import { Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef, Inject, NgZone } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { environment } from 'src/environments/environment';
import { CONST_AWS_API, API, COUNTRIES_LIST } from '../../../../../core/constants'
import { API as AWS_API } from 'aws-amplify';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AppPaymentTVService } from 'src/app/core/services/app-payment-tv.service';
import * as moment from 'moment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ValidationService } from 'src/app/core/services/validation.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { AppService } from '../../../../../core/services/app.service';
import { EventTermsConditionsComponent } from '../event-terms-conditions/event-terms-conditions.component';
import { PaymentService } from 'src/app/core/services/payment.service';
import { ConsumerSignInComponent } from '../../../landing-pages/consumer/consumer-sign-in/consumer-sign-in.component';
import { UserService } from 'src/app/core/services/user.service';
import { SearchCountryField, CountryISO } from 'ngx-intl-tel-input-gg';
import { fromEvent, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
const EMAIL_REGEX = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
declare let $: any;
declare let window: any;
declare var fbq: any;

@Component({
  selector: 'app-event-tickets',
  templateUrl: './event-tickets.component.html',
  styleUrls: ['./event-tickets.component.scss']
})
export class EventTicketsComponent implements OnInit {
  showSubmenu: boolean = false;
  userInfo: any = {};
  userInfoSubscription: Subscription;
  streamInfo: any = {};
  billingForm: FormGroup;
  shippingForm: FormGroup;
  showCCForm = false;
  address: string;
  pastedText: any;
  card: any;
  cardError: string;
  validStripeForm = false;
  redirectUrl = '';
  invoice_id: any;
  taxAmount = 0;
  taxable: boolean = true;
  currentLocation: any;
  loadCss = `${environment.CONSUMER_PORTAL}assets/custom-css/paystand.css`;
  psKey: any;
  cardId: any;
  incl: any;
  codes: any = {};
  paymentData: any;
  reopen: boolean;
  paymentSuccess: boolean = false;
  streamId: any;
  paymentType = "pay_per_view";
  currency: any;
  finalAmount: any;
  // totalAmount: any;
  charityInfo: any = {};
  performerInfo: any = {};
  taxPercentage = 0;
  getPaymentDetailToken = "";
  isPaymentSuccess = false;
  ccForm: FormGroup;
  @ViewChild('cardInfo', { static: false }) cardInfo: ElementRef;
  amount: any;
  priceChangeDate: string;
  currectDatesAmounts = [];
  USDAmount: any = [];
  GBPAmount: any = [];
  currencyType: string;
  profileInfoForm: FormGroup;
  contactInfoForm: FormGroup;
  streamData: any;
  isEdit: boolean = false;
  getAmount: any;
  displayAmounts: any;
  isAgrees = false;
  isStateOptional: boolean;
  countriesList = COUNTRIES_LIST;
  billingCountry: any = {};
  shippingCountry: any = {};
  options: {};
  countryChanged: boolean = true;
  inputData: { amount: any; finalAmount: any; currency: any; organization_id: any; performer_id: string; stream_id: string; paymentType: string; payment_type: string; response: any; transaction_id: string; name: any; gateway: any; };
  hasUserInfo: boolean = false;
  questionsForm: any;
  // @ViewChild('f', { static: false }) form: any;
  selectedQuestionsData: any = [];
  showShippingForm: boolean = false;
  getCurrency: any;
  getCurrencytype: any;
  userSubscriptionInfo: any;
  subEvents: any;
  codeInfo: any = {};
  expoInfo: any;
  isBookingFrom = "web";
  isMobilePaymentSuccess = false;
  ticketKey: any;
  streamUrl: any;
  scheduleUrl: any;
  mobileUrl: string;
  deviceData: string;
  priceDetails: any;
  settingsJSON: any;
  processingFee: number = 0;
  refCodeMatched: boolean = false;
  expoUrl: string;
  networkUrl: string;
  homeUrl: string;
  currencyInfoSubscription: Subscription;
  separateDialCode = true;
  SearchCountryField = SearchCountryField;
  CountryISO = CountryISO;
  preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  selectedCountry: any = "US";
  psSrc: string;
  enablePaystand = false;
  vodUrl: any;
  timezoneVal: any;
  isMobile: boolean = false;
  backRedirectionUrl: any;
  selectedCard: any = {};
  selectedCardInfoSubscr: Subscription;
  showBillingForm: boolean = false;
  addressList: any = [];
  addressListInfoSubscr: Subscription;
  savedCardsListSubscr: Subscription;
  savedCardsList: any = [];
  newShippingForm: boolean = false;
  addNewCard: boolean = false;
  selectedShippingAddress: any = {};
  selectedBillingAddress: any = {};
  shippingCodes: any;
  currentTheme: any;
  transactionInfoSubscr: Subscription;
  transactionInfo: any;
  selectedTransaction: any;
  billingAddress: any;
  currentBlock: any;
  amt_without_pf = 0;
  crypto_amount : any;
  totalAmount : any;
  currency_for_totAmt : number;
  USD_Rates : any;
  sliced_crypto_amount : any;
  clientDetails : any;
  cryptoToken : any;
  cryptoSymbol : any;
  deviceInfo:any
  private unsubscriber: Subject<void> = new Subject<void>();
  nftTicketSelected: boolean = false;
  nftTicketTotalPrice: number;
  network_name: string;
  walletId: any;
  settingsDataSubscription: Subscription;
  settingsData: any = {};
  organizationId: any;
  performerInfoSubscription!: Subscription;

  constructor(private router: Router, private location: Location,
    private loader: NgxUiLoaderService,
    private commonSubscribeService: CommanSubscribeService,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private toastr: ToastrService,
    private cd: ChangeDetectorRef,
    private appPaymentService: AppPaymentTVService,
    public dialog: MatDialog,
    private storageService: StorageService,
    private appService: AppService,
    private paymentService: PaymentService,
    private zone: NgZone,
    private userService: UserService) { }

  get businessPhoneValue() {
    return this.shippingForm.controls['phone_number'];
  }

  showOverlay: boolean = false;
  timer = 120;
  toggleLoader(state) {
    if (state != 'none') {
      this.showOverlay = true;
      var counter = 120;
      var interval = setInterval(() => {
        counter--;
        if (counter <= 0) {
          clearInterval(interval);
          return;
        } else {
          this.timer = counter;
        }
      }, 1000);
    }
    // var overlay = document.getElementsByClassName('ngx-overlay');
    // overlay[0]['style'].display = state;
    if (state == 'none') {
      this.loader.stop();
    }
  }
  getAwsData(body) {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: body
    };
    this.loader.start();
    return data;
  }
  processStreamInfo(streamInfo) {
    try {
      if (streamInfo.age_limit <= 15) {
        streamInfo.ageInfo = 'Family Friendly';
      } else if (streamInfo.age_limit == 16 || streamInfo.age_limit <= 17) {
        streamInfo.ageInfo = 'Adults Supervision';
      } else if (streamInfo.age_limit == 18 || streamInfo.age_limit <= 20) {
        streamInfo.ageInfo = '18+';
      } else if (streamInfo.age_limit == 21 || streamInfo.age_limit > 21) {
        streamInfo.ageInfo = '21+';
      }

      if (streamInfo) {
        let name = streamInfo.stream_video_title ? streamInfo.stream_video_title.split(' ') : "";
        if (name) {
          let secondName = name[1] ? name[1].charAt(0) : name[0].charAt(1);
          streamInfo.displayTitleName = name[0].charAt(0) + secondName;
        }
      }
      return streamInfo;
    } catch (e) {
      console.log(e);
      return streamInfo;
    }
  }

  fee = 0; id: any; userId: any; paramsTicketKey: any;
  datesList: any = [];
  exchange_rate: any;
  background_image: any = "";
  eventStartDate: any
  eventEndDate: any;
  addOnData: any = [];
  isAnalyticsData: boolean = false;
  proceedBtn: boolean = false;
  liveTickets: any = [];
  nftTickets: any = [];
  virtualTickets: any = [];
  ticketType: String = 'virtual';
  shippingCountriesList = COUNTRIES_LIST;
  shippingList = [];
  shippingCost: number = 0;
  shippingChrg: number = 0;
  // Raw, never-converted shipping charge for the fan's destination country (see line ~383).
  // getCurrencyRates() must always convert from this base, never from shippingCost/shippingChrg
  // themselves — it can run twice per currency change (via getEventDetails()'s callback and the
  // currencyInfoSubscription handler), and converting an already-converted value compounded the
  // FX markup (e.g. a $3 charge inflating to ~$290 against INR).
  shippingCostBase: number = 0;
  getStreamInfo(callback) {
    this.streamInfo = this.commonSubscribeService.streamInfo;
    let locInfo = this.commonSubscribeService.locationInfo;
    this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
    this.id = typeof (this.userInfo.id) == 'string' ? this.userInfo.id : JSON.stringify(this.userInfo.id);
    this.paramsTicketKey = this.route.snapshot.params.ticket_key;
    if (this.paramsTicketKey) {
      let keys = this.paramsTicketKey.split('-');
      this.userId = keys[1];
    }
    if (!this.streamInfo || !this.streamInfo.displayAmounts) {
      this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
        if (val == "fail") {
          this.currentLocation = this.currentLocation ? this.currentLocation : {};
        } else {
          this.currentLocation = json && Object.keys(json).length > 0 ? json : this.currentLocation;
        }
        this.getCurrencytype = this.getCurrency ? this.getCurrency : this.currentLocation && this.currentLocation.currency && this.currentLocation.currency.code;
        let code = this.currentLocation && this.currentLocation.currency ? this.currentLocation.currency.code : '';
        let currentCode = code.includes('\"') ? JSON.parse(code) : code;
        let localCurrency = this.getCurrency && this.getCurrency.includes('\"') ? JSON.parse(this.getCurrency) : this.getCurrency
        let data = {
          headers: {
            "Content-Type": "application/json",
            "x-api-key": environment.AWS_Cognito.X_Api_Key,
            "Authorization": `Bearer ${this.userInfo.access_token}`,
          },
          response: true,
          body: {
            "slug": this.route.snapshot.params.slug_name,
            "userid": this.id ? this.id : this.userId,
            "offset": new Date().getTimezoneOffset(),
            "currency": localCurrency ? localCurrency : currentCode,
            "timezone": this.timezoneVal
          }
        }
        this.loader.start();
        AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_EVENT_BY_SLUG, data).then(response => {
          this.loader.stop();
          this.checkIsUserSubscribe(response.data.Data.stream_info, (IsUserSubscribe: any) => {
            this.commonSubscribeService.sendSlugData(response['data']['Data']);
            this.streamInfo = response.data.Data.stream_info;
            this.exchange_rate = response.data.Data.rate;

            if (this.streamInfo.media_files) {
              let media_files = JSON.parse(this.streamInfo.media_files);
              Object.keys(media_files).forEach(element => {
                this.streamInfo[element] = media_files[element];
              });
            }

            if (this.streamInfo && this.streamInfo.ticket_home_banner) {
              this.background_image = this.streamInfo.ticket_home_banner;
            } else {
              this.background_image = this.streamInfo.video_banner_image;
            }

            if (this.streamInfo.media_files) {
              let media_files = JSON.parse(this.streamInfo.media_files);
              this.streamInfo.event_home_banner = media_files.event_home_banner;
            }
            let device = this.commonSubscribeService.getMobileOperatingSystem();
            // if (device == 'android' || device == 'ios')
            //   this.background_image = this.streamInfo.event_home_banner;

            if (this.streamInfo.selected_type == "single_session_event") {
              // let localTime = moment.utc(this.streamInfo.publish_date_time).toDate();
              // let startTime = moment(localTime).format('DD MMM YYYY');
              // element.stream_info.startTime = moment(localTime).format('hh:mm A');
              // let endTime = moment.utc(this.streamInfo.expected_end_date_time).toDate();
              // let eventEndTIme = moment(endTime).format('DD MMM YYYY');
              // element.stream_info.endTime = moment(endTime).format('hh:mm A');
              let localTime = moment.utc(this.streamInfo.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
              let startTime = localTime.format('DD MMM YYYY');
              let endTime = moment.utc(this.streamInfo.expected_end_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
              let eventEndTIme = endTime.format('DD MMM YYYY');
              if (moment(eventEndTIme).isAfter(startTime)) {
                this.streamInfo.eventStart = localTime.format('DD MMM YYYY, hh:mm A');
                this.streamInfo.eventEnd = endTime.format('DD MMM YYYY, hh:mm A');
                // this.streamInfo.eventStart = moment(localTime).format('DD MMM YYYY, hh:mm A');
                // this.streamInfo.eventEnd = moment(endTime).format('DD MMM YYYY, hh:mm A');
              } else {
                this.streamInfo.eventStart = localTime.format('ddd') + ", " + localTime.format('DD MMM YYYY, hh:mm A');
                this.streamInfo.eventEnd = endTime.format('hh:mm A');
                // this.streamInfo.eventStart = moment(localTime).format('ddd') + ", " + moment(localTime).format('DD MMM YYYY, hh:mm A');
                // this.streamInfo.eventEnd = moment(endTime).format('hh:mm A');
              }
              // let localTime = moment.utc(this.streamInfo.publish_date_time).toDate();
              // this.streamInfo.eventStart = moment(localTime).format('ddd') + ", " + moment(localTime).format('DD MMM YYYY, hh:mm A');
              // let endDate = moment.utc(this.streamInfo.expected_end_date_time).toDate();
              // this.streamInfo.eventEnd = moment(endDate).format('hh:mm A');
            }
            this.streamInfo.originalPublishDate = this.streamInfo.publish_date_time;
            this.streamInfo.originalExpectedDate = this.streamInfo.expected_end_date_time;
            // publish_date_time/expected_end_date_time are bare UTC "YYYY-MM-DD HH:mm:ss" (no
            // timezone marker) - parse via moment.utc(...).tz(...) like the rest of this file
            // (see the "single_session_event" block above) instead of formatting the raw value,
            // which showed the wrong calendar date to viewers on the other side of UTC. This
            // shared streamInfo object is also read by other components, so keep it consistent.
            let publishLocalForBanner = moment.utc(this.streamInfo.originalPublishDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
            let expectedEndLocalForBanner = moment.utc(this.streamInfo.originalExpectedDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
            this.streamInfo.publish_date_time = publishLocalForBanner.format("ddd") + ", " + publishLocalForBanner.format("DD MMM") + " " + publishLocalForBanner.format("YYYY");
            this.streamInfo.expected_end_date_time = expectedEndLocalForBanner.format("ddd") + ", " + expectedEndLocalForBanner.format("DD MMM") + " " + expectedEndLocalForBanner.format("YYYY");
            // if (this.streamInfo.event_dates_json) {
            //   this.streamInfo.event_dates_json = JSON.parse(this.streamInfo.event_dates_json);
            // this.datesList = [...this.streamInfo.event_dates_json];
            this.priceDetails = response['data']['Data']['price_details'];
            this.settingsJSON = JSON.parse(this.streamInfo.settings_json);
            let myList = [];
            this.countriesList.forEach(c => {
              if (this.settingsJSON && this.settingsJSON.country_wise_shipping) {
                this.settingsJSON.country_wise_shipping.forEach(e => {
                  if (e.country_name == c.alpha2code) {
                    // if (c.alpha2code == this.currentLocation.country_code2) {
                    myList.push(c);
                  }
                })
              }
            });
            this.shippingList = this.shippingCountriesList = myList;
            let isAvl = false;
            if (this.settingsJSON && this.settingsJSON.country_wise_shipping) {
              this.settingsJSON.country_wise_shipping.forEach(e => {
                if (e.country_name == this.currentLocation.country_code2 && !isAvl) {
                  this.shippingChrg = this.shippingCost = this.shippingCostBase = Number(e.shipping_cost);
                  isAvl = true;
                }
              })
            }
            let affiliatesList = response['data']['Data']['affiliates'];
            if (affiliatesList && affiliatesList.length > 0) {
              affiliatesList.forEach(element => {
                if (element.referral_code == this.route.snapshot.queryParams.ref)
                  this.refCodeMatched = true;
              });
            }
            this.getCurrencyRates();
            // this.getExpoList();
            // this.getNetworkRoomsList();
            if (IsUserSubscribe && response.data.Data.stream_info && response.data.Data.stream_info.stream_amounts) {
              let stream_amounts = JSON.parse(response.data.Data.stream_info.stream_amounts);
              stream_amounts.live_stream = stream_amounts.sub_live_stream;
              stream_amounts.vod = stream_amounts.sub_vod;
              if (stream_amounts.subscriberPayment == "free") {
                response.data.Data.stream_info.stream_payment_mode = 'free';
              }

              let eventType = response.data.Data.stream_info.stream_vod == "stream" ? "stream" : "vod";
              if (eventType == "stream" && response.data.Data.stream_info.stream_status == "completed") {
                eventType = "vod";
              }
              if (eventType == 'vod' && !stream_amounts.enable_vod_setup) {
                response.data.Data.stream_info.stream_payment_mode = 'free';
              }
              response.data.Data.stream_info.stream_amounts = JSON.stringify(stream_amounts);
            }
            this.ticketsData = response['data']['Data']['tickets'];
            this.ticketsData = this.ticketsData.filter(ticket => ticket.isDeleted !== 1);

            if (this.vodUrl) {
              this.ticketsData = this.ticketsData.filter(a => a.ticket_type == 'paid');
            }
            this.virtualTickets = this.ticketsData.filter(a => !a.live && !a.add_ons && !a.token_id);
            this.liveTickets = this.ticketsData.filter(a => a.live && !a.add_ons && !a.token_id);
            this.nftTickets = this.ticketsData.filter(a => a.token_id);
            this.ticketType = this.virtualTickets.length > 0 ? 'virtual' : this.liveTickets.length > 0 ? 'live' : this.nftTickets.length > 0 ? 'nft' : 'add-on';
            this.ticketsData.forEach(element => {
              if (element.add_ons)
                element.add_ons = typeof element.add_ons == 'string' ? JSON.parse(element.add_ons) : element.add_ons;
              if(element.token_id){
                element.nftTicketFiatPrice =((Number(element.nft_details.salePrice) /environment.ONE_USD) * this.USD_Rates[element.currency]) 
              }
            });
            this.addOnData = [];
            let getAddonsData = this.ticketsData.filter(a => a.add_ons);
            if (getAddonsData.length > 0) {
              getAddonsData.forEach(element => {
                element.add_ons = typeof element.add_ons == 'string' ? JSON.parse(element.add_ons) : element.add_ons;
                this.addOnData.push(element);
              });
              this.imageScroll();
              this.proceedBtn = true;
            }
            // else{
            //   this.dispAddons = true;
            // }
            setTimeout(() => {
              this.loadAdsScript()
            }, 1000);
            this.isAnalyticsData = this.addOnData.length == this.ticketsData.length ? true : false
            this.subEvents = response['data']['Data']['subEvents'];
            let datesArr = [];
            if (this.subEvents.length > 0) {
              this.subEvents.forEach(event => {
                // let eventDate = moment.utc(event.stream_info.publish_date_time).toDate();
                // event.start = moment(eventDate).format('YYYY-MM-DD');
                // let eventEnd = moment.utc(event.stream_info.expected_end_date_time).toDate();
                // event.end = moment(eventEnd).format('YYYY-MM-DD');
                let localTime = moment.utc(event.stream_info.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
                event.start = localTime.format('YYYY-MM-DD');
                let eventEnd = moment.utc(event.stream_info.expected_end_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
                event.end = eventEnd.format('YYYY-MM-DD');
                datesArr.push(event);
                datesArr.push(event);
              });
            }
            this.datesList = [...new Map(datesArr.map(item =>
              [item['start'], item])).values()];
            this.datesList = this.datesList.sort((a, b) => a.start > b.start ? 1 : -1);
            if (this.datesList && this.datesList.length > 0) {
              this.datesList.forEach((date, key) => {
                date.originalDate = date.start;
                // date.start = moment(date.start).format("ddd") + ", " + moment(date.start).format("DD MMM") + " " + moment(date.start).format("YYYY");
                date.start = moment(date.start).format("DD MMM") + " " + moment(date.start).format("YYYY");
                if (this.streamInfo.selected_type == 'single_day_event' || this.streamInfo.selected_type == 'multi_day_event') {
                  if (key == 0)
                    this.eventStartDate = moment(date.originalDate).format("ddd") + ", " + moment(date.originalDate).format("DD MMM") + " " + moment(date.originalDate).format("YYYY");
                  this.eventEndDate = moment(date.end).format("ddd") + ", " + moment(date.end).format("DD MMM") + " " + moment(date.end).format("YYYY");
                }
                // if(this.datesList.length >2)
                // date.start = this.datesList.length
              });
            }
            // }

            this.commonSubscribeService.sendSubEventsInfo(this.subEvents);
            this.userSubscriptionInfo = response['data']['Data']['user_subscription_info'];
            if (this.ticketsData) {
              let isFree = [];
              isFree = this.ticketsData.filter(a => a.ticket_type == 'free');
              if (isFree.length == this.ticketsData.length)
                this.streamInfo.stream_payment_mode = 'free';
              this.ticketsData.forEach(element => {
                element.selectedOption = 0;
                if (this.userSubscriptionInfo && this.userSubscriptionInfo[0]) {
                  if (this.userSubscriptionInfo[0].ticketIDs.includes(element.id))
                    element.isBooked = "Ticket already purchased";
                }
                if (this.streamInfo.booking_fee != 0) {
                  this.fee = (this.streamInfo.booking_fee) / 100;
                  element.price_bf = Number(this.fee * element.price);
                  element.price_bf = element.price_bf.toFixed(2);
                  // element.price_bf = (element.price * this.streamInfo.booking_fee)/100;
                }
                element.start_date = moment(element.start_date).format("DD MMM YYYY");
                element.end_date = moment(element.end_date).format("DD MMM YYYY");
                // element.isTicketSelected = true;
                if (element.amounts) {
                  element.amounts = typeof element.amounts == 'string' ? JSON.parse(element.amounts) : element.amounts;
                }
                element.sessionsName = [];
                if (element.sessions && element.sessions.length > 0) {
                  element.sessions.forEach(e => {
                    if (e == element.event_id)
                      element.allSessions = true;
                    if (this.userSubscriptionInfo && this.userSubscriptionInfo[0]) {
                      if (this.userSubscriptionInfo[0].ticket_ids.indexOf(e) != -1)
                        element.disableTicket = true;
                      else
                        element.disableTicket = false;
                      // this.userSubscriptionInfo[0].ticket_ids.forEach(ticketId => {
                      //   ticketId.indexOf()
                      //   if (ticketId == e) {
                      //     element.disableTicket = true;
                      //   }
                      // });
                    }
                    let data = this.subEvents.filter(a => (a.streamid == e) || (a.parent_streams_id == e));
                    if (data.length > 0) {
                      data = data.sort((a, b) => a.stream_info.publish_date_time > b.stream_info.publish_date_time ? 1 : -1);
                      data.forEach(event => {
                        // let localTime = moment.utc(event.stream_info.publish_date_time).toDate();
                        // let stageStart = moment(localTime).format('DD MMM YYYY, hh:mm A');
                        // let endDate = moment.utc(event.stream_info.expected_end_date_time).toDate();
                        // let endTime = moment(endDate).format('hh:mm A');
                        let stageStart, endTime;
                        // let localTime = moment.utc(event.stream_info.publish_date_time).toDate();
                        // let startTime = moment(localTime).format('DD MMM YYYY');
                        // let endTimeDur = moment.utc(event.stream_info.expected_end_date_time).toDate();
                        // let eventEndTime = moment(endTimeDur).format('DD MMM YYYY');
                        let localTime = moment.utc(event.stream_info.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
                        let startTime = localTime.format('DD MMM YYYY');
                        let endTimeDur = moment.utc(event.stream_info.expected_end_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
                        let eventEndTime = endTimeDur.format('DD MMM YYYY');
                        if (moment(eventEndTime).isAfter(startTime)) {
                          if (moment(eventEndTime).isAfter(startTime, 'year')) {
                            stageStart = localTime.format('DD MMM YYYY, hh:mm A');
                            endTime = endTimeDur.format('DD MMM YYYY, hh:mm A');
                          } else {
                            stageStart = localTime.format('DD MMM, hh:mm A');
                            endTime = endTimeDur.format('DD MMM, hh:mm A');
                          }
                        } else {
                          stageStart = localTime.format('MMMM DD') + ' - ' + localTime.format('hh:mm A');
                          endTime = endTimeDur.format('hh:mm A');
                        }
                        // let stageDate = stageStart + ' - ' + endTime;
                        let stageDate = stageStart;
                        element.sessionsName.push({
                          stage: event.stream_info.stage,
                          date: stageDate
                        });
                      });
                    }
                  });
                } else {
                  // if (element.sessions)
                  //   element.allSessions = true;
                  if (this.userSubscriptionInfo && this.userSubscriptionInfo[0]) {
                    if (this.userSubscriptionInfo[0].ticket_ids.indexOf(element.event_id) != -1)
                      element.disableTicket = true;
                    else
                      element.disableTicket = false;
                    // this.userSubscriptionInfo[0].ticket_ids.forEach(ticketId => {
                    //   if (ticketId == element.event_id)
                    //     element.disableTicket = true;
                    // });
                  }
                }
              });
              // if (response.data.Data.stream_info.stream_payment_mode == 'paid') {
              //   // this.streamInfo.stream_amounts = tempTicketType;
              //   let result = this.commonSubscribeService.getAmount(response.data.Data.stream_info, this.currentLocation, this.IsUserSubscribe, this.ticketsData);
              //   // if (result && result.current) {
              //   //   this.amount = result.current.price;
              //   //   this.currencyType = result.current.currency;
              //   //   this.priceChangeDate = result.priceChangeDate;
              //   // } else {
              //   //   let message = result.message || 'Something went wrong';
              //   //   this.toastr.error(message);
              //   // }
              //   if (result && result.currectDatesAmounts && result.currectDatesAmounts.length > 0) {
              //     this.currectDatesAmounts = result.currectDatesAmounts;
              //   } else {
              //     let message = result.message || 'Something went wrong';
              //     this.toastr.error(message);
              //   }
              // } else {
              //   this.isSelectedTicket = true;
              // }
            }
            callback(this.processStreamInfo(response.data.Data.stream_info));
          });
        }).catch(error => {
          this.loader.stop();
        });
      });
    } else {
      this.IsUserSubscribe = this.streamInfo.IsUserSubscribe;
      callback(this.streamInfo);
    }
  }
  // isShown:boolean = false;
  // openDesc(){
  //   this.isShown = !this.isShown;
  // }

  rates: any;
  curExchangeRate: any;
  getCurrencyRates() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_EXCHANGE_RATES + '/' + this.streamInfo?.currency_type;
    this.loader.start();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        this.loader.stop();
        this.rates = response['data']['Data']['rates'];
        this.curExchangeRate = this.rates[this.getCurrency];
        // Always convert from shippingCostBase (the raw, un-converted charge), never from
        // shippingCost/shippingChrg themselves — this method can run twice per currency change
        // (via getEventDetails()'s callback and the currencyInfoSubscription handler), and
        // converting an already-converted value compounded the FX markup on repeated calls.
        if (this.curExchangeRate != 1) {
          this.shippingCost = this.shippingChrg = Number((this.shippingCostBase * this.curExchangeRate * 1.025).toFixed(2));
        } else {
          this.shippingCost = this.shippingChrg = this.shippingCostBase;
        }
      }
    }).catch(error => {
      this.loader.stop();
    });
  }

  dispAddons: boolean = false;
  showAddons() {
    if(this.ticketType == 'nft'){
      return
    }
    if (this.ticketType == 'virtual' && this.liveTickets.length > 0) {
      this.ticketType = 'live';
      this.imageScroll();
      return;
    }
    this.dispAddons = !this.dispAddons;
    this.ticketType = 'add-on';
    this.imageScroll();
  }


  changeTicketType(type) {
    this.ticketType = type;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Event Type ${type}-clicked - ${userId}`)
    const data = {
      actionType: "event",
      metaData: {
        title: `Event Type ${type} - clicked`,
        eventId: this.streamInfo?.id || null,
        eventName: this.streamInfo?.stream_video_title || null,
        ticketType: type,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo.organization_id || null,
      clickAction:'event-type',
      networkGroupId : this.streamInfo.network_group_id || null,
    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    if (type == 'live' || type == 'virtual' || type == 'nft') {
      this.dispAddons = false;
    } else {
      this.dispAddons = true;
    }
    var myDiv = document.getElementById('containerDiv');
    myDiv.scrollTop = 0;
    var addOn = document.getElementById('addon-Container');
    setTimeout(() => {
      addOn.scrollLeft = 0;
    }, 10);
  }

  toggleStageInfo(ticket) {
    this.ticketsData.forEach(element => {
      if (element.id == ticket.id && !element.showStageInfo)
        element.showStageInfo = true;
      else
        element.showStageInfo = false;
    });
    // this.showDescription = !this.showDescription
  }

  IsUserSubscribe = false;
  checkIsUserSubscribe(streamData, callback: (val: any) => void) {

    if (!this.userInfo || Object.keys(this.userInfo)?.length == 0) {
      callback(false);
    } else {

      let reqData = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`
        },
        response: true,
        body: {
          user_id: this.userInfo.id,
          channel_url: streamData.channel_name
        }
      }
      AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_SUBSCRIPTION_STATUS, reqData).then(response => {
        if (response.data.message === "Success") {
          if (response.data && response.data.Data && response.data.Data.length > 0) {
            if (response.data.Data[0].subscription_status == 0) {
              if (new Date().getTime() < new Date(response.data.Data[0].subscription_end_date).getTime()) {
                this.IsUserSubscribe = true;
              } else {
                this.IsUserSubscribe = false;
              }
            } else {
              this.IsUserSubscribe = true;
            }
          } else {
            this.IsUserSubscribe = false;
          }
          callback(this.IsUserSubscribe);
        } else {
          this.IsUserSubscribe = false;
          callback(this.IsUserSubscribe);
        }
      }).catch(error => {
        this.loader.stop();
        // callback("fail");
        callback(false);
      });
    }
  }

  getUserInfo(user_id, callback) {
    if (user_id) {
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`,
        },
        response: true,
        body: {
          "user_id": user_id,
          "organization_id": this.organizationId
        }
      }
      this.loader.start();
      AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER_BY_ID, data).then(response => {
        this.loader.stop();
        if (response.data.user) {
          response.data.user.access_token = response.data.user.session_token;
          this.userInfo = this.commonSubscribeService.userInfo = response.data.user;
          this.commonSubscribeService.sendUserInfo(this.userInfo);
          this.isBookingFrom = "mobile";
        }
        callback();
      }).catch(error => {
        this.loader.stop();
        this.toastr.error('Unable to get user details');
      });
    } else {
      callback();
    }
  }

  getParam(param) {
    try {
      let url = decodeURIComponent(location.href).split("?");
      if (url[1]) {
        let queryParams = url[1].split("&");
        let params = {};
        if (queryParams && queryParams.length > 0) {
          queryParams.forEach(p => {
            let p1 = p.split("=");
            params[p1[0]] = p1[1];
          });
        }
        return params[param];
      } else {
        return "";
      }
    } catch (e) {
      console.log(e);
      return this.route.snapshot.queryParamMap.get(param);
    }
  }
  scrollleftdiv() {
    (function HorizontalScrolling() {
      function wheelHandler(element, event) {
        const toLeft = event.deltaY < 0 && element.scrollLeft > 0
        const toRight = event.deltaY > 0 && element.scrollLeft < element.scrollWidth - element.clientWidth

        if (toLeft || toRight) {
          event.preventDefault()
          event.stopPropagation()

          element.scrollBy({ left: event.deltaY })
        }
      }


      const targets = document.querySelectorAll('#scroll-divs')

      targets.forEach(element => element.addEventListener('wheel', event => wheelHandler(element, event)))
    })()
  }
  togglequantity: boolean = false;
  showquantity() {
    this.togglequantity = !this.togglequantity;
  }
  isAddOnTickets: any = [];
  paidAddOnTickets: any = [];
  totalAddOnAmount = 0;
  updateTicketsData() {
    if (this.ticketsData) {
      let isFree = [];
      isFree = this.ticketsData.filter(a => a.ticket_type == 'free');
      if (isFree.length == this.ticketsData.length)
        this.streamInfo.stream_payment_mode = 'free';
      this.addOnData = [];
      let getAddonsData = this.ticketsData.filter(a => a.add_ons);
      if (getAddonsData.length > 0) {
        getAddonsData.forEach(element => {
          // element.add_ons = typeof element.add_ons == 'string' ? JSON.parse(element.add_ons): element.add_ons;
          this.addOnData.push(element);
        });
      }
      this.imageScroll();
      this.isAnalyticsData = this.addOnData.length == this.ticketsData.length ? true : false;
      this.ticketsData.forEach(element => {
        if (element.add_ons)
          element.add_ons = typeof element.add_ons == 'string' ? JSON.parse(element.add_ons) : element.add_ons;
        element.selectedOption = 0;
        if (this.userSubscriptionInfo && this.userSubscriptionInfo[0]) {
          if (this.userSubscriptionInfo[0].ticketIDs.includes(element.id))
            element.isBooked = "Ticket already purchased";
        }
        if (this.streamInfo.booking_fee) {
          this.fee = (this.streamInfo.booking_fee) / 100;
          element.price_bf = Number(this.fee * element.price);
          element.price_bf = element.price_bf.toFixed(2);
          // element.price_bf = (element.price * this.streamInfo.booking_fee)/100;
        }
        element.start_date = moment(element.start_date).format("DD MMM YYYY");
        element.end_date = moment(element.end_date).format("DD MMM YYYY");
        // element.isTicketSelected = true;
        if (element.amounts) {
          element.amounts = typeof element.amounts == 'string' ? JSON.parse(element.amounts) : element.amounts;
        }
        element.sessionsName = [];
        if (element.sessions && element.sessions.length > 0) {
          element.sessions.forEach(e => {
            if (e == element.event_id)
              element.allSessions = true;
            if (this.userSubscriptionInfo && this.userSubscriptionInfo[0]) {
              if (this.userSubscriptionInfo[0].ticket_ids.indexOf(e) != -1)
                element.disableTicket = true;
              else
                element.disableTicket = false;
              // this.userSubscriptionInfo[0].ticket_ids.forEach(ticketId => {
              //   ticketId.indexOf()
              //   if (ticketId == e) {
              //     element.disableTicket = true;
              //   }
              // });
            }
            let data = this.subEvents.filter(a => (a.streamid == e) || (a.parent_streams_id == e));
            if (data.length > 0) {
              data.forEach(event => {
                // let localTime = moment.utc(event.stream_info.publish_date_time).toDate();
                // let stageStart = moment(localTime).format('DD MMM YYYY, hh:mm A');
                // let endDate = moment.utc(event.stream_info.expected_end_date_time).toDate();
                // let endTime = moment(endDate).format('hh:mm A');
                let localTime = moment.utc(event.stream_info.publish_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
                let stageStart = localTime.format('DD MMM YYYY');
                let endDate = moment.utc(event.stream_info.expected_end_date_time, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal);
                let endTime = endDate.format('DD MMM YYYY');
                let stageDate = stageStart + ' - ' + endTime
                element.sessionsName.push({
                  stage: event.stream_info.stage,
                  date: stageDate
                });
              });
            }
          });
        } else {
          // if (element.sessions)
          //   element.allSessions = true;
          if (this.userSubscriptionInfo && this.userSubscriptionInfo[0]) {
            if (this.userSubscriptionInfo[0].ticket_ids.indexOf(element.event_id) != -1)
              element.disableTicket = true;
            else
              element.disableTicket = false;
            // this.userSubscriptionInfo[0].ticket_ids.forEach(ticketId => {
            //   if (ticketId == element.event_id)
            //     element.disableTicket = true;
            // });
          }
        }
      });

      setTimeout(() => {
        this.loadAdsScript()
      }, 1000);

      if (this.selectedTicketsData.length > 0) {
        this.ticketsData.forEach(element => {
          this.selectedTicketsData.forEach(e => {
            if (element.id == e.id) {
              element.selectedOption = e.selectedOption;
              if (e.selectedOption)
                element.showQty = true;
              e.currency = element.currency;
              if (this.isSelectedTicket && this.contactInfoForm.valid)
                e.price = this.contactInfoForm.valid ? element.price * element.selectedOption : element.ptice;
              this.currency = element.currency;
            }
          });
        });
        if (this.selectedTicketsData.length > 0) {
          this.bookingFee = 0; this.amount = 0; this.amountWithBF = 0; this.withoutAddOn = 0; this.totalAddOnAmount = 0;
          let isFree = [];
          isFree = this.selectedTicketsData.filter(a => a.ticket_type == 'free');
          if (isFree.length == this.selectedTicketsData.length) {
            this.bookingFee = 0;
            this.streamInfo.stream_payment_mode = 'free';
            this.amount = 0;
          } else {
            this.streamInfo.stream_payment_mode = 'paid';
            this.selectedTicketsData.forEach(ticket => {
              this.ticketsData.forEach(element => {
                if (ticket.id == element.id) {
                  this.amount += element.price * element.selectedOption;
                  if (!ticket.add_ons) {
                    this.withoutAddOn += element.price * element.selectedOption;
                    this.withoutAddOn = Number(this.withoutAddOn.toFixed(2));
                  }
                }
              });
              this.amount = Number(this.amount.toFixed(2));
              this.streamData.amount = this.amount;
            });
            // this.totalAddOnAmount = this.amount - this.withoutAddOn;
            this.streamData.amount = this.amount = Number(this.amount.toFixed(2));
            this.isAddOnTickets = this.selectedTicketsData.filter(a => a.add_ons);
            if (this.isAddOnTickets.length > 0)
              this.paidAddOnTickets = this.isAddOnTickets.filter(a => a.ticket_type == 'paid');
            if (this.streamInfo.booking_fee != 0 && isFree.length != this.selectedTicketsData.length) {
              this.bookingFee = this.fee * this.withoutAddOn;
              this.bookingFee = Number(this.bookingFee.toFixed(2));
            }
            this.amountWithBF = this.selectedTicketsData.length != this.isAddOnTickets.length ? Number((this.amount + this.bookingFee).toFixed(2)) : Number((this.amount).toFixed(2));
          }
        }
      }
    }
  }

  ngOnInit() {
    // setTimeout(() => {
    //   this.loadAdsScript();
    // }, 1000);
    this.route.queryParams.subscribe(params => {
      if (params['code']) {
        this.promoCode = params['code'];
      }
    });
    this.organizationId = this.commonSubscribeService.perfomerInfoData?.data?.Data?.[0]?.organization_id;
    this.performerInfoSubscription = this.commonSubscribeService.getPerfomerInfo().subscribe(response => {
      this.organizationId = response?.data?.Data?.[0]?.organization_id;
    });

    this.network_name = environment.clientDetails.network_name
    let device = this.commonSubscribeService.getMobileOperatingSystem();
    this.deviceInfo = device;
    let ticketStatus=localStorage.getItem('ticketKey')
    if(ticketStatus){
    }
    this.clientDetails = environment.clientDetails;
    this.cryptoToken = this.clientDetails.crypto_token;
    this.cryptoSymbol = this.clientDetails.crypto_symbol;
    this.currentBlock = "Tickets";
    this.currentTheme = this.commonSubscribeService.getThemeColors();
    this.commonSubscribeService.getCurrencyRates("USD",result=>{
      this.USD_Rates = result;
    });
   
    this.totalAmount = this.commonSubscribeService.getTotalAmount().subscribe(response => {
      // this.currency_for_totAmt = response.currency;
      // this.amt_without_pf = response.amt_without_pf;
      this.crypto_amount = this.commonSubscribeService.convertToCryptoAmount(response.amt_without_pf,this.USD_Rates[response.currency])
      this.sliced_crypto_amount = Math.trunc(this.crypto_amount * Math.pow(10, 3))/Math.pow(10, 3);
    })
    
    if (!this.route.snapshot.params.ticket_key) {
      this.storageService.deleteItem('ticket_key');
    }

    this.transactionInfoSubscr = this.commonSubscribeService.getTransactionInfo().subscribe(response => {
      this.transactionInfo = response;
      this.card = this.transactionInfo["card"];
      if (this.selectedCard && this.selectedCard.id) {
        this.makePayment('card');
      } else {
        this.makePayment();
      }
    })

    this.savedCardsListSubscr = this.commonSubscribeService.getSavedCards().subscribe(response => {
      this.savedCardsList = response;
      if (this.savedCardsList.length == 0 && this.addressList.length > 0 && this.addressList.billingAddress.length == 0) {
        this.showBillingForm = true;
      }
      // else if (this.savedCardsList.length > 0 && !this.addNewCard) {
      //   this.showBillingForm = false;
      // }
      if (this.savedCardsList.length == 0) {
        this.addNewCard = true;
      }
    })
    this.selectedCardInfoSubscr = this.commonSubscribeService.getSelectedCardInfo().subscribe(response => {
      this.selectedCard = response;
      if (response) {
        //this.selectedBillingAddress = {};
        //this.buildBillingForm();
        //updated showBillingForm to display after selecting card
        this.showBillingForm = true;
        this.addNewCard = false;
      }
    });

    this.addressListInfoSubscr = this.commonSubscribeService.getAddressList().subscribe(response => {
      this.addressList = response;
      if (this.addressList.shippingAddress.length > 0) {
        let shippingAdd = this.addressList.shippingAddress.filter(a => a.shippingAddress);
        this.newShippingForm = shippingAdd.length > 0 ? true : false;
        let selectedAddress = this.addressList.shippingAddress.filter(a => a.defaultShippingAddress);
        this.selectedShippingAddress = selectedAddress.length > 0 ? selectedAddress[0] : {};
        // if(this.newShippingForm){
        //   this.commonSubscribeService.formsValidationSubject.next(false);
        // }
      } else if (this.addressList.shippingAddress.length == 0) {
        this.newShippingForm = true;
      }
      if((this.selectedShippingAddress || Object.keys(this.selectedShippingAddress).length == 0) && !this.getShippingValue){
        this.buildShippingForm();
      }
      if(Object.keys(this.selectedShippingAddress).length > 0){
        this.calShippingTax();
      }
      if (this.addressList.billingAddress.length > 0) {
        let billingAdd = this.addressList.billingAddress.filter(a => a.billingAddress);
        this.showBillingForm = billingAdd.length > 0 ? true : false;
        if (this.showBillingForm) {
          this.commonSubscribeService.formsValidationSubject.next(false);
        }
        let selectedAddress = this.addressList.billingAddress.filter(a => a.defaultBillingAddress);
        this.billingAddress = this.selectedBillingAddress = selectedAddress.length > 0 ? selectedAddress[0] : {};
        if(this.billingAddress){
          this.buildBillingForm();
        }
        if (Object.keys(this.selectedBillingAddress).length > 0 && this.isAgrees)
          this.commonSubscribeService.formsValidationSubject.next(true);
        if (Object.keys(this.selectedBillingAddress).length > 0) {
          let country;
          COUNTRIES_LIST.forEach(element => {
            if (element.alpha3code == this.selectedBillingAddress.country_code) {
              country = element;
            }
          });
          if(country?.name===undefined){
            country={"name": this.selectedBillingAddress.country}
          }
          this.commonSubscribeService.validateZip(this.selectedBillingAddress.zip, country?.name, (result) => {
            if (result.status) {
              this.codes = result;
              let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country);
              this.codes.country = country[0].alpha3code;
              this.selectedBillingAddress.country_code=this.codes.country 
              this.getTaxPercentage(this.selectedBillingAddress.zip, () => {
                let amount = Number(this.amountWithBF.toFixed(2));
                this.finalAmount = this.taxAmount ? amount + this.taxAmount : amount;
                if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1)
                  //removing processing fee at starting
                  // this.finalAmount = this.processingFee + this.finalAmount;
                  this.finalAmount =  this.finalAmount;
                this.finalAmount = Number(this.finalAmount.toFixed(2));
                let data = {
                  "total_amount": this.finalAmount,
                  "currency": this.currency,
                  "processing_fee": this.processingFee,
                  "amt_without_pf": this.amt_without_pf
                }
                this.commonSubscribeService.totalAmountSubject.next(data);
              });
            } else {
              this.toastr.error('Invalid zip code');
            }
          });
          if(this.selectedTransaction){
            let val = {'selectedTransaction':this.selectedTransaction};
            this.calFee(val);
          }
        }
      } else if (this.addressList.billingAddress.length == 0 && this.savedCardsList.length == 0) {
        this.showBillingForm = true;
      }
    });

    if (Object.keys(this.route.snapshot.queryParams) && this.route.snapshot.queryParams.user_id)
      this.isMobile = true;
    else
      this.isMobile = false;
    this.backRedirectionUrl = environment.CONSUMER_PORTAL + this.route.snapshot.params.slug_name+'/cancel-payment';
    this.timezoneVal = this.userService.getTimezone();
    this.vodUrl = this.storageService.getItem('vodUrl');
    this.commonSubscribeService.sendScreenStatus(true);
    this.userInfo = this.commonSubscribeService.userInfo;
    this.userInfoSubscription = this.commonSubscribeService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      this.buildprofileInfoForm();
      this.continueInfoDetail();
    });
    this.currencyInfoSubscription = this.commonSubscribeService.getCurrencyInfo().subscribe(response => {
      if (response) {
        this.getCurrency = this.storageService.getItem('currency');
        // if(!this.isSelectedTicket)
        this.getEventDetails();
        this.getCurrencyRates(); 
        // return;
        if (this.isSelectedTicket && this.contactInfoForm.invalid) {
          // this.selectTicket();
        }
      }
    });
    if (this.route.snapshot.queryParams.user_id) {
      this.mobileUrl = environment.CONSUMER_PORTAL + this.route.snapshot.params.slug_name + '/cancel-payment';
    }
    this.deviceData = this.commonSubscribeService.getMobileOperatingSystem();
    if (this.deviceData == 'web')
      window.scrollTo(0, 400);
    // this.streamInfo = this.storageService.getItem('streamInfo');
    if (this.getParam('user_id')) {
      this.isBookingFrom = "mobile";
    }
    this.getUserInfo(this.getParam('user_id'), () => {
      this.buildprofileInfoForm();
      this.buildBillingForm();
      this.buildShippingForm();
      this.getCurrency = this.storageService.getItem('currency');
      this.getStreamInfo((streamInfo) => {
        this.streamInfo = streamInfo;
        this.commonSubscribeService.sendStreamInfo(this.streamInfo);
        // this.getTicketsByTicketId();
        // if (this.streamInfo.stream_payment_mode == 'paid')
        //   this.getTicketsByEventId();
        // if (this.streamInfo.stream_payment_mode == 'free')
        //   this.getQuestionsByEventId();
        var ctDate, currentDate, eventStartDates: any = [], eventEndDates: any = [];
        ctDate = moment().format("YYYY-MM-DD");
        currentDate = new Date(ctDate).getTime();
        this.currentLocation = this.commonSubscribeService.locationInfo;
        this.currencyType = this.getCurrency ? this.getCurrency : this.streamInfo.currency_type;
        let locInfo = this.commonSubscribeService.locationInfo;
        this.currentLocation = locInfo && Object.keys(locInfo).length > 0 ? locInfo : this.storageService.getItem('current_location');
        if (!this.currentLocation || Object.keys(this.currentLocation).length == 0) {
          this.commonSubscribeService.getCurrentLocation((val: any, json: any) => {
            if (val == "fail") {
              this.currentLocation = this.currentLocation ? this.currentLocation : {};
            } else {
              this.currentLocation = json;
            }
            this.prepare();
          });
        } else {
          this.prepare();
        }
      });


    });

    let status = this.commonSubscribeService.getLoginStatus().subscribe(response => {
      if (response) {
        this.continueInfoDetail();
      }
    });

    // this.profileInfoForm.valueChanges.subscribe(val => {
    //   if (this.profileInfoForm.valid) {
    //     this.contactInfoForm.enable();
    //   }
    // })

    // this.contactInfoForm.get('providers') as FormArray).valueChanges.subscribe(values => {
    //   console.log(values);
    // });
    // this.contactInfoForm.valueChanges.subscribe(val => {
    //   if (this.contactInfoForm.valid) {
    //     if(this.showShippingForm)
    //       this.shippingForm.enable();
    //     this.billingForm.enable();
    //   }
    // })

    if(this.shippingForm){
      this.shippingForm.valueChanges.subscribe(val => {
        if (this.shippingForm.invalid) {
          this.commonSubscribeService.formsValidationSubject.next(false);
        } else if (this.shippingForm.valid) {
          this.calShippingTax();
          this.commonSubscribeService.formsValidationSubject.next(true);
        }
      })
    }
    
    if(this.billingForm){
      this.billingForm.valueChanges.subscribe(val => {
        if (this.billingForm.invalid){
          this.commonSubscribeService.formsValidationSubject.next(false);
        }
      })
    }
    this.settingsDataSubscription = this.commonSubscribeService.getICWebpageThemeSettings().subscribe(async (response) => {
      this.settingsData = response;
      if (this.settingsData?.is_preview && this.profileInfoForm) {
        this.profileInfoForm.disable();
      }
      this.addStyle();
    });
    this.settingsData = this.commonSubscribeService.icWebpageSettingsData;
    if (this.settingsData?.is_preview && this.profileInfoForm) {
      this.profileInfoForm.disable();
    }
  }

  calShippingTax(){
    let country;
    COUNTRIES_LIST.forEach(element => {
      if (element.alpha3code == this.selectedBillingAddress.country_code) {
        country = element;
      }
    });
    let shippingzip = this.getShippingValue.zip ? this.getShippingValue.zip : this.selectedShippingAddress && this.selectedShippingAddress.zip ? this.selectedShippingAddress.zip : ""
      let newShipCountry = this.getShippingValue.country.name ? this.getShippingValue.country.name : "";
      let shippingCountry = this.selectedShippingAddress && this.selectedShippingAddress.country ? this.selectedShippingAddress.country : newShipCountry ;
    this.commonSubscribeService.validateZip(shippingzip, shippingCountry, (result) => {
      if (result.status) {
        // if (result.status) {
          this.shippingCodes = result;
          let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.shippingCodes.country);
          this.shippingCodes.country = country[0].alpha3code;
        // }
        // let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country);
        // this.codes.country = country[0].alpha3code;
        this.getTaxPercentage(shippingzip, () => {
          let amount = Number(this.amountWithBF.toFixed(2));
          this.finalAmount = this.taxAmount ? amount + this.taxAmount : amount;
          if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1)
            //removing processing fee at start
            // this.finalAmount = this.processingFee + this.finalAmount;
            this.finalAmount = this.finalAmount;
          this.finalAmount = Number(this.finalAmount.toFixed(2));
          let data = {
            "total_amount": this.finalAmount,
            "currency": this.currency,
            "processing_fee": this.processingFee,
            "amt_without_pf": this.amt_without_pf
          }
          this.commonSubscribeService.totalAmountSubject.next(data);
        });
      } else {
        this.toastr.error('Invalid zip code');
      }
    });
  }

  calFee(response) {
    if (this.currentBlock == "Tickets") {
      this.selectedTransaction = response.selectedTransaction;
      this.fee = (this.selectedTransaction == "wallet" || this.selectedTransaction == 'crypto') ? (this.streamInfo.booking_fee_wallet ? this.streamInfo.booking_fee_wallet : 0) / 100 : (this.streamInfo.booking_fee ? this.streamInfo.booking_fee : 0)/100;
      if (this.selectedTransaction == "wallet" || this.selectedTransaction == "crypto") {
        // this.bookingFee = this.withoutAddOn * this.fee;
        this.bookingFee = this.amount * this.fee; 
        this.bookingFee = Number(this.bookingFee.toFixed(2));
        this.amountWithBF = this.amount + this.bookingFee + this.shippingCost;
        this.amt_without_pf = this.amountWithBF + this.taxAmount;
        this.processingFee = 0;
        this.finalAmount = this.amt_without_pf;
      } else if (this.selectedTransaction && this.selectedTransaction == "ott") {
        this.processingFee = 0;
        // this.bookingFee = this.withoutAddOn * this.fee;
        this.bookingFee = this.amount * this.fee;
        this.bookingFee = Number(this.bookingFee.toFixed(2));
        this.amountWithBF = this.amount + this.bookingFee + this.shippingCost;
        this.amt_without_pf = this.amountWithBF + this.taxAmount;
        if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
          this.processingFee = (this.amt_without_pf * (environment.processing_fee / 100)) + environment.fee_percentage;
          this.processingFee = Number(this.processingFee.toFixed(2));
        }
        this.finalAmount = this.amt_without_pf + this.processingFee;
      }
      this.calTax();
      this.amt_without_pf = this.amountWithBF + this.taxAmount;
      let data = {
        "total_amount": this.finalAmount,
        "currency": this.currency,
        "processing_fee": this.processingFee ? this.processingFee : undefined,
        "amt_without_pf": this.amt_without_pf
      }
      this.commonSubscribeService.totalAmountSubject.next(data);
    }
  }

  calTax(){
    let country;
    if (this.selectedCard && this.selectedCard.id) {
      COUNTRIES_LIST.forEach(element => {
        if (element.alpha2code == this.selectedCard.billing_address.country) {
          country = element;
        }
      });
    }
    let shippingzip = this.getShippingValue.zip ? this.getShippingValue.zip : this.selectedShippingAddress && this.selectedShippingAddress.zip ? this.selectedShippingAddress.zip : ""
    let newShipCountry = this.getShippingValue.country.name ? this.getShippingValue.country.name : "";
    let shippingCountry = this.selectedShippingAddress && this.selectedShippingAddress.country ? this.selectedShippingAddress.country : newShipCountry ;
    if (shippingzip) {
      this.commonSubscribeService.validateZip(shippingzip, shippingCountry, (result) => {
        if (result.status) {
          this.shippingCodes = result;
          let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.shippingCodes.country);
          this.shippingCodes.country = country[0].alpha3code;
        }
        else {
          this.toastr.error('Invalid zip code');
        }
      });
    }
    let zip = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
    let newBillCountry =  this.getBillingValue && this.getBillingValue.country.name ? this.getBillingValue.country.name : "";
    let cName = (this.selectedBillingAddress && this.selectedBillingAddress.country)  ? this.selectedBillingAddress.country : country && country.name ? country.name : newBillCountry;
    if (!zip) {
      return;
    }
    this.commonSubscribeService.validateZip(zip, cName, (result) => {
      if (result.status) {
        this.codes = result;
        let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country)
        this.codes.country = country[0].alpha3code;
        this.getTaxPercentage(zip, () => {
          this.showCCForm = true;
          if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
            let totalPrice = 0;
            this.selectedTicketsData.forEach(e => {
              totalPrice += e.price;
              totalPrice = Number(totalPrice.toFixed(2));
            });
            this.amountWithBF = Number(this.amountWithBF.toFixed(2));
            this.finalAmount = this.amountWithBF + this.taxAmount;
            this.finalAmount = Number(this.finalAmount.toFixed(2));
            this.processingFee = (this.finalAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
            this.processingFee = Number(this.processingFee.toFixed(2));
            // processing fee added for ott
            if(this.selectedTransaction =='ott'){
              this.finalAmount = this.finalAmount + this.processingFee;
            }
            this.finalAmount = Number(this.finalAmount.toFixed(2));
          } else {
            this.totalAddOnAmount = 0;
            let isFree = [];
            isFree = this.selectedTicketsData.filter(a => a.ticket_type == 'free');
            this.finalAmount = this.finalAmount + this.taxAmount;
            if (this.selectedTicketsData.length != isFree.length) {
              if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
                this.addOnAmount = this.orgAmount - this.withoutAddOn;
                this.processingFee = (this.finalAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
                this.processingFee = Number(this.processingFee.toFixed(2));
              }
              if (!this.isDiscountApplied) {
                // withoutAddOn is the pre-discount ticket total. When a promo code is active,
                // bookingFee was already derived from the discounted total by finalAmounts()/
                // verifyCode() - recomputing it here from withoutAddOn silently dropped the
                // discount every time calTax() ran (e.g. on payment method change via calFee()).
                this.bookingFee = this.fee * this.withoutAddOn;
                this.bookingFee = Number(this.bookingFee.toFixed(2));
              }
              // amountWithBF was last set by an earlier calculation (e.g. checkTicketQuantity/
              // calFee) before this booking fee was refreshed above - without recomputing it
              // here, the booking fee shown in the breakdown no longer matches what actually
              // gets carried into finalAmount below (the displayed "Total").
              this.amountWithBF = Number((this.amount + this.bookingFee + this.shippingCost).toFixed(2));
            } else {
              this.bookingFee = 0;
            }
            this.finalAmount = this.amountWithBF + this.taxAmount;
            if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1)
              this.finalAmount = this.finalAmount + this.processingFee;
            this.finalAmount = Number(this.finalAmount.toFixed(2));
          }
          let data = {
            "total_amount": this.finalAmount,
            "currency": this.currency,
            "processing_fee": this.processingFee,
            "amt_without_pf": this.amt_without_pf
          }
          this.commonSubscribeService.totalAmountSubject.next(data);
          if (this.isAgrees) {
            this.commonSubscribeService.formsValidationSubject.next(true);
          }
        });
      } else {
        this.toastr.error('Invalid zip code');
      }
    });
  }

  imageScroll() {
    (function HorizontalScrolling() {
      function wheelHandler(element, event) {
        const toLeft = event.deltaY < 0 && element.scrollLeft > 0
        const toRight = event.deltaY > 0 && element.scrollLeft < element.scrollWidth - element.clientWidth

        if (toLeft || toRight) {
          event.preventDefault()
          event.stopPropagation()

          element.scrollBy({ left: event.deltaY * 12 })
        }
      }

      const targets = document.querySelectorAll('#addon-Container')
      targets.forEach(element => element.addEventListener('wheel', event => wheelHandler(element, event)))
    })()
  }
  loadAdsScript() {

    this.ticketsData.forEach((element, index) => {
      if (element && element.add_ons && element.add_ons.length > 0) {

        let t;
        let start = $('#myCarousel_' + index).find('.active').attr('data-interval');
        let id = "#myCarousel_" + index;
        t = setTimeout("$('" + id + "').carousel({interval: 1000});", start - 1000);

        $('#myCarousel_' + index).on('slid.bs.carousel', () => {
          clearTimeout(t);
          let duration = $(this).find('.active').attr('data-interval');

          $('#myCarousel_' + index).carousel('pause');
          t = setTimeout("$('" + id + "').carousel();", duration - 1000);
        });

        $('.carousel-control-next_' + index).on('click', () => {
          clearTimeout(t);
        });

        $('.carousel-control-prev_' + index).on('click', () => {
          clearTimeout(t);
        });

      }
    });

  }

  getEventDetails() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`,
      },
      response: true,
      body: {
        "slug": this.route.snapshot.params.slug_name,
        "userid": this.id ? this.id : this.userId,
        "offset": new Date().getTimezoneOffset(),
        "currency": this.getCurrency ? this.getCurrency : this.currentLocation.currency.code,
        "timezone": this.timezoneVal
      }
    }
    // this.loader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_EVENT_BY_SLUG, data).then(response => {
      // this.loader.stop();
      // this.checkIsUserSubscribe(response.data.Data.stream_info, (IsUserSubscribe: any) => {
      this.commonSubscribeService.sendSlugData(response['data']['Data']);
      this.streamInfo = response.data.Data.stream_info;
      this.priceDetails = response['data']['Data']['price_details'];
      this.settingsJSON = JSON.parse(this.streamInfo.settings_json);
      let affiliatesList = response['data']['Data']['affiliates'];
      if (affiliatesList && affiliatesList.length > 0) {
        affiliatesList.forEach(element => {
          if (element.referral_code == this.route.snapshot.queryParams.ref)
            this.refCodeMatched = true;
        });
      }
      this.ticketsData = response['data']['Data']['tickets'];
      if (this.vodUrl) {
        this.ticketsData = this.ticketsData.filter(a => a.ticket_type == 'paid');
      }
      this.virtualTickets = this.ticketsData.filter(a => !a.live && !a.add_ons && !a.token_id);
      this.liveTickets = this.ticketsData.filter(a => a.live && !a.add_ons && !a.token_id);
      this.nftTickets = this.ticketsData.filter(a => a.token_id);
      this.nftTickets.forEach((element) => {
        if(element.token_id){
          element.nftTicketFiatPrice = (Number(element.nft_details.salePrice) /environment.ONE_USD) * this.USD_Rates[element.currency]
        }
      })
      this.ticketType = this.virtualTickets.length > 0 ? 'virtual' : this.liveTickets.length > 0 ? 'live' : this.nftTickets.length > 0 ? 'nft' : 'add-on';
      this.updateTicketsData();
      // });
    }).catch(error => {
      this.loader.stop();
    });
  }

  checkProfileForm(event, currentForm, formType) {
    formType = formType == 'billingForm' && this.showShippingForm ? 'shippingForm' : formType;
    if (this[currentForm].valid)
      this[formType].enable();
    else
      this[formType].disable();
  }

  proceedWithAddress() {
    if (this.billingForm.valid)
      this.proceed();
  }

  buildprofileInfoForm() {
    this.profileInfoForm = this.formBuilder.group({
      user_first_name: [{ value: this.userInfo.user_first_name ? this.userInfo.user_first_name : this.profileInfoForm?.getRawValue()?.user_first_name, disabled: false }, Validators.required],
      user_last_name: [{ value: this.userInfo.user_last_name ? this.userInfo.user_last_name :this.profileInfoForm?.getRawValue().user_last_name, disabled: false }, Validators.required],
      user_email: [{ value: this.userInfo.email ? this.userInfo.email : this.profileInfoForm?.getRawValue()?.user_email, disabled: false }, [Validators.required, ValidationService.emailValidator, Validators.pattern(EMAIL_REGEX)]]
    });
    if (this.settingsData?.is_preview) {
      this.profileInfoForm.disable();
    }
    if(this.totalTicketsCount == 1) {
      this.billingForm.enable();
    } else if(this.totalTicketsCount > 1){
      this.contactInfoForm.enable();
    }
  }

  isLiveTickets = false;
  buildContactInfoForm(val, formData?,type?) {
    this.contactInfoForm = this.formBuilder.group({
      contactTicketList: this.formBuilder.array([])
    });

    let contactTicketListCtrl: any = <FormArray>this.contactInfoForm.controls.contactTicketList;
    contactTicketListCtrl.controls = [];
    let count = 0;
    this.selectedTicketsData.forEach((e, index) => {
      contactTicketListCtrl.push(
        this.formBuilder.group({
          ticket_id: [e.id],
          ticket_name: [e.title],
          ticket_detail: [e],
          contactList: this.formBuilder.array([])
        })
      );

      let contactListCtrl = <FormArray>contactTicketListCtrl.controls[index].controls.contactList;
      contactListCtrl.controls = [];
      let data = {
        user_first_name: this.userInfo.user_first_name || this.profileInfoForm.getRawValue().user_first_name,
        user_last_name: this.userInfo.user_last_name || this.profileInfoForm.getRawValue().user_last_name,
        user_email: this.userInfo.email || this.profileInfoForm.getRawValue().user_email,
      }
      if (!formData) {
        for (let i = 0; i < parseInt(e.selectedOption); i++) {
          count++
          if (index == 0 && i == 0) {
            contactListCtrl.push(
              this.formBuilder.group({
                id: [],
                user_first_name: [data.user_first_name ? data.user_first_name : "", [Validators.required]],
                user_last_name: [data.user_last_name ? data.user_last_name : "", [Validators.required]],
                user_email: [data.user_email ? data.user_email : "", [Validators.required, ValidationService.emailValidator, Validators.pattern(EMAIL_REGEX)]],
                ticket_id: [this.selectedTicketsData.length == 1 ? e.id : "", Validators.required],
                user_count: count
              })
            );
          } else {
            contactListCtrl.push(
              this.formBuilder.group({
                id: [],
                user_first_name: ["", Validators.required],
                user_last_name: ["", Validators.required],
                user_email: ["", [Validators.required, ValidationService.emailValidator, Validators.pattern(EMAIL_REGEX)]],
                ticket_id: [this.selectedTicketsData.length == 1 ? e.id : "", Validators.required],
                user_count: count
              })
            );
          }
        }
        if (this.profileInfoForm.invalid)
          this.contactInfoForm.disable();
      }
    });
    if (formData) {
      formData.contactTicketList.forEach((element, index) => {
        let contactListCtrl = <FormArray>contactTicketListCtrl.controls[index].controls.contactList;
        contactListCtrl.controls = [];
        element.contactList.forEach(contact => {
          count++
          // The caller (saveOtherUserTicket) already grouped each contact under its correct
          // ticket-type slot, falling back to the contact's original group when its Ticket Name
          // hasn't been picked yet (ticket_id === ""). Re-filtering here by exact ticket_id
          // equality would drop that not-yet-assigned contact all over again since "" never
          // equals a real ticket_id, making it vanish from every group instead of staying put.
          if (element.ticket_id == contact.ticket_id || !contact.ticket_id) {
            contactListCtrl.push(
              this.formBuilder.group({
                id: [],
                user_first_name: [contact.user_first_name, Validators.required],
                user_last_name: [contact.user_last_name, Validators.required],
                user_email: [contact.user_email, [Validators.required, ValidationService.emailValidator, Validators.pattern(EMAIL_REGEX)]],
                ticket_id: [contact.ticket_id, Validators.required],
                // Preserve the row's original user_count instead of recomputing it here -
                // recomputing via count++ ties it to THIS rebuild's group iteration order
                // (ticket-type/catalog order), which defeats getSortedContactRows()' sort by
                // silently re-numbering every row back into catalog order on every rebuild.
                // Only a genuinely new row (no prior user_count) gets the fresh counter value.
                user_count: contact.user_count != null ? contact.user_count : count
              })
            );
          }
        });
      });
    }
    if (this.selectedTicketsData.length == 1 && this.profileInfoForm.valid && val == true) {
      this.saveOtherUserTicket();
    }
    if(type == 'delete'){
      this.calTax();
    }
  }

  get contactTicketList(): FormArray {
    return this.contactInfoForm.get('contactTicketList') as FormArray;
  }

  contactList(index): FormArray {
    return this.contactTicketList.controls[index]['controls'].contactList.controls;
  }

  // Ticket-holder rows are still stored nested per ticket-type (needed for the existing
  // per-ticket-type limit/pricing checks elsewhere), but that means their display order
  // followed catalog order of the ticket types (whichever ticket type this event's API
  // happens to list first), not the order the buyer actually filled the rows in - so
  // finishing the LAST row first (e.g. picking its Ticket Name after already filling in
  // an earlier row) could visually jump it above rows filled in first. Rendering via this
  // flattened, user_count-sorted list instead keeps row order equal to fill-in order,
  // independent of which ticket-type group a row structurally belongs to.
  getSortedContactRows(): { pIndex: number, cIndex: number, control: any }[] {
    const rows: { pIndex: number, cIndex: number, control: any }[] = [];
    this.contactTicketList.controls.forEach((_, pIndex) => {
      (this.contactList(pIndex) as any).forEach((control: any, cIndex: number) => {
        rows.push({ pIndex, cIndex, control });
      });
    });
    rows.sort((a, b) => (a.control.get('user_count').value || 0) - (b.control.get('user_count').value || 0));
    return rows;
  }

  // getSortedContactRows() builds a fresh wrapper object every change-detection cycle, so
  // without this the *ngFor's default identity-based diffing would see "new" items on every
  // keystroke and tear down/recreate the input DOM nodes, dropping focus while typing.
  trackByContactRow(index: number, row: { control: any }): any {
    return row.control;
  }

  getTicketValue(form) {
    return form.getRawValue();
  }

  getTicketsByTicketId() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "timezone": this.timezoneVal
      }
    }
    let url = CONST_AWS_API.GET_TICKETS_BY_TICKET_ID + '/' + this.streamInfo.id + '/' + new Date().getTimezoneOffset();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.status == 0) {

      }
    }, error => {
      console.log(error);
    })
  }

  ticketsData: any;
  getTicketsByEventId() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        "timezone": this.timezoneVal
      }
    }
    this.loader.start();
    let url = CONST_AWS_API.GET_TICKETS_BY_EVENT_ID + '/' + this.streamInfo.id + '/' + new Date().getTimezoneOffset();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      this.loader.stop();
      if (response.status == 200) {
        this.ticketsData = response['data']['Data'];
        this.ticketsData.forEach(element => {
          if (element.amounts)
            element.amounts = typeof element.amounts == 'string' ? JSON.parse(element.amounts) : element.amounts;
          if (element.sessions) {
            element.sessions.forEach(e => {
              if (e == element.event_id)
                element.allSessions = true;
            });
          }
        });
        setTimeout(() => {
          this.loadAdsScript()
        }, 1000);
        if (this.streamInfo.stream_payment_mode == 'paid') {
          // this.streamInfo.stream_amounts = tempTicketType;
          let result = this.commonSubscribeService.getAmount(this.streamInfo, this.currentLocation, this.IsUserSubscribe, this.ticketsData);
          // if (result && result.current) {
          //   this.amount = result.current.price;
          //   this.currencyType = result.current.currency;
          //   this.priceChangeDate = result.priceChangeDate;
          // } else {
          //   let message = result.message || 'Something went wrong';
          //   this.toastr.error(message);
          // }
          if (result && result.currectDatesAmounts && result.currectDatesAmounts.length > 0) {
            this.currectDatesAmounts = result.currectDatesAmounts;
          } else {
            let message = result.message || 'Something went wrong';
            this.toastr.error(message);
          }
        } else {
          this.isSelectedTicket = true;
        }

      }
    }, error => {
      console.log(error);
    })
  }

  selectedTicketsData: any = [];
  disableTickets: boolean = false;
  currentSelectedTicket: any = [];
  // selectTicket(event, ticket) {

  //   if(event.checked) {
  //     ticket.selectedOption = 1;
  //     event.value = 1;
  //     this.currentSelectedTicket.push(ticket.id);
  //   } else {
  //     ticket.selectedOption = 0;
  //     event.value = 0;
  //     let index = this.currentSelectedTicket.findIndex(a => a == ticket.id);
  //     if(index != -1) {
  //       this.currentSelectedTicket.splice(index, 1)
  //     }
  //   }

  //   this.selectedTicketsData = [];
  //   this.ticketsData.forEach(element => {
  //     // if (element.id == ticket.id && event.value == 1) {
  //     //   element.isTicketSelected = true;
  //     //   this.selectedTicketsData.push(element);
  //     // } else if (event.value == 0) {
  //     //   element.isTicketSelected = true;
  //     // } else {
  //     //   element.isTicketSelected = false;
  //     // }
  //     if (element.allSessions && element.id == ticket.id && event.value == 1) {
  //       element.isTicketSelected = true;
  //       this.disableTickets = true;
  //     } else if (element.allSessions && element.id == ticket.id && event.value == 0) {
  //       this.disableTickets = false;
  //     }
  //     if (element.id == ticket.id && event.value == 1)
  //       element.isTicketSelected = true;
  //     else if (element.id == ticket.id && element.isTicketSelected && event.value == 0)
  //       element.isTicketSelected = false;
  //     if(this.disableTickets && !element.allSessions)
  //       element.selectedOption = 0;
  //   });
  //   this.ticketsData.forEach(element => {
  //     if (element.allSessions && element.isTicketSelected)
  //       this.selectedTicketsData.push(element);
  //     else if (element.isTicketSelected && !this.disableTickets)
  //       this.selectedTicketsData.push(element);
  //   });
  //   this.selectedTicketsData.forEach(element => {
  //     if (element.shipping_address == 1)
  //       this.showShippingForm = true;
  //     else
  //       this.showShippingForm = false;
  //   });
  //   this.amount = 0, this.finalAmount = 0, this.streamData.amount = 0;
  //   if (this.ticketsData) {
  //     this.ticketsData.forEach(e => {
  //       if (e.isTicketSelected) {
  //         this.amount += e.price;
  //         this.streamData.amount += e.price;
  //         this.streamData.currency = e.currency;
  //         this.currencyType = e.currency;
  //         this.selectedTicket = e;
  //         this.currency = e.currency;
  //         this.finalAmount += e.price;
  //       }
  //     })

  //   }
  //   console.log(this.selectedTicketsData,'gg');
  //   console.log(this.amount, this.finalAmount);
  // }

  isSelectedAllDateTicket = false;
  disableAll = false;
  allowLiveTickets = false;
  allowNftTickets = false;
  allowVirtualTickets = false;
  tooltipTxt = '';
  amountWithBF: any;
  withoutAddOn = 0;
  orgAmount = 0;
  selectTicket(ticket, event, type, from?) {
    if(ticket && from == 'nft'){
      // this.commonSubscribeService.formsValidationSubject.next(true);
      if(this.userInfo && this.userInfo.access_token){
      this.nftTicketSelected = type == 'add' ? true : false;
      this.nftTicketTotalPrice = ticket.nft_details.salePrice;
      ticket.nftTicketSelected = true
      if(type == 'add'){
        this.toastr.info("You will only proceed with NFT ticket")
      }
      this.ticketsData.map((ticket) => {
          if(!ticket.nftTicketSelected && ticket.selectedOption){
            ticket.selectedOption = 0
            ticket.showQty = 0
          }
        this.amountWithBF = 0
      })
    }
    else{
      this.requireLogin();
      return
    }
  }
    if (ticket && from == 'addon')
      ticket.showQty = true;
    if (event && !event.target)
      ticket.selectedOption = event;

    // if(type === "add" && !ticket.selectedOption){
    //   ticket.selectedOption = 1;
    // }
    
    // if (type && !ticket.selectedOption) {
    //   ticket.selectedOption = 0;
    //   ticket.selectedOption = type == 'add' ? ticket.selectedOption = 1 : ticket.selectedOption = 0;
    // }
    
    if (type) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      if (type === 'add') {
        (window as any).umami?.track(`Ticket Quantity Add Clicked -${userId}`);
        const data = {
          actionType: "event",
          metaData: {
            title: "Ticket Quantity Add Clicked",
            eventId: this.streamInfo.id,
            eventName: this.streamInfo.stream_video_title,
            ticketId: ticket.id,
            orgId: this.streamInfo.organization_id,
            timeStamp: new Date().toISOString()
            
          },
          organizationId: this.streamInfo.organization_id || null,
          clickAction:'quantity-add',
          networkGroupId : this.streamInfo.network_group_id || null,

        }
         
        this.commonSubscribeService.sendTriggeredEvent(data);
      } else {
        (window as any).umami?.track(`Ticket Quantity Minus Clicked ${userId}`);
        const data = {
          actionType: "event",
          metaData: {
            title: "Ticket Quantity Minus Clicked",
            eventId: this.streamInfo.id,
            eventName: this.streamInfo.stream_video_title,
            ticketId: ticket.id,
            orgId: this.streamInfo.organization_id,
            timeStamp: new Date().toISOString()
          },
          organizationId: this.streamInfo.organization_id || null,
          networkGroupId : this.streamInfo.network_group_id || null,         
          clickAction:'quantity-minus'
        }
        this.commonSubscribeService.sendTriggeredEvent(data);
      }
      ticket.selectedOption = type == 'add' ? ticket.selectedOption = ticket.selectedOption + 1 : event = ticket.selectedOption - 1;
      if (ticket.selectedOption < 0)
        ticket.selectedOption = 0;
      if ((ticket.selectedOption < 0 || ticket.selectedOption == 0) && from == 'addon')
        ticket.showQty = false;
    }

    if (ticket.selectedOption > 1 && this.vodUrl) {
      ticket.selectedOption = 1;
      this.toastr.error('You can select only one ticket');
      return;
    }

    if (ticket.limited_tickets == 1 && ticket.inventory < parseInt(ticket.selectedOption)) {
      ticket.selectedOption = 0;
      this.isSelectedAllDateTicket = false;
      this.toastr.error("Only " + ticket.inventory + " tickets available");
      // return;
    }

    this.selectedTicketsData = [];
    this.isSelectedAllDateTicket = false;
    this.ticketsData.forEach(element => {
      if (element.selectedOption)
        this.selectedTicketsData.push(element);
    });
    if (this.selectedTicketsData.length == 0) {
      this.disableAll = false;
      this.allowLiveTickets = false;
      this.allowNftTickets = false;
      this.allowVirtualTickets = false;
      this.tooltipTxt = '';
    }
    this.selectedTicketsData.forEach(element => {

      if (element.live == 1)
        this.allowLiveTickets = true;
      if (element.live != 1 && element.nft != 1)
        this.allowVirtualTickets = true;
        if (element.nft == 1 && element.live != 1 && element.virtual != 1)
        this.allowNftTickets = true;
    });
    this.amount = 0, this.finalAmount = 0, this.streamData.amount = 0, this.amountWithBF = 0, this.withoutAddOn = 0, this.totalAddOnAmount = 0;
    let checkCurrency = false;
    this.bookingFee = 0;
    this.selectedTicketsData.forEach(e => {
      if (e.currency != ticket.currency && ticket.price != 0) {
        checkCurrency = true;
        ticket.selectedOption = "";
      }
      // this.amount += e.price;
      // this.streamData.amount += e.price;
      if (e.price && e.price != 0) {
        this.streamData.currency = e.currency;
        this.currencyType = e.currency;
        this.selectedTicket = e;
        this.currency = e.currency;
      } else if (e.price == 0) {
        e.currency = this.currencyType;
      }
      // this.finalAmount += e.price;
    });

    if (checkCurrency) {
      this.toastr.error('Please buy same currency ticket');
      return;
    }
    if (ticket.selectedOption) {
      this.currentSelectedTicket.push(ticket.id);
    } else {
      let index = this.currentSelectedTicket.findIndex(a => a == ticket.id);
      if (index != -1) {
        this.currentSelectedTicket.splice(index, 1)
      }
    }
    let isFree = [];
    isFree = this.selectedTicketsData.filter(a => a.ticket_type == 'free');
    this.selectedTicketsData.forEach(element => {
      element.org_price = element.price;
      delete element.line_total;
      this.amount += element.price * element.selectedOption;
      this.amount = Number(this.amount.toFixed(2));
      if (!element.add_ons) {
        this.withoutAddOn += element.price * element.selectedOption;
        this.withoutAddOn = Number(this.withoutAddOn.toFixed(2));
      }
      this.streamData.amount = this.amount;
      if (isFree.length == this.selectedTicketsData.length) {
        this.bookingFee = 0;
        this.streamInfo.stream_payment_mode = 'free';
        this.amount = 0;
      } else {
        this.streamInfo.stream_payment_mode = 'paid';
      }
    });
    this.isAddOnTickets = this.selectedTicketsData.filter(a => a.add_ons);
    if (this.isAddOnTickets.length > 0) {
      this.paidAddOnTickets = this.isAddOnTickets.filter(a => a.ticket_type == 'paid');
      this.shippingCost = this.shippingChrg;
    } else {
      this.shippingCost = 0;
    }
    this.streamData.amount = this.amount = Number(this.amount.toFixed(2));
    if (this.streamInfo.booking_fee != 0 && isFree.length != this.selectedTicketsData.length) {
      this.bookingFee = this.fee * this.withoutAddOn;
      this.bookingFee = Number(this.bookingFee.toFixed(2));
    }
    this.amountWithBF = Number((this.amount + this.bookingFee + this.shippingCost).toFixed(2));
    this.orgAmount = this.amount;
    if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
      let amt = this.amountWithBF + this.taxAmount;
      this.processingFee = (amt * (environment.processing_fee / 100)) + environment.fee_percentage;
      this.processingFee = Number(this.processingFee.toFixed(2));
    }
    if (this.isDiscountApplied)
      this.verifyCode('promocode', 'msg');
  }

  showToast(ticket) {
    if ((this.disableTickets && !ticket.allSessions) || (ticket.limited_tickets == 1 && ticket.inventory == 0 && ticket.status == 0) || (ticket.disableTicket)) {
      this.toastr.error('This ticket is not available');
    }
  }
  
  questionsData: boolean = false;
  totalTicketsCount = 0;
  checkTicketSelected(type) {
    //added when change the currency
    this.selectedTicketsData = [];
    this.ticketsData.forEach(element => {
      if (element.selectedOption)
        this.selectedTicketsData.push(element);
    });
    if (this.selectedTicketsData && this.selectedTicketsData.length == 0) {
      this.toastr.error('Please select atleast one ticket');
      return;
    }
    // if(this.vodUrl && this.selectedTicketsData.length > 1){
    //   this.toastr.error('You can select only one ticket');
    //   return;
    // }
    this.isAnalyticsData = (this.addOnData.length == this.ticketsData.length || (this.selectedTicketsData.length > 0)) ? true : false;
    // if(this.paidAddOnTickets.length > 0)
    //   this.bookingFee = this.bookingFee + (this.totalAddOnAmount * (2.9 / 100)) + 0.3;
    this.selectedTicketsData.forEach(element => {
      if (element.selectedOption)
        this.totalTicketsCount += element.selectedOption;
    });
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Checkout ${this.totalTicketsCount} Clicked - ${userId}`)
    const data = {
      actionType: "event",
      metaData: {
        title: `Checkout ${this.totalTicketsCount} Clicked`,
        eventId: this.streamInfo?.id || null,
        eventName: this.streamInfo?.stream_video_title || null,
        ticketCount: this.totalTicketsCount,
        selectedTickets: this.selectedTicketsData?.map((t: any) => ({ ticketId: t.id, ticketName: t.ticket_title || t.name, quantity: t.selectedOption })) || [],
        timeStamp: new Date().toISOString()
      },
      organizationId: this.streamInfo.organization_id || null,
      networkGroupId : this.streamInfo.network_group_id || null,

      clickAction:'checkout'
    }
    this.commonSubscribeService.sendTriggeredEvent(data);
    let shippingValue = this.selectedTicketsData.filter(a => a.shipping_address == 1);
    this.showShippingForm = shippingValue.length > 0;
    if (shippingValue.length > 0) {
      this.newShippingForm = true;
    }
    if (this.showShippingForm)
      this.shippingForm.disable();
    if ((this.isAnalyticsData && type == 'continue') || this.addOnData.length == 0) {
      this.commonSubscribeService.sendScreenStatus(false);
      this.isSelectedTicket = true;
      this.continueInfoDetail();
      let selectedTickets = this.selectedTicketsData.filter(a => a.ticket_type == 'free');
      if (this.selectedTicketsData.length == selectedTickets.length)
        this.streamInfo.stream_payment_mode = 'free';
      else
        this.streamInfo.stream_payment_mode = 'paid';
      // if (this.deviceData != 'web')
      //   document.getElementById('app-tickets').scrollIntoView({ behavior: 'smooth' });
      this.getQuestionsByEventId();
      // if (Object.keys(this.route.snapshot.queryParams).length > 0 && this.route.snapshot.queryParams.ref) {
      //   this.labelText = 'Enter referal code';
      //   this.promoCode = this.route.snapshot.queryParams.ref;
      //   this.verifyCode("referralcode");
      // } else {
      //   this.labelText = 'Enter promo code';
      // }
    }
  }

  deleteTickets(ticket, index) {
    this.amount = 0, this.finalAmount = 0, this.streamData.amount = 0, this.amountWithBF = 0, this.withoutAddOn = 0, this.totalAddOnAmount = 0;
    this.contactTicketList.value.forEach(element => {
      element.contactList.forEach(e => {
        if (ticket.value.user_count == e.user_count) {
          this.selectedTicketsData[index].selectedOption--;
          if (this.selectedTicketsData[index].selectedOption == 0)
            this.selectedTicketsData.splice(index, 1);
          
        }
      });
    });
    let isFree = [];
    isFree = this.selectedTicketsData.filter(a => a.ticket_type == 'free');
    this.selectedTicketsData.forEach(element => {
      // Don't overwrite element.price with the line total here — it must stay the per-unit
      // price (matching org_price) while contactInfoForm is still invalid, because the
      // order-summary template multiplies it by selectedOption again in that state
      // ("{{ticket.selectedOption * ticket.price}}"). Overwriting it double-counted quantity
      // on every delete (e.g. 5 tickets at $12 rendered as 5 x $60 = $300 instead of $60).
      const lineTotal = element.org_price * element.selectedOption;
      delete element.line_total;
      this.amount += lineTotal;
      this.amount = Number(this.amount.toFixed(2));
      if (!element.add_ons) {
        this.withoutAddOn += lineTotal;
        this.withoutAddOn = Number(this.withoutAddOn.toFixed(2));
      }
      this.streamData.amount = this.amount;
      if (isFree.length == this.selectedTicketsData.length) {
        this.bookingFee = 0;
        this.streamInfo.stream_payment_mode = 'free';
        this.amount = 0;
      } else {
        this.streamInfo.stream_payment_mode = 'paid';
      }
    });
    this.isAddOnTickets = this.selectedTicketsData.filter(a => a.add_ons);
    if (this.isAddOnTickets.length > 0) {
      this.paidAddOnTickets = this.isAddOnTickets.filter(a => a.ticket_type == 'paid');
      this.shippingCost = this.shippingChrg;
    } else {
      // Mirrors the same isAddOnTickets check in the initial ticket-selection flow — without
      // this, deleting the last (or only) merch/add-on ticket left shippingCost at its stale
      // pre-delete value, since nothing else in this function ever clears it back to 0.
      this.shippingCost = 0;
    }
    this.streamData.amount = this.amount = Number(this.amount.toFixed(2));
    if (this.streamInfo.booking_fee != 0 && isFree.length != this.selectedTicketsData.length) {
      this.bookingFee = this.fee * this.withoutAddOn;
      this.bookingFee = Number(this.bookingFee.toFixed(2));
    }
    this.amountWithBF = this.amount + this.bookingFee + this.shippingCost;
    // finalAmount/processingFee drive the checkout summary panel once a ticket has already
    // been booked into the flow (proceedToCheckout's *ngIf="finalAmount" branch) — without
    // recomputing them here too, that panel kept showing the pre-delete total.
    this.finalAmount = this.amountWithBF + this.taxAmount;
    this.finalAmount = Number(this.finalAmount.toFixed(2));
    if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
      this.processingFee = (this.finalAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
      this.processingFee = Number(this.processingFee.toFixed(2));
      if (this.selectedTransaction == 'ott') {
        this.finalAmount = this.finalAmount + this.processingFee;
      }
      this.finalAmount = Number(this.finalAmount.toFixed(2));
    }
    this.continueInfoDetail('delete');
  }

  questionPanelOpenState = false;
  generalQuesAns: any = [];
  saveQuestions(valid, isMandatory) {
    // if (this.isLiveTickets) {
    //   this.usersQuestionsInfo.forEach(element => {
    //     let appendAns = [], ticketId;
    //     element.userQuestions.forEach(e => {
    //       if (e.isSelected) {
    //         ticketId = e.ticket_id
    //         appendAns = (e.questions);
    //       } else {
    //         e.questions.forEach(qtn => {
    //           appendAns.forEach(a => {
    //             if (qtn.id == a.id && ticketId == e.ticket_id) {
    //               if (qtn.option_type == "checkbox") {
    //                 qtn.options = a.options;
    //               } else {
    //                 qtn.value = a.value;
    //               }
    //             }
    //           });
    //         });
    //       }
    //     });
    //   });
    // }
    // return;
    // if (valid) {
    // const data = {};
    if (valid) {
      let isCheckedChecked = true, ansMandtory = true;
      let usersAnswer: any = [], quesAns: any = [];
      let generalAns: any = [], generalQuesAns = [];
      if (this.generalQuestions && this.generalQuestions.length > 0) {
        this.generalQuestions.forEach(qtn => {
          const generalData = {};
          if (qtn.option_type == "checkbox") {
            let selectedCheck = qtn.options.filter(a => a.value == true);
            if (qtn.is_mandatory == 1 && (!selectedCheck || selectedCheck.length == 0) && isCheckedChecked) {
              ansMandtory = false;
            }

            if (selectedCheck && selectedCheck.length != 0) {
              qtn.value = qtn.options.filter(op => op.value == true).map(op => op.option).toString();
              qtn.valueArray = qtn.options.filter(op => op.value == true).map(op => op.option);
            }
          } else {
            if (qtn.is_mandatory == 1 && !qtn.value && ansMandtory) {
              ansMandtory = false;
            }
          }
          qtn.valueArray = [qtn.value];
          generalData[qtn.id] = qtn.value || '';
          if (qtn.value && qtn.question_type == "general") {
            generalQuesAns.push({
              'id': qtn.id,
              'ques': qtn.question,
              'ans': qtn.valueArray
            })
            generalAns.push({
              questions: qtn
            });
          }
        });
        this.generalQuesAns = generalQuesAns;
      }
      if (this.usersQuestionsInfo && this.usersQuestionsInfo.length > 0) {
        this.usersQuestionsInfo.forEach(e => {
          // this.questionsInfo.forEach(qtn => {
          // element.userQuestions.forEach(e => {
          const data = {};
          quesAns = [];
          e.questions.forEach(qtn => {
            if (qtn.option_type == "checkbox") {
              let selectedCheck = qtn.options.filter(a => a.value == true);
              if (qtn.is_mandatory == 1 && (!selectedCheck || selectedCheck.length == 0) && isCheckedChecked) {
                isCheckedChecked = false;
              }

              if (selectedCheck && selectedCheck.length != 0) {
                qtn.value = qtn.options.filter(op => op.value == true).map(op => op.option).toString();
                qtn.valueArray = qtn.options.filter(op => op.value == true).map(op => op.option);
              }
            } else {
              if (qtn.is_mandatory == 1 && !qtn.value && isCheckedChecked) {
                isCheckedChecked = false;
              }
              qtn.valueArray = [qtn.value];
            }

            data[qtn.id] = qtn.value || '';
            if (qtn.value) {
              quesAns.push({
                'id': qtn.id,
                'ques': qtn.question,
                'ans': qtn.valueArray
              })
            }
          });
          if (quesAns) {
            usersAnswer.push({
              user_id: e.user_id, name: e.user_id, email: e.email, questions: data, quesAns: quesAns, ticket_id: e.ticket_id
            });
          }

          // });

        });
      }
      if (!isCheckedChecked || !ansMandtory) {
        this.generalQuesAns = [];
        this.selectedQuestionsData = [];
        // this.toastr.error('Please answer all mandatory questions');
        return;
      }
      this.selectedQuestionsData = usersAnswer;
      this.hasUserInfo = true;
      this.questionsData = false;
      // if(this.contactInfoForm.valid){
      // this.buildBillingForm();
      // this.buildShippingForm();
      // }
      // } else {
      //   this.toastr.error('Please answer all mandatory questions');
      // }
    }
    // else if (isMandatory) {
    //   this.toastr.error('Please answer all mandatory questions');
    // }
  }

  preventLeadingSpace(event: KeyboardEvent, qtn: any): void {
    if (event.key === ' ' && (!qtn.value || qtn.value.trim() === '')) {
      event.preventDefault(); 
    }
  }
 
  questionsInfo: any = [];
  usersQuestionsInfo: any = [];
  contactTicketsList: any = [];
  sameAnswer: boolean = true;
  questionsRes: any = [];
  generalQuestions: any = [];
  mandatoryQues: any = [];
  getQuestionsByEventId() {
    if (this.settingsJSON.questionnaire == 1) {
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`
        },
        response: true,
        body: {}
      }
      let url = CONST_AWS_API.GET_QUESTIONS_BY_EVENT_ID + '/' + this.streamInfo.id;
      this.loader.start();
      AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
        this.loader.stop();
        if (response.status == 200) {
          let questionsInfo = response['data']['Data'];
          this.questionsRes = response['data']['Data'];
          this.questionsInfo = [];
          if (questionsInfo && questionsInfo.length > 0) {
            questionsInfo.forEach(element => {
              if (element.options)
                element.options = JSON.parse(element.options);

              if (element.option_type == "checkbox") {
                element.options = element.options || [];
                element.options.forEach(e1 => {
                  e1.value = false;
                });
              }

              this.questionsInfo.push(element);
              this.generalQuestions = [];
              this.mandatoryQues = [];
              this.selectedTicketsData.forEach(e => {
                if (element.ticket_id == e.id)
                  this.selectedTicketQuestions.push(element);
              });
            });
          }
          this.questionsData = true;
          // this.buildBillingForm();
          // this.buildShippingForm();
          this.usersQuestionsInfo = [];
          if (this.questionsInfo && this.questionsInfo.length > 0) {
            this.contactTicketsList = this.contactInfoForm.getRawValue().contactTicketList;
            // this.contactTicketsList.forEach(e1 => {
            //   e1.contactList.forEach(ele => {
            //     this.selectedTicketsData.forEach(e => {
            //       if (ele.ticket_id == e.id) {
            //         e1.ticket_id= e.id;
            //           e1.ticket_name= e.title;
            //           e1.ticket_detail= e
            //       }
            //     });
            //   });
            // });
            this.contactTicketsList.forEach(e1 => {
              this.getNonRegTicketData.forEach(result => {
                e1.contactList = [...new Map(e1.contactList.map(item =>
                  [item['user_email'], item])).values()];
                e1.contactList.forEach(e2 => {
                  if (e2.user_email == result.user.email) {
                    let questions = [];
                    this.questionsInfo.forEach(e3 => {
                      if (e1.ticket_id == e3.ticket_id) {
                        e1.selectedTicketQues = true;
                        questions.push(e3);
                      }
                      // this.selectedTicketsData.forEach(e => {
                      if ((e3.is_mandatory == 1 && (e1.ticket_id == e3.ticket_id)) || (e3.is_mandatory == 1 && e3.question_type == "general"))
                        this.mandatoryQues.push(e3);
                      // });
                      if (e3.question_type == "general")
                        this.generalQuestions.push(e3);
                      this.generalQuestions = [...new Map(this.generalQuestions.map(ques =>
                        [ques['id'], ques])).values()];
                    });
                    if ((result.ticketIDs && !result.ticketIDs.includes(e1.ticket_id))) {
                      // if (this.usersQuestionsInfo.length < e1.ticket_detail.selectedOption) {
                      if (e1.selectedTicketQues) {
                        this.usersQuestionsInfo.push({
                          user_id: e2.id, name: e2.user_first_name + " " + e2.user_last_name, email: e2.user_email, ticket_name: e1.ticket_name, ticket_id: e1.ticket_id,
                          questions: JSON.parse(JSON.stringify(questions))
                        });
                      }
                    } else {
                      if (e1.selectedTicketQues) {
                        this.usersQuestionsInfo.push({
                          user_id: e2.id, name: e2.user_first_name + " " + e2.user_last_name, email: e2.user_email, ticket_name: e1.ticket_name, ticket_id: e1.ticket_id,
                          questions: JSON.parse(JSON.stringify(questions))
                        });
                      }
                    }
                  }
                });
              });
            });
            if (this.getNonRegTicketData.length == 0) {
              this.generalQuestions = [];
              this.mandatoryQues = [];
            }
          } else {
            this.questionsData = false;
          }
          if (this.usersQuestionsInfo && this.usersQuestionsInfo.length == 0 && this.generalQuestions.length == 0) {
            this.hasUserInfo = true;
            this.questionsData = false;
          }
          this.isSelectedTicket = true;
        }
      }, error => {
        console.log(error);
      })
    } else {
      this.hasUserInfo = true;
      this.questionsData = false;
    }
  }

  selectedTicketQuestions: any = [];
  filterQuestions() {

    // this.ticketsArr = this.contactInfoForm.getRawValue().contactTicketList;
    this.contactTicketsList.forEach(e1 => {
      e1.contactList.forEach(e2 => {
        let questions = [];
        this.questionsInfo.forEach(e3 => {
          if (e3.question_type == "general") {
            e1.selectedTicketQues = true;
            questions.push(e3);
          } else if (e1.ticket_id == e3.ticket_id) {
            e1.selectedTicketQues = true;
            questions.push(e3);
          }
        });
        for (let i = 0; i < e1.ticket_detail.selectedOption; i++) {
          if (e1.selectedTicketQues) {
            this.usersQuestionsInfo.push({
              user_id: e2.id, name: e2.user_first_name + " " + e2.user_last_name, email: e2.user_email, ticket_name: e1.ticket_name, isSelected: i == 0 ? true : false, ticket_id: e1.ticket_id,
              questions: JSON.parse(JSON.stringify(questions))
            });
          }
        }

        // if (this.usersQuestionsInfo.length < e1.ticket_detail.selectedOption) {
        // }
        // this.usersQuestionsInfo = [...new Map(this.usersQuestionsInfo.map(item =>
        //   [item['user_id'], item])).values()];
      });
    });
    this.groupByEmail();
  }

  groupByEmail() {
    //  const sorted = stages.sort((a, b) => a.sessionDate > b.sessionDate ? 1 : -1);
    const grouped = this.usersQuestionsInfo.reduce((groups, stage) => {
      const pos = stage.ticket_name;
      groups[pos] = groups[pos] || [];
      groups[pos].push(stage);

      return groups;
    }, {});

    this.usersQuestionsInfo = Object.keys(grouped).map(key => ({ ticket_name: key, userQuestions: grouped[key] }));
  }

  promoCode: any;
  isDiscountApplied: boolean = false;

  // onInput(event) {
  //   event.target.value = event.target.value.toUpperCase();
  // }
  hideCode: boolean = false;
  verifyCode(from, type?) {
    if (this.promoCode == '' || this.promoCode == undefined) {
      this.toastr.error("Please enter promo code");
      return;
    }
    if (this.priceDetails.subscription_status == true && from == 'promocode' && this.route.snapshot.queryParams.churn != 'yes') {
      this.toastr.error('Code is not applicable as you have already subscribed');
      return;
    }
    if (this.priceDetails.subscription_status == true && this.route.snapshot.queryParams.churn != 'yes') {
      return;
    }
    let url = CONST_AWS_API.VERIFY_CODE;
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        'stream_id': this.streamInfo.id,
        'code': this.promoCode.toUpperCase()
      }
    }
    AWS_API.post(environment.AWS_Cognito.apiName, url, data).then(response => {
      // if (this.promoCode == this.route.snapshot.queryParams.ref) {
      //   if (response.status == 200 && response['data']['message'] != "Success") {
      //     this.hideCode = true;
      //     return
      //   }
      // }
      if (response.status == 200 && response['data']['message'] == "Success") {
        let discountInfo = response['data']['Data'][0] || {};
        let noOfTicket = 0;
        if (from == "promocode" && discountInfo && discountInfo.ticket_ids && discountInfo.ticket_ids.length == 0 && discountInfo.tickets_count) {
          let count = Number(discountInfo.tickets_count);
          let ticketCount = 0;
          if (count > 0) {
            this.selectedTicketsData.forEach(e => {
              if (e.ticket_type != 'free') {
                ticketCount = ticketCount + parseInt(e.selectedOption)
              }
            });
            if (ticketCount < count && type != 'msg') {
              this.toastr.success("Have to book min " + count + " tickets to applicable for this code");
              this.clearCode();
              return;
            }
          }
        }
        if (from == "promocode" && discountInfo && discountInfo.ticket_ids && discountInfo.ticket_ids.length > 0) {
          let isAvailable = false;
          this.selectedTicketsData.forEach(e => {
            if (discountInfo.ticket_ids.includes(e.id)) {
              isAvailable = true;
              noOfTicket = noOfTicket + parseInt(e.selectedOption)
            }
          });

          if (!isAvailable || (isAvailable && discountInfo.tickets_count > noOfTicket)) {
            this.promoCode = '';
            if (type == 'msg')
              this.clearCode();
            if (isAvailable && discountInfo.tickets_count && type != 'msg') {
              this.toastr.success("Have to book min " + discountInfo.tickets_count + " tickets to applicable for this code");
            } else if (type != 'msg') {
              this.toastr.success('You are not applicable for this promo code');
            }
            return;
          }

        }

        this.codeInfo = response['data']['Data'][0];
        // if (from == "referralcode" && Object.keys(this.route.snapshot.queryParams).length > 0 && discountInfo.referrer && discountInfo.status == 1) {
        //   this.isDiscountApplied = true;
        //   // this.toastr.success('Code applied');
        //   this.finalAmounts(discountInfo, from);
        // } else if ((Object.keys(this.route.snapshot.queryParams).length == 0 || this.getParam('user_id')) && !discountInfo.referrer) {
        if ((Object.keys(this.route.snapshot.queryParams).length == 0 || Object.keys(this.route.snapshot.queryParams).length > 0 || this.getParam('user_id')) && !discountInfo.referrer) {
          this.isDiscountApplied = true;
          if (type != 'msg')
            this.toastr.success('Code applied');
          let isFree = this.selectedTicketsData.filter(a => a.ticket_type == 'free');
          if (isFree.length != this.selectedTicketsData.length)
            this.finalAmounts(discountInfo, from);
        } else {
          this.promoCode = '';
          if (type != 'msg')
            this.toastr.error('Invalid code');
        }
      } else {
        this.promoCode = '';
        this.toastr.error(response['data']['message']);
      }
    }, error => {
      console.log(error);
    })
  }

  clearCode() {
    this.promoCode = '';
    this.isDiscountApplied = false;
    this.totalAmountAfterDiscount = 0;
    this.amount = 0;
    // this.bookingFee = 0;
    this.discountVal = 0;
    this.discountInfo = {};
    this.codeInfo = {};
    this.withoutAddOn = 0;
    this.streamAmountAfterDis = 0;
    this.addOnAfterDis = 0;
    this.liveAmountAfterDis = 0;
    // this.streamData.amount = this.amount = parseFloat(this.finalAmount);
    this.discountTickets = "";
    this.originalAmountSum = 0;
    this.selectedTicketsData.forEach(e => {
      let total = this.profileInfoForm.valid && this.contactInfoForm && this.contactInfoForm.valid ? e.price : e.price * e.selectedOption;
      total = Number(total.toFixed(2));
      this.streamData.amount = this.amount += total;
      if (!e.add_ons) {
        this.withoutAddOn += total;
        this.withoutAddOn = Number(this.withoutAddOn.toFixed(2));
      }
    });
    let isFree = this.selectedTicketsData.filter(a => a.ticket_type == 'free');
    this.streamInfo.stream_payment_mode = 'paid';
    this.streamData.amount = this.amount = Number(this.amount.toFixed(2));
    if (this.streamInfo.booking_fee != 0 && isFree.length != this.selectedTicketsData.length && this.selectedTicketsData.length != this.isAddOnTickets.length) {
      this.bookingFee = this.fee * this.withoutAddOn;
      this.bookingFee = Number(this.bookingFee.toFixed(2));
    }
    this.amountWithBF = this.amount + this.bookingFee + this.shippingCost;
    this.amountWithBF = Number(this.amountWithBF.toFixed(2));
    
    
    this.getTaxPercentage(this.getBillingValue.zip, () => {
      let amt = this.amountWithBF + this.taxAmount
      if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
        this.addOnAmount = this.orgAmount - this.withoutAddOn;
        this.processingFee = (amt * (environment.processing_fee / 100)) + environment.fee_percentage;
        this.processingFee = Number(this.processingFee.toFixed(2));
      }
      // let fees = this.settingsJSON && this.settingsJSON.fee_to_fan == 1 ? this.processingFee : 0;
      let fees = this.settingsJSON && this.settingsJSON.fee_to_fan == 1 && this.selectedTransaction =='ott' ? this.processingFee : 0;
      this.finalAmount = this.taxAmount ? this.amountWithBF + fees + this.taxAmount : this.amountWithBF + fees;
      this.finalAmount = Number(this.finalAmount.toFixed(2));
      let data = {
        "total_amount": this.finalAmount,
        "currency": this.currency,
        "processing_fee": this.processingFee ? this.processingFee : undefined,
        "amt_without_pf": this.amt_without_pf
      }
      this.commonSubscribeService.totalAmountSubject.next(data);
    })
  }

  totalAmountAfterDiscount: any;
  discountVal = 0;
  discountInfo: any = {};
  discountTickets = "";
  originalAmountSum = 0;
  streamAmountAfterDis = 0;
  addOnAfterDis = 0;
  liveAmountAfterDis = 0;
  finalAmounts(discountInfo, from) {
    this.discountTickets = '';
    this.originalAmountSum = this.amount = this.totalAmountAfterDiscount = 0;
    // this.bookingFee = 0;
    this.withoutAddOn = 0;
    this.discountInfo = discountInfo || {};
    let currencyType = discountInfo?.currency_type || 'USD';
    if (this.curExchangeRate != 1){
      this.curExchangeRate = this.rates[this.getCurrency] * 1.025;
    }
    let discount = (discountInfo?.discount_type == 'amount') ? this.curExchangeRate * Number(discountInfo?.discount) : Number(discountInfo?.discount);
    let discountType = discountInfo?.discount_type || 'percentage';
    let streamAmount = 0;
    let liveAmount = 0;
    let addOnAmount = 0;
    this.selectedTicketsData.forEach(ticket => {
      this.ticketsData.forEach(element => {
        if (ticket.id == element.id) {
          if (element.live == 1) {
            liveAmount += element.price;
          }
           else if (ticket.add_ons) {
            addOnAmount += element.price;
          }
           else {
            streamAmount += element.price;
          }
        }
      });
    });
    let disVal = 0;
      if (addOnAmount) {
        disVal = discountType == 'amount' ? discount : addOnAmount * (discount / 100);
        this.addOnAfterDis = addOnAmount - disVal;
        this.addOnAfterDis = this.addOnAfterDis + this.shippingCost;
      }
      if(liveAmount){
        disVal = discountType == 'amount' ? discount : liveAmount * (discount / 100);
        this.liveAmountAfterDis = liveAmount - disVal;
      }
      if(streamAmount){
        disVal = discountType == 'amount' ? discount : streamAmount * (discount / 100);
        this.streamAmountAfterDis = streamAmount - disVal;
      }
    if (from != "promocode" || (!discountInfo.ticket_ids || discountInfo.ticket_ids.length == 0)) {
      this.selectedTicketsData.forEach(e => {
        let total = this.profileInfoForm.valid && this.contactInfoForm && this.contactInfoForm.valid ? e.price : e.price * e.selectedOption;
        this.originalAmountSum += total;
        if (!e.add_ons) {
          this.withoutAddOn += total;
          this.withoutAddOn = Number(this.withoutAddOn.toFixed(2));
        }
      });
      let tickAmt = discountType == 'amount' ? discount : streamAmount * (discount / 100);
      this.streamAmountAfterDis = streamAmount - tickAmt;
      let totalTicktAmt = this.liveAmountAfterDis + this.streamAmountAfterDis;
      this.bookingFee = totalTicktAmt * this.fee;
      this.bookingFee = Number(this.bookingFee.toFixed(2));
      if (discountType == 'percentage' && discount == 100) {
        this.streamInfo.stream_payment_mode = 'free';
        let val = discountType == 'amount' ? discount : this.originalAmountSum * (discount / 100);
        val = Number(val.toFixed(2));
        this.discountVal = val;
        this.amount = this.finalAmount = this.bookingFee = this.amountWithBF = 0;
        return;
      }
      let val = discountType == 'amount' ? discount : this.originalAmountSum * (discount / 100);
      val = Number(val.toFixed(2));
      this.discountVal = val;
      this.streamData.amount = this.amount = this.totalAmountAfterDiscount = Number((this.originalAmountSum - val).toFixed(2));
      this.amountWithBF = this.amount + this.bookingFee + this.shippingCost;
      let amount = Number(this.amountWithBF.toFixed(2));
      let zip = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
      this.getTaxPercentage(zip, () => {
        if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
          let amt = amount + this.taxAmount;
          let calAddAmt = discountType == 'amount' ? discount : this.amount * (discount / 100);
          this.addOnAmount = Number((this.addOnAmount - calAddAmt).toFixed(2));
          this.processingFee = (amt * (environment.processing_fee / 100)) + environment.fee_percentage;
          this.processingFee = Number(this.processingFee.toFixed(2));
        }
        // let fees = this.settingsJSON && this.settingsJSON.fee_to_fan == 1 ? this.processingFee : 0;
        let fees = this.settingsJSON && this.settingsJSON.fee_to_fan == 1 && this.selectedTransaction == 'ott' ? this.processingFee : 0;
        this.finalAmount = amount += fees;
        this.finalAmount = this.taxAmount ? this.finalAmount + this.taxAmount : this.finalAmount;
        this.finalAmount = Number(this.finalAmount.toFixed(2));
        let data = {
          "total_amount": this.finalAmount,
          "currency": this.currency,
          "processing_fee": this.processingFee ? this.processingFee : undefined,
          "amt_without_pf": this.amt_without_pf
        }
        this.commonSubscribeService.totalAmountSubject.next(data);
      });
    } else if (from == "promocode") {

      let totalDiscount = 0;
      // let discount = discountInfo.discount;
      this.amount = 0;
      let liveTickDis = 0;let addonTickDis = 0; let streamTickDis = 0;
      this.selectedTicketsData.forEach(e => {
        let total = this.profileInfoForm.valid && this.contactInfoForm && this.contactInfoForm.valid ? e.price : e.price * e.selectedOption;
        this.originalAmountSum = this.amount += total;
        if (discountInfo.ticket_ids.includes(e.id)) {
          totalDiscount += discountType == 'amount' ? discount : total * (discount / 100);
          this.discountTickets = this.discountTickets + e.title + ", ";
          if (e.live == 1) {
            liveTickDis += discountType == 'amount' ? discount : total * (discount / 100);
          }
           else if (e.add_ons) {
            addonTickDis += discountType == 'amount' ? discount : total * (discount / 100);
          }
           else {
            streamTickDis += discountType == 'amount' ? discount : total * (discount / 100);
          }
        }
        if (addOnAmount) {
          this.addOnAfterDis = addOnAmount - addonTickDis;
          this.addOnAfterDis = this.addOnAfterDis + this.shippingCost;
        }
        if(liveAmount){
          this.liveAmountAfterDis = liveAmount - liveTickDis;
        }
        if(streamAmount){
          this.streamAmountAfterDis = streamAmount - streamTickDis;
          
        }
        let virBF = 0;let liveBF = 0;
        if(this.streamAmountAfterDis){
          virBF = this.streamAmountAfterDis * this.fee;
          virBF = Number(virBF.toFixed(2));
          this.streamAmountAfterDis = this.streamAmountAfterDis + virBF;
        }
        if(this.liveAmountAfterDis){
          liveBF = this.liveAmountAfterDis * this.fee;
          liveBF = Number(liveBF.toFixed(2));
          this.liveAmountAfterDis = this.liveAmountAfterDis + liveBF;
        }
        this.bookingFee = virBF + liveBF;
        if (!e.add_ons) {
          this.withoutAddOn += total;
          this.withoutAddOn = Number(this.withoutAddOn.toFixed(2));
        }
      });
      // let totalTicktAmt = this.liveAmountAfterDis + this.streamAmountAfterDis;
      // this.bookingFee = totalTicktAmt * this.fee;
      // this.bookingFee = Number(this.bookingFee.toFixed(2));
      if (discountType == 'percentage' && discount == 100) {
        this.streamInfo.stream_payment_mode = 'free';
        let val = discountType == 'amount' ? discount : this.originalAmountSum * (discount / 100);
        val = Number(val.toFixed(2));
        this.discountVal = val;
        this.amount = this.finalAmount = this.bookingFee = this.amountWithBF = 0;
        return;
      }
      this.discountTickets = this.discountTickets.replace(/,\s*$/, "");
      this.discountVal = totalDiscount;
      this.streamData.amount = this.amount = this.totalAmountAfterDiscount = Number((this.originalAmountSum - totalDiscount).toFixed(2));
      this.finalAmount = this.amountWithBF = this.amount + this.bookingFee + this.shippingCost;
      if (this.amount == 0) {
        if (discount == 100) {
          this.streamInfo.stream_payment_mode = 'free';
          this.finalAmount = 0;
          this.bookingFee = 0;
          this.amountWithBF = 0;
          return;
        }
      }
      let amount = Number(this.amountWithBF.toFixed(2));
      let zip = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
      this.getTaxPercentage(zip, () => {
        if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
          let amt = this.amountWithBF + this.taxAmount;
          this.addOnAmount = this.orgAmount - this.withoutAddOn;
          let calAddAmt = discountType == 'amount' ? discount : this.addOnAmount * (discount / 100);
          this.addOnAmount = Number((this.addOnAmount - calAddAmt).toFixed(2));
          this.processingFee = (amt * (environment.processing_fee / 100)) + environment.fee_percentage;
          this.processingFee = Number(this.processingFee.toFixed(2));
        }
        // let fees = this.settingsJSON && this.settingsJSON.fee_to_fan == 1 ? this.processingFee : 0;
        let fees = this.settingsJSON && this.settingsJSON.fee_to_fan == 1 && this.selectedTransaction == 'ott'? this.processingFee : 0;
        this.finalAmount = amount += fees;
        this.finalAmount = this.taxAmount ? this.finalAmount + this.taxAmount : this.finalAmount;
        this.finalAmount = Number(this.finalAmount.toFixed(2));
        let data = {
          "total_amount": this.finalAmount,
          "currency": this.currency,
          "processing_fee": this.processingFee ? this.processingFee : undefined,
          "amt_without_pf": this.amt_without_pf
        }
        this.commonSubscribeService.totalAmountSubject.next(data);
      });
    }

  }

  getCheckout() {
    this.router.navigateByUrl('/event/checkout');
  }

  prepare() {
    if (this.currentLocation) {
      this.countriesList.forEach(country => {
        if (country.alpha2code == this.currentLocation.country_code2) {
          this.countryChanged = false
          this.selectedCountry = country.alpha2code;
          this.billingForm.patchValue({
            country: country
          });
          this.shippingForm.patchValue({
            country: country
          });
          this.options = {
            types: [],
            componentRestrictions: { country: country.alpha2code }
          };
          this.checkState(country);
          setTimeout(() => { this.countryChanged = true });
        }
      });
    }
    this.userInfo = JSON.parse(JSON.stringify(this.commonSubscribeService.userInfo));
    // if (this.streamInfo.stream_payment_mode == 'paid') {
    //   // this.streamInfo.stream_amounts = tempTicketType;
    //   let result = this.commonSubscribeService.getAmount(this.streamInfo, this.currentLocation, this.IsUserSubscribe,this.ticketsData);
    //   // if (result && result.current) {
    //   //   this.amount = result.current.price;
    //   //   this.currencyType = result.current.currency;
    //   //   this.priceChangeDate = result.priceChangeDate;
    //   // } else {
    //   //   let message = result.message || 'Something went wrong';
    //   //   this.toastr.error(message);
    //   // }
    //   if (result && result.currectDatesAmounts && result.currectDatesAmounts.length > 0) {
    //     this.currectDatesAmounts = result.currectDatesAmounts;
    //   } else {
    //     let message = result.message || 'Something went wrong';
    //     this.toastr.error(message);
    //   }
    // } else {
    //   this.isSelectedTicket = true;
    // }
    this.getPaymentDetails(this.streamInfo);
    let dateTime = this.commonSubscribeService.getStreamDate(this.streamInfo);
    this.streamInfo.date = dateTime.date;
    this.streamInfo.time = dateTime.time;
    // this.paymentData = this.commonSubscribeService.paymentInfo;

  }

  buildBillingForm() {
    this.billingForm = this.formBuilder.group({
      address1: ['', Validators.required],
      address2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', [Validators.required, ValidationService.autoCompleteValueSelected(COUNTRIES_LIST, 'name')]],
      zip: ['', Validators.required],
    });
    if ((this.profileInfoForm && this.profileInfoForm.invalid) || (this.contactInfoForm && this.contactInfoForm.invalid)) {
      this.billingForm.disable();
    }
    // this.isStateOptional = false;
    // this.billingForm.valueChanges.subscribe(val => {
    //   if (val.country && val.country.toLowerCase() == 'united kingdom' && !this.isStateOptional) {
    //     this.isStateOptional = true;
    //     this.billingForm.get("state").setValidators([]);
    //     this.billingForm.get("state").updateValueAndValidity();
    //   }
    // });
  }

  buildShippingForm() {
    this.shippingForm = this.formBuilder.group({
      address1: ['', Validators.required],
      address2: [''],
      city: ['', Validators.required],
      state: ['', Validators.required],
      country: ['', [Validators.required, ValidationService.autoCompleteValueSelected(this.shippingCountriesList, 'name')]],
      zip: ['', Validators.required],
      phone_number: ['', [Validators.required]]
    });
    if (this.currentLocation) {
      this.countriesList.forEach(country => {
        if (country.alpha2code == this.currentLocation.country_code2) {
          this.countryChanged = false
          this.selectedCountry = country.alpha2code;
          // this.billingForm.patchValue({
          //   country: country
          // });
          this.shippingForm.patchValue({
            country: country
          });
          this.options = {
            types: [],
            componentRestrictions: { country: country.alpha2code }
          };
          this.checkState(country);
          setTimeout(() => { this.countryChanged = true });
        }
      });
    }
  }

  billingFormLat: any;
  billingFormLong: any;
  shippingFormLong: any;
  shippingFormLat: any;
  getSelectedAddress(val, formType?) {
    var myAddress = {
      name: '',
      address1: '',
      address2: '',
      city: '',
      state: '',
      country: '',
      zip: '',
      copy: false
    };
    let street = val && val.formatted_address ? val.formatted_address.split(',') : val.split(',');
    this.address = street[0];
    this.loader.start();
    if (val && val.formatted_address)
      val = val.formatted_address
    else
      val = this.pastedText;
    myAddress.address1 = this.address;
    if (val) {
      this.commonSubscribeService.getAddress(val, (result) => {
        this.loader.stop();
        if (result) {
          let place = {
            address_components: result['results'][0]['address_components'],
            geometry: result['results'][0].geometry
          }
          if (place && place.geometry.location.lat && formType == 'billingForm') {
            this.billingFormLat = place.geometry.location.lat;
            this.billingFormLong = place.geometry.location.lng;
          } else if (place && place.geometry.location.lat && formType == 'shippingForm') {
            this.shippingFormLat = place.geometry.location.lat;
            this.shippingFormLong = place.geometry.location.lng;
          }
          if (place && place.address_components) {
            place.address_components.forEach(element => {
              if ((element.types[0] == "sublocality_level_1" || element.types[0] == "premise") && element.long_name)
                myAddress.address2 = element.long_name;

              if ((element.types[0] == "locality" || element.types[0] == "postal_town") && element.long_name)
                myAddress.city = element.long_name;
              if ((element.types[0] == "administrative_area_level_1" || element.types[0] == "administrative_area_level_2") && element.long_name)
                myAddress.state = element.long_name;
              if (element.types[0] == "country" && element.long_name)
                myAddress.country = element.long_name;
              if (element.types[0] == "postal_code" && element.long_name)
                myAddress.zip = element.long_name;
            });
          }
          let country = myAddress.country && val ? COUNTRIES_LIST.find(c => c.name === myAddress.country) : COUNTRIES_LIST.find(c => c.name === myAddress.country);
          if (country.alpha2code != this.currentLocation.country_code2 && formType == 'shippingForm') {
            this.toastr.error("Shipping is not available in your region");
            this.buildShippingForm();
            return;
          }
          this.getBillingAddress(myAddress, formType);
        }
      });
      // }).catch((error)=>{
      //   this.loader.stop();
      // });
    }
  }

  getBillingAddress(myAddress, formType, val?) {
    let formVal = formType == 'billingForm' ? this.billingForm : this.shippingForm;
    let country = myAddress.country && val ? COUNTRIES_LIST.find(c => c.name === myAddress.country.name) : COUNTRIES_LIST.find(c => c.name === myAddress.country);
    formVal.patchValue({
      address1: myAddress.address1 ? myAddress.address1 : this.address,
      address2: myAddress.address2,
      city: myAddress.city,
      state: myAddress.state,
      country: country ? country : {},
      zip: myAddress.zip
    });
    if (this.sameBillingAddress) {
      this.billingFormLat = this.shippingFormLat;
      this.billingFormLong = this.shippingFormLong;
    }
    if (this.billingForm.valid) {
      this.proceed();
    }
  }

  sameBillingAddress = false;
  populateBillingAddress(event) {
    if (event.checked)
      this.sameBillingAddress = true;
    else
      this.sameBillingAddress = false;
    if (event.checked)
      this.getBillingAddress(this.shippingForm.value, 'billingForm', true);
    else
      this.buildBillingForm();
    // this.billingForm.patchValue({
    //   address1: myAddress.address1 ? myAddress.address1 : this.address,
    //   address2: myAddress.address2,
    //   city: myAddress.city,
    //   state: myAddress.state,
    //   country: myAddress.country ? COUNTRIES_LIST.find(c => c.name === myAddress.country) : {},
    //   zip: myAddress.zip
    // });
  }

  setCountry(e: any) {
    if (e.target.value) {
      this.countryChanged = false;
      let selectCountryInfo = this.countriesList.find(c => c.name.toLowerCase() === e.target.value.toLowerCase());
      this.billingForm.get('country').setValue(selectCountryInfo);
      if (selectCountryInfo && selectCountryInfo.alpha2code) {
        this.countryChanged = false;
        this.options = {
          types: [],
          componentRestrictions: { country: selectCountryInfo.alpha2code }
        };
        setTimeout(() => { this.countryChanged = true });
      }
    }
  }
  onPasteLocation(event: ClipboardEvent,formType) {
    let clipboardData = event.clipboardData || window.clipboardData;
    this.pastedText = clipboardData.getData('text');
    this.getSelectedAddress(this.pastedText,formType);
  }

  get getBillingValue() {
    return this.billingForm.getRawValue();
  }

  get getShippingValue() {
    return this.shippingForm.getRawValue();
  }

  buildCCForm() {
    this.ccForm = this.formBuilder.group({
      nameOnCard: ["", Validators.required],
      cardNumber: ["", Validators.required],
      expDate: ["", Validators.required],
      cvv: ["", Validators.required],
      month: [""],
      year: [""]
    });

    // this.ccForm.valueChanges.subscribe(val => {
    //   if (val.zip && this.currency == 'USD') {
    //     this.getTaxPercentage(val.zip);
    //   }
    // });
  }

  getPaymentDetails(streamInfo) {
    let stream = streamInfo;
    let performer = streamInfo.performer_info;
    let resKey = 'stream';
    let resObj: any = {};
    resObj.stream = {
      id: this.streamInfo.id,
      stream_video_title: stream.stream_video_title,
      organization_id: stream.organization_id,
      amount: this.getAmount,
      currency: stream.currency_type,
      stream_amounts: stream.displayAmounts,
      publish_date_time: stream.originalPublishDate,
      video_thumbnail_image: stream.video_thumbnail_image,
      video_banner_image: stream.video_banner_image,
      performer_id: stream.performer_id,
      user_first_name: stream.user_first_name,
      user_last_name: stream.user_last_name,
      user_display_name: stream.user_display_name,
      channel_name: stream.channel_name,
      number_of_creators: stream.number_of_creators,
      stream_status: stream.stream_status,
      currency_type: stream.currency_type,
      expected_end_date_time: stream.originalExpectedDate,
      slug: this.route.snapshot.params.slug_name,
      selected_type: this.streamInfo.selected_type,
      network_group_id: stream.network_group_id || 0,
    };
    resObj.status = 0;
    resObj.message = "Success";
    resObj.paymentType = this.paymentType;
    resObj.stream_id = this.streamInfo.id;
    this.streamId = resObj.stream_id;
    this.streamData = resObj.stream || {};
    this.paymentType = resObj.paymentType;
    if (this.streamData && this.paymentType == "pay_per_view") {
      this.streamData.amount = this.amount;
      this.streamData.currency = this.currencyType;
      this.finalAmount = this.streamData.amount;
      this.currency = this.currencyType;
    }
    this.buildCCForm();
  }

  getTaxPercentage(zip, callback) {
    // let amount = this.withoutAddOn ? this.withoutAddOn + this.bookingFee : this.amount + this.bookingFee;
    // amount = Number(amount.toFixed(2));
    // if (this.paymentType == 'pay_per_view') {
    //   amount = this.withoutAddOn ? this.withoutAddOn + this.bookingFee : this.amount + this.bookingFee;
    // }
    let streamAmount = 0;
    let liveAmount = 0;
    let addOnAmount = 0;

    this.selectedTicketsData.forEach(ticket => {
      this.ticketsData.forEach(element => {
        if (ticket.id == element.id) {
          if (element.live == 1) {
            liveAmount += element.price
          } else if (ticket.add_ons) {
            addOnAmount += element.price;
          }else {
            streamAmount += element.price;
          }
        }
      });
    });
    //this.fee = this.selectedTransaction == "wallet" ? (this.streamInfo.booking_fee_wallet) / 100 : (this.streamInfo.booking_fee)/100;
    streamAmount = streamAmount + streamAmount * this.fee;
    liveAmount = liveAmount + liveAmount * this.fee;
    // addOnAmount = addOnAmount + addOnAmount * this.fee;
    if (addOnAmount) {
      addOnAmount = addOnAmount + this.shippingCost;
      addOnAmount = Number(addOnAmount.toFixed(2));
    }
    streamAmount = this.streamAmountAfterDis ? Number(this.streamAmountAfterDis.toFixed(2)) : Number(streamAmount.toFixed(2));
    liveAmount = this.liveAmountAfterDis ? Number(this.liveAmountAfterDis.toFixed(2)) : Number(liveAmount.toFixed(2));
    addOnAmount = this.addOnAfterDis? Number(this.addOnAfterDis.toFixed(2)) : Number(addOnAmount.toFixed(2));

    if (this.streamInfo.has_live_tax == 0) {
      liveAmount = 0;
    }

    let shippingzip = this.getShippingValue.zip ? this.getShippingValue.zip : this.selectedShippingAddress && this.selectedShippingAddress.zip ? this.selectedShippingAddress.zip : ""
    let billingZip = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
    if (this.paymentType == 'pay_per_view' && (streamAmount > 0 || liveAmount > 0 || addOnAmount > 0)) {
      let data: any = {
        access_token: this.userInfo.access_token,
        // add_on: addOn.length > 0 ? true : false,
        amount: streamAmount,
        liveAmount: liveAmount,
        addOnAmount: addOnAmount,
        stream_id: this.streamId,
        payment_type: this.paymentType,
        currency: this.currency,
        address: {
          street1: this.getBillingValue.address1,
          city: this.getBillingValue.city,
          state: this.getBillingValue.state,
          state_code: this.codes.state,
          zip: billingZip,
          country: this.getBillingValue.country.name,
          country_code: this.codes.country,
          shippingZip: shippingzip,
          shipping_country_code: this.shippingCodes ? this.shippingCodes.country :""
        }
      };
      // if (data.add_on) {
      //   data.add_on_amount = this.amount - this.withoutAddOn;
      // }
      if (this.streamData.stream_vod == 'vod' || this.streamData.end_date_time) {
        data.vod = true;
      }
      if (this.streamData.vod_video_audio == 'audio') {
        data.vod_video_audio = 'audio';
      }
      if (liveAmount) {
        data.venueAddress = this.settingsJSON.venue_address;
      }
      this.paymentService.calculateTax(data, (result) => {
        if (result.status == 0) {
          this.taxPercentage = result.data.taxPercentage;
          this.taxAmount = result.data.tax;
          if(result.data.tax){
            this.taxAmount = Number(this.taxAmount.toFixed(2));
          }
          this.finalAmount = result.data.finalAmount;
          this.amt_without_pf = this.finalAmount = this.amountWithBF + this.taxAmount;
          this.finalAmount = Number(this.finalAmount.toFixed(2));
          this.invoice_id = result.data.invoice_id;
          this.incl = result.data.incl;
          if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
            // this.addOnAmount = this.orgAmount - this.withoutAddOn;
            let amt = this.amountWithBF + this.taxAmount;
            this.processingFee = (amt * (environment.processing_fee / 100)) + environment.fee_percentage;
            this.processingFee = Number(this.processingFee.toFixed(2));
            addOnAmount = this.addOnAmount;
          }
          let data = {
            "total_amount": this.finalAmount,
            "currency": this.currency,
            "processing_fee": this.processingFee,
            "amt_without_pf": this.amt_without_pf
          }
          this.commonSubscribeService.totalAmountSubject.next(data);
          if (this.incl)
            this.taxAmount = 0;
          callback();
        } else {
          this.toastr.error('Unable to get tax');
        }
      })
    } else {
      this.taxPercentage = 0;
      this.taxAmount = 0;
      this.finalAmount = this.amountWithBF + this.taxAmount;
      this.finalAmount = Number(this.finalAmount.toFixed(2));
      this.invoice_id = '';
      this.incl = '';
      this.cd.detectChanges();
      callback();
    }
  }

  editAddress() {
    if (this.deviceData == 'web') {
      this.isEdit = !this.isEdit;
      this.billingForm.enable();
    } else {
      document.getElementById('app-tickets').scrollIntoView({ behavior: 'smooth' });
      this.isEdit = !this.isEdit;
      this.billingForm.enable();
    }
  }

  closeForm() {
    const base = this.commonSubscribeService.getChannelBasePath(this.router.url.split("/")[1]);
    if (Object.keys(this.route.snapshot.queryParams).length > 0)
      this.router.navigate([`${base}/event/` + this.route.snapshot.params.slug_name], { queryParams: { ref: this.route.snapshot.queryParams.ref } });
    else
      this.router.navigate([`${base}/event/${this.route.snapshot.params.slug_name}`]);
  }

  isShowT_C: boolean = false;
  showHideTermsAndConditions() {
    this.isShowT_C = !this.isShowT_C;
  }

  checkForm(from?) {
    if (this.profileInfoForm.invalid ) {
      this.toastr.error('Please fill contact information');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.profileInfoForm);
      return;
    }
    if (this.contactInfoForm.invalid  && !this.nftTicketSelected) {
      this.toastr.error(this.hasDuplicateEmailError() ? 'Please give unique email for each attendee' : 'Please fill user information');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.contactInfoForm);
      return;
    }
    if (this.mandatoryQues.length > 0 && this.selectedQuestionsData.length == 0 && this.generalQuesAns.length == 0 && !this.nftTicketSelected) {
      this.toastr.error('Please answer all mandatory questions');
      document.getElementById('questionsData').scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (this.shippingForm.invalid && this.showShippingForm && this.newShippingForm && from != 'card' && Object.keys(this.selectedShippingAddress).length == 0 && !this.nftTicketSelected) {
      this.toastr.error('Please fill shipping information');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.shippingForm);
      return;
    }
    if (this.billingForm.invalid &&  this.amount > 0 &&from != 'card' && (Object.keys(this.selectedBillingAddress).length == 0 && Object.keys(this.selectedCard).length == 0 ) && this.streamInfo.stream_payment_mode == 'paid' && !this.nftTicketSelected ) {
      this.toastr.error('Please fill billing information');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.billingForm);
      return;
    }
    if (Object.keys(this.selectedCard).length == 0 && from == 'card' && this.streamInfo.stream_payment_mode == 'paid' &&  !this.nftTicketSelected) {
      this.toastr.error("Please select card");
      return;
    }
    if (!this.isAgrees) {
      this.toastr.error('Please accept terms and conditions');
      return;
    }
    this.commonSubscribeService.formsValidationSubject.next(true);
    if (from == 'card') {
      this.proceedToCheckout('card');
    }
  }

  registerEvent() {
    if (this.profileInfoForm.invalid) {
      this.toastr.error('Please fill contact information');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.profileInfoForm);
      return;
    }
    if (this.contactInfoForm.invalid) {
      if (this.checkEmail)
        this.checkUser();
      if (!this.checkEmail) {
        this.toastr.error(this.hasDuplicateEmailError() ? 'Please give unique email for each attendee' : 'Please fill user information');
        this.commonSubscribeService.scrollToError();
        this.commonSubscribeService.markFormGroupTouched(this.contactInfoForm);
      }
      return;
    }
    if (this.mandatoryQues.length > 0 && this.selectedQuestionsData.length == 0 && this.generalQuesAns.length == 0) {
      this.toastr.error('Please answer all mandatory questions');
      document.getElementById('questionsData').scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (this.shippingForm.invalid && this.showShippingForm) {
      this.toastr.error('Please fill shipping information');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.shippingForm);
      return;
    }
    if (!this.isAgrees) {
      this.toastr.error('Please accept terms and conditions');
      return;
    }
    // if (this.userInfo.user_phone_number != '') {
    // this.loader.start();
    // this.saveProfile();
    var paymentInfo: any = {};
    let formData = this.contactInfoForm.getRawValue();
    let inputData = this.profileInfoForm.getRawValue();
    inputData.user_email = inputData.user_email.toLowerCase();
    let users: any = []; let usersData;
    let tickets = [];
    formData.contactTicketList.forEach(e1 => {
      e1.contactList.forEach(ele => {
        this.getNonRegTicketData.forEach(res => {
          if (ele.user_email == res.user.email) {
            if (res.ticketIDs && !res.ticketIDs.includes(e1.ticket_id))
              ele.self = 1;
            else
              ele.self = 1;
          } else {
            ele.self = 0;
          }
        });
        if (this.getNonRegTicketData.length == 0) {
          ele.self = 0;
        }
      });
      e1.contactList.forEach(contact => {
        let qArr = [];
        let questions = this.selectedQuestionsData.filter(a => a.email == inputData.user_email && contact.ticket_id == a.ticket_id);
        if (questions && questions.length > 0) {
          questions.forEach(element => {
            qArr = element.quesAns;
          });
        }
        tickets.push({
          'id': e1.ticket_detail.id,
          'for_self': e1.ticket_detail.live == 1 ? undefined : contact.self,
          'limited_tickets': e1.ticket_detail.limited_tickets,
          'name': e1.ticket_detail.title,
          'sessions': e1.ticket_detail.sessions,
          'networking': e1.ticket_detail.networking,
          'live': e1.ticket_detail.live,
          'live_qa': e1.ticket_detail.live_qa,
          'expo': e1.ticket_detail.expo,
          'questions': qArr && contact.user_email == inputData.user_email ? qArr : [],
          'add_ons': e1.ticket_detail.add_ons && e1.ticket_detail.add_ons.length > 0 ? e1.ticket_detail.add_ons : undefined,
          'price':e1.ticket_detail.price,
          'amounts':e1.ticket_detail?.amounts || 0,
          "discountInfo":this.discountInfo,
          "discountTickets":this.discountTickets,
          user: {
            'id': contact.id,
            'first_name': contact.user_first_name,
            'last_name': contact.user_last_name,
            'email': contact.user_email
          }
        });
      })
    });
    var paymentInfo: any = {
      paymentType: this.paymentType,
      payment_type: this.paymentType,
      organization_id: this.streamData ? this.streamData.organization_id : '',
      currency: this.currency || "USD",
      // subscription_id: this.subscriptionInfo.id ? this.subscriptionInfo.id : '',
    }
    paymentInfo.amount = 0;
    paymentInfo.stream_id = this.streamId;
    if (this.questionsInfo && this.questionsInfo.length > 0)
      paymentInfo['questions'] = this.generalQuesAns;
    this.streamData.amount = 0;
    paymentInfo.streamInfo = this.streamData;
    paymentInfo.tickets = tickets;
    paymentInfo.country = this.currentLocation.country_name
    let phnNum = this.getShippingValue.phone_number;
    let num = (phnNum && phnNum.number) ? phnNum.number.replace(/\W+/g, '') : '';
    let dial_code = phnNum && phnNum.dialCode
    if (this.showShippingForm) {
      paymentInfo.shipping_address = {
        street1: this.getShippingValue.address1,
        city: this.getShippingValue.city,
        state: this.getShippingValue.state,
        state_code: this.codes.state,
        zip: this.getShippingValue.zip,
        country: this.getShippingValue.country.name,
        country_code: this.codes.country,
        lat: this.shippingFormLat,
        lng: this.shippingFormLong,
        phone_number: dial_code + num
      };
    }
    if (this.route.snapshot.queryParams.ref && this.refCodeMatched)
      paymentInfo['ref_code'] = this.route.snapshot.queryParams.ref;
    paymentInfo.timezone_offset = new Date().getTimezoneOffset();
    if (this.discountInfo && this.discountInfo.code) {
      paymentInfo['discount_code'] = this.discountInfo.code;
    }
    if(paymentInfo['ref_code']===undefined && localStorage.getItem('affiliateReferralCode') && localStorage.getItem('affiliateReferralCode') != 'undefined'){
      paymentInfo['ref_code']=JSON.parse(localStorage.getItem('affiliateReferralCode') || '""')
    }
    paymentInfo['network_group_id'] = this.streamData.network_group_id || 0;
    this.toggleLoader('');
    let url = API.REGISTER_EVENT + '?NOLOADER';
    this.commonSubscribeService.sendPaymentStatus(true);
    this.appPaymentService.postRequest(url, { paymentInfo: paymentInfo }).subscribe(result => {
      if (result.status == 0) {
        this.storageService.deleteItem('eventInfo');
        this.ticketKey = result.ticket_key;
        this.getMobileUrls(this.ticketKey, paymentInfo.tickets);
        this.showOverlay = false;
        if (this.isBookingFrom == "mobile") {
          this.mobilePaymentSuccess();
        } else {
          this.openDialog(result.ticket_key, paymentInfo.tickets);
        }
        this.toggleLoader('none');
        this.commonSubscribeService.sendPaymentStatus(false);
      } else {
        this.showOverlay = false;
        this.commonSubscribeService.sendPaymentStatus(false);
        this.toastr.error(result.message);
      }
      let deviceInfo=this.commonSubscribeService.getMobileOperatingSystem();
      if (deviceInfo==='android' || deviceInfo==='ios') {
      history.pushState(null, '');
      fromEvent(window, 'popstate')
        .pipe(takeUntil(this.unsubscriber))
        .subscribe((_) => {
          history.pushState(null, '');
          this.openDialog(result.ticket_key, paymentInfo.tickets);
      });
      }
      this.toggleLoader('none');
    }, error => {
      this.toggleLoader('none');
      this.showOverlay = false;
      this.commonSubscribeService.sendPaymentStatus(false);
      this.toastr.error(error.error);
    });
    // }
  }

  saveProfile() {
    if (this.profileInfoForm.valid) {
      let inputData = this.profileInfoForm.getRawValue();
      inputData.user_email = inputData.user_email.toLowerCase();
      // let birthdate = moment(inputData.date_of_birth).format("YYYY-MM-DD")
      let date = new Date();
      date.setFullYear(date.getFullYear() - parseInt(inputData.date_of_birth));
      let birthdate = moment((date.getMonth() + 1) + '/' + (date.getDate()) + '/' + (date.getFullYear())).format("YYYY-MM-DD");
      let data = {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": environment.AWS_Cognito.X_Api_Key,
          "Authorization": `Bearer ${this.userInfo.access_token}`
        },
        response: true,
        body: {
          "user_first_name": inputData.user_first_name,
          "user_last_name": inputData.user_last_name,
          "profile_pic": this.userInfo.profile_pic,
          "user_email": inputData.user_email,
          // "user_phone_number": inputData.user_phone_number,
          "date_of_birth": birthdate,
          "user_id": this.userInfo.id,
          "user_display_name": this.userInfo.user_display_name
        }
      }
      AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.UPDATE_PROFILE, data).then(response => {
        this.loader.stop();
        if (response.data.message == 'success') {
          this.OL_saveProfile(data.body);
        }
      }).catch(error => {
        this.loader.stop();
      });
    }
  }

  OL_saveProfile(data) {
    let reqData = {
      firstname: data.user_first_name,
      lastname: data.user_last_name,
      phone: data.user_phone_number,
      organization_id: this.organizationId,
      custom_attributes: {
        date_of_birth: data.date_of_birth,
        profile_pic: data.profile_pic,
        user_display_name: data.user_display_name
      }
    }
    this.loader.start();
    this.appService.postRequest(API.UPDATE_USER_INFO,reqData).subscribe(result => {
      this.getUser();
      this.loader.stop();
    }, error => {
      this.loader.stop();
    });
  }

  getUser() {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {
        // email: this.profileData.email,
        // user_id: this.userInfo.id
      }
    }
    this.loader.start();
    AWS_API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.GET_USER, myInit).then(response => {
      this.loader.stop();
      let userInfo = response.data.user;
      userInfo.signedIn = true;
      userInfo.access_token = userInfo.session_token;
      // if (userInfo && userInfo.user_phone_number && userInfo.date_of_birth
      //   && userInfo.user_display_name) {
      userInfo.is_profile_completed = true;
      // } else {
      //   userInfo.is_profile_completed = false;
      // }
      this.commonSubscribeService.sendUserInfo(userInfo);
    }).catch(error => {
      this.loader.stop();
    });
  }

  selectedTabValue = 'Credit/Debit Card';
  tabIndexVal = 0;
  tabClick(tab) {
    if (tab && tab.tab && tab.tab.textLabel) {
      this.selectedTabValue = tab.tab.textLabel;
    }
    if (tab.tab.textLabel == 'Credit/Debit Card' && (this.profileInfoForm.invalid || this.contactInfoForm.invalid || (this.mandatoryQues.length > 0 && this.selectedQuestionsData.length == 0 && this.generalQuesAns.length == 0) || this.billingForm.invalid || (this.shippingForm.invalid && this.showShippingForm) || (!this.isAgrees))) {
      this.checkForm();
      this.tabIndexVal = 0;
      return;
    }
    // if (this.currency == 'USD' && tab.tab.textLabel == 'Credit/Debit Card')
    //   this.proceed();
  }

  labelText = 'Enter promo code';
  addOnAmount = 0;
  proceed(from?) {
    // if(this.totalAmountAfterDiscount)
    //   this.amount = this.totalAmountAfterDiscount;
    // if (this.shippingForm.invalid && this.selectedTicket && this.selectedTicket.shipping_address == 1)
    //   this.toastr.error('Please enter complete shipping address');
    // if (this.billingForm.invalid)
    //   this.toastr.error('Please enter complete billing address');
    this.commonSubscribeService.billingInfoSubject.next(this.getBillingValue);
    if (from == 'card') {
      this.checkForm('card');
    } else {
      this.proceedToCheckout();
    }
  }

  proceedToCheckout(from?) {
    if (this.billingForm.valid || (from == 'card' && this.selectedCard && this.selectedCard.id)) {

      // this.validateZip((valid) => {
      let country;
      if (this.selectedCard && this.selectedCard.id) {
        COUNTRIES_LIST.forEach(element => {
          if (element.alpha2code == this.selectedCard.billing_address.country) {
            country = element;
          }
        });
      }
      let shippingzip = this.getShippingValue.zip ? this.getShippingValue.zip : this.selectedShippingAddress && this.selectedShippingAddress.zip ? this.selectedShippingAddress.zip : ""
      let newShipCountry = this.getShippingValue.country.name ? this.getShippingValue.country.name : "";
      let shippingCountry = this.selectedShippingAddress && this.selectedShippingAddress.country ? this.selectedShippingAddress.country : newShipCountry ;
      if (shippingzip) {
        this.commonSubscribeService.validateZip(shippingzip, shippingCountry, (result) => {
          if (result.status) {
            this.shippingCodes = result;
            let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.shippingCodes.country);
            this.shippingCodes.country = country[0].alpha3code;
          }
          else {
            this.toastr.error('Invalid zip code');
          }
        });
      }
      let zip = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : ""
      let newBillCountry =  this.getBillingValue && this.getBillingValue.country.name ? this.getBillingValue.country.name : "";
      let cName = (this.selectedBillingAddress && this.selectedBillingAddress.country) || country ? country.name ? country.name : this.selectedBillingAddress.country : newBillCountry;
      this.commonSubscribeService.validateZip(zip, cName, (result) => {
        if (result.status) {
          // this.isEdit = !this.isEdit;
          // this.billingForm.disable();
          // this.shippingForm.disable();
          this.codes = result;
          let country = COUNTRIES_LIST.filter(country => country.alpha2code == this.codes.country)
          this.codes.country = country[0].alpha3code;
          this.getTaxPercentage(zip, () => {
            this.showCCForm = true;
            if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
              let totalPrice = 0;
              this.selectedTicketsData.forEach(e => {
                totalPrice += e.price;
                totalPrice = Number(totalPrice.toFixed(2));
              });
              this.amountWithBF = Number(this.amountWithBF.toFixed(2));
              this.finalAmount = this.amountWithBF + this.taxAmount;
              this.finalAmount = Number(this.finalAmount.toFixed(2));
              this.processingFee = (this.finalAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
              this.processingFee = Number(this.processingFee.toFixed(2));
              //added processing fee only for ott
              if(this.selectedTransaction =='ott'){
                this.finalAmount = this.finalAmount + this.processingFee;
              }
              this.finalAmount = Number(this.finalAmount.toFixed(2));
            } else {
              // let bookingFee = parseFloat(this.bookingFee.toFixed(2));
              this.bookingFee = 0; this.totalAddOnAmount = 0;
              let isFree = [];
              isFree = this.selectedTicketsData.filter(a => a.ticket_type == 'free');
              // this.totalAddOnAmount = this.amount - this.withoutAddOn;
              this.finalAmount = this.finalAmount + this.taxAmount;
              if (this.selectedTicketsData.length != isFree.length) {
                if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
                  this.addOnAmount = this.orgAmount - this.withoutAddOn;
                  this.processingFee = (this.finalAmount * (environment.processing_fee / 100)) + environment.fee_percentage;
                  this.processingFee = Number(this.processingFee.toFixed(2));
                }
                this.bookingFee = this.fee * this.amount;
                // if(this.paidAddOnTickets.length > 0)
                //   this.bookingFee = this.bookingFee + (this.totalAddOnAmount * (2.9 / 100)) + 0.3;
                this.bookingFee = Number(this.bookingFee.toFixed(2));
              }
              this.finalAmount = this.amountWithBF + this.taxAmount;
               //added processing fee only for ott
              if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1 && this.selectedTransaction =='ott')
                this.finalAmount = this.finalAmount + this.processingFee;
              this.finalAmount = Number(this.finalAmount.toFixed(2));
            }
            let data = {
              "total_amount": this.finalAmount,
              "currency": this.currency,
              "processing_fee": this.processingFee,
              "amt_without_pf": this.amt_without_pf
            }
            this.commonSubscribeService.totalAmountSubject.next(data);
            if (this.isAgrees) {
              this.commonSubscribeService.formsValidationSubject.next(true);
            }
          });
        } else {
          this.toastr.error('Invalid zip code');
        }
      });
    } else if (from == 'card' && !this.selectedCard) {
      this.toastr.error("Please select card");
    }
  }

  async makePayment(from?) {
    if (this.profileInfoForm.invalid) {
      this.toastr.error('Please fill contact information');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.profileInfoForm);
      return;
    }
    if (this.contactInfoForm.invalid && !this.nftTicketSelected) {
      if (this.checkEmail)
        this.checkUser();
      if (!this.checkEmail) {
        this.toastr.error(this.hasDuplicateEmailError() ? 'Please give unique email for each attendee' : 'Please fill user information');
        this.commonSubscribeService.scrollToError();
        this.commonSubscribeService.markFormGroupTouched(this.contactInfoForm);
      }
      return;
    }
    if (this.mandatoryQues.length > 0 && this.selectedQuestionsData.length == 0 && this.generalQuesAns.length == 0 && !this.nftTicketSelected) {
      this.toastr.error('Please answer all mandatory questions');
      document.getElementById('questionsData').scrollIntoView({ behavior: 'smooth' });
      return;
    }
    if (this.shippingForm.invalid && this.showShippingForm && this.newShippingForm && from != 'card' && !this.selectedShippingAddress && !this.nftTicketSelected) {
      this.toastr.error('Please fill shipping information');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.shippingForm);
      return;
    }
    if (this.billingForm.invalid && (Object.keys(this.selectedCard).length == 0 && (this.selectedBillingAddress && Object.keys(this.selectedBillingAddress).length == 0) && !this.nftTicketSelected)) {
      this.toastr.error('Please fill billing information');
      this.commonSubscribeService.scrollToError();
      this.commonSubscribeService.markFormGroupTouched(this.billingForm);
      return;
    }
    if (!this.isAgrees) {
      this.toastr.error('Please accept terms and conditions');
      return;
    }
    try { fbq('track', 'StripePay'); } catch (e) { }
    let amount, finalAmount, name;
    name = this.userInfo.user_display_name || this.userInfo.display_name
    if (this.paymentType == 'pay_per_view') {
      amount = this.streamData.amount;
      finalAmount = this.finalAmount;
    } else {
      amount = finalAmount = this.finalAmount;
    }
    if ((this.transactionInfo["card"]) || from == 'card' || this.transactionInfo["mode"]) {
      console.log('proceed to make payment',this.streamData);
      let data: any = {
        amount: this.selectedTransaction == "crypto" ? this.crypto_amount : amount,
        finalAmount: this.selectedTransaction == "crypto" ? this.crypto_amount : finalAmount,
        currency: this.transactionInfo.currency ? this.transactionInfo.currency : this.getCurrency.toLowerCase() || 'gbp',
        organization_id: this.streamData.organization_id,
        performer_id: JSON.stringify(this.performerInfo.id),
        stream_id: JSON.stringify(this.streamData.id),
        paymentType: this.paymentType,
        payment_type: this.paymentType,
        response: null,
        transaction_id: '',
        name: name,
        network_group_id: this.streamData.network_group_id ? this.streamData.network_group_id : '',
      };
      console.log(data,'============================');
      let ticketIds = [], ticketIdInv: any = [];
      this.selectedTicketsData.forEach(element => {
        let inv = { 'id': element.id, 'limited_tickets': element.limited_tickets }
        ticketIdInv.push(inv);
        if (element.sessions && element.sessions.length > 0) {
          element.sessions.forEach(e => {
            ticketIds.push(e);
          });
        } else if (!ticketIds.includes(element.event_id)) {
          ticketIds.push(element.event_id);
        }
      });
      data['ticket_ids'] = ticketIds;
      // data['tickets'] = ticketIdInv;
      if (this.questionsInfo && this.questionsInfo.length > 0)
        data['questions'] = this.generalQuesAns;
      console.log(data['ref_code'],'++++++++++++++++++++++++++++++');
      console.log(this.route.snapshot.queryParams.ref,'++++++++++++++++++++++++++++++');
      if (this.route.snapshot.queryParams.ref && this.refCodeMatched)
        data['ref_code'] = this.route.snapshot.queryParams.ref;
      if (this.discountInfo && this.discountInfo.code) {
        data['discount_code'] = this.discountInfo.code;
      }
      data['ref_code'] = this.route.snapshot.queryParams.ref;
      if((data['ref_code']===undefined || data['ref_code']===null || data['ref_code'] === '') && localStorage.getItem('affiliateReferralCode') && localStorage.getItem('affiliateReferralCode') != 'undefined'){
        data['ref_code']=JSON.parse(localStorage.getItem('affiliateReferralCode') || '""')
      }
      data['zip'] = this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : "";
      if (this.paymentType == 'charity_donation' && this.charityInfo) {
        data['toName'] = this.charityInfo.charity_name;
        data['stream_id'] = this.charityInfo.stream_id;
      } else if (this.paymentType == 'performer_tip' && this.performerInfo) {
        data['toName'] = this.performerInfo.performer_name;
      }
      this.streamData.event_id = this.streamId;
      data['guest_id'] = this.performerInfo.guest_id;
      data['invoice_id'] = this.invoice_id;
      data['tax_amount'] = this.taxAmount;
      data['tax_rate'] = this.taxPercentage;
      data['stream_id'] = this.streamId;
      data['streamInfo'] = this.streamData;
      data['country'] = this.getBillingValue.country.name ? this.getBillingValue.country.name : this.selectedBillingAddress && this.selectedBillingAddress.country ? this.selectedBillingAddress.country : "";
      data.ticket_type_name = this.selectedTicket.ticket_type_name;
      data['address'] = {
        street1: this.getBillingValue.address1 ? this.getBillingValue.address1 : this.selectedBillingAddress && this.selectedBillingAddress.line1 ? this.selectedBillingAddress.line1 : "",
        city: this.getBillingValue.city ? this.getBillingValue.city : this.selectedBillingAddress && this.selectedBillingAddress.city ? this.selectedBillingAddress.city : "",
        state: this.getBillingValue.state ? this.getBillingValue.state : this.selectedBillingAddress && this.selectedBillingAddress.state ? this.selectedBillingAddress.state : "",
        state_code: this.codes.state ? this.codes.state : this.selectedBillingAddress && this.selectedBillingAddress.state_code ? this.selectedBillingAddress.state_code : "",
        zip: this.getBillingValue.zip ? this.getBillingValue.zip : this.selectedBillingAddress && this.selectedBillingAddress.zip ? this.selectedBillingAddress.zip : "",
        country: this.getBillingValue.country.name ? this.getBillingValue.country.name : this.selectedBillingAddress && this.selectedBillingAddress.country ? this.selectedBillingAddress.country : "",
        country_code: this.codes.country ? this.codes.country : this.selectedBillingAddress && this.selectedBillingAddress.country_code ? this.selectedBillingAddress.country_code : "",
        lat: this.billingFormLat,
        lng: this.billingFormLong
      };
      if (this.showShippingForm) {
        let phnNum = this.getShippingValue.phone_number;
        let num = (phnNum && phnNum.number) ? phnNum.number.replace(/\W+/g, '') : '';
        let dial_code = phnNum && phnNum.dialCode;
        let selShipNum = this.selectedShippingAddress && this.selectedShippingAddress.mobile ? this.selectedShippingAddress.dial_code + this.selectedShippingAddress.mobile : "";
        data['shipping_address'] = {
          street1: this.getShippingValue.address1 ? this.getShippingValue.address1 : this.selectedShippingAddress && this.selectedShippingAddress.line1 ? this.selectedShippingAddress.line1 : '',
          city: this.getShippingValue.city ? this.getShippingValue.city : this.selectedShippingAddress && this.selectedShippingAddress.city ? this.selectedShippingAddress.city : "",
          state: this.getShippingValue.state ? this.getShippingValue.state : this.selectedShippingAddress && this.selectedShippingAddress.state ? this.selectedShippingAddress.state : "",
          state_code: this.shippingCodes.state ? this.shippingCodes.state : this.selectedShippingAddress && this.selectedShippingAddress.state_code ? this.selectedShippingAddress.state_code : "",
          zip: this.getShippingValue.zip ? this.getShippingValue.zip : this.selectedShippingAddress && this.selectedShippingAddress.zip ? this.selectedShippingAddress.zip : "",
          country: this.getShippingValue.country.name ? this.getShippingValue.country.name : this.selectedShippingAddress && this.selectedShippingAddress.country ? this.selectedShippingAddress.country : "",
          country_code: this.shippingCodes.country ? this.shippingCodes.country : this.selectedShippingAddress && this.selectedShippingAddress.country_code ? this.selectedShippingAddress.country_code : "",
          lat: this.shippingFormLat,
          lng: this.shippingFormLong,
          phone_number: dial_code && num ? dial_code + num : selShipNum
        };
      }
      data['fee_to_fan'] = this.settingsJSON.fee_to_fan;
      data['creator_currency'] = this.streamInfo.currency_type.toLowerCase();
      data['exchange_rate'] = this.exchange_rate;
      if (this.settingsJSON.fee_to_fan == 1) {
        data['processing_fee_amount'] = this.processingFee;
        data['processing_fee_percentage'] = environment.processing_fee;
        data['processing_fee_fixed'] = environment.fee_percentage;
        data['booking_fee'] = this.bookingFee;

      } else {
        data['booking_fee'] = this.bookingFee;
      }
      if (this.streamInfo.stream_payment_mode == 'paid') {
        let formData = this.contactInfoForm.getRawValue();
        let users: any = []; let usersData;
        let tickets = [];
        if (formData && formData.contactTicketList) {
          let inputData = this.profileInfoForm.getRawValue();
          inputData.user_email = inputData.user_email.toLowerCase();
          formData.contactTicketList.forEach(e1 => {
            e1.contactList.forEach(ele => {
              this.getNonRegTicketData.forEach(res => {
                if (ele.user_email == res.user.email) {
                  if (res.ticketIDs && !res.ticketIDs.includes(e1.ticket_id))
                    ele.self = 1;
                  else
                    ele.self = 1;
                } else {
                  ele.self = 0;
                }
              });
              if (this.getNonRegTicketData.length == 0) {
                ele.self = 0;
              }
            });
            e1.contactList.forEach(contact => {
              let qArr = [];
              let questions = this.selectedQuestionsData.filter(a => a.email == inputData.user_email && contact.ticket_id == a.ticket_id);
              if (questions && questions.length > 0) {
                questions.forEach(element => {
                  qArr = element.quesAns;
                });
              }
              tickets.push({
                'id': e1.ticket_detail.id,
                'for_self': e1.ticket_detail.live == 1 ? undefined : contact.self,
                'limited_tickets': e1.ticket_detail.limited_tickets,
                'name': e1.ticket_detail.title,
                'sessions': e1.ticket_detail.sessions,
                'networking': e1.ticket_detail.networking,
                'live': e1.ticket_detail.live,
                'live_qa': e1.ticket_detail.live_qa,
                'expo': e1.ticket_detail.expo,
                'questions': qArr && contact.user_email == inputData.user_email ? qArr : [],
                'add_ons': e1.ticket_detail.add_ons && e1.ticket_detail.add_ons.length > 0 ? e1.ticket_detail.add_ons : undefined,
                'price':e1.ticket_detail.price,
                'amounts':e1.ticket_detail.amounts,
                "discountTickets":this.discountTickets,
                "disccountinfo":this.discountInfo,
                user: {
                  'id': contact.id,
                  'first_name': contact.user_first_name,
                  'last_name': contact.user_last_name,
                  'email': contact.user_email
                }
              });
            })
          });
          data.tickets = tickets;
        }
      }
      if (this.userInfo && !this.userInfo.is_guest) {
        if (this.getBillingValue.address1) {
          data['new_billing'] = {
            "type": 'billing',
            "name": name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
            "line1": this.getBillingValue.address1,
            "line2": this.getBillingValue.address2,
            "city": this.getBillingValue.city,
            "state": this.getBillingValue.state,
            "state_code": this.codes.state,
            "country": this.getBillingValue.country.name,
            "country_code": this.codes.country,
            "zip": this.getBillingValue.zip,
            "remove_default": false,
            "default": false,
            "organization_id": this.streamData?.organization_id || null,
          }
        }
        if (this.getShippingValue.address1 && this.showShippingForm) {
          let phnNum = this.getShippingValue.phone_number;
          let num = (phnNum && phnNum.number) ? phnNum.number.replace(/\W+/g, '') : '';
          let dial_code = phnNum && phnNum.dialCode;
          data['new_shipping'] = {
            "type": 'shipping',
            "name": name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
            "mobile": num,
            "dial_code": dial_code,
            "line1": this.getShippingValue.address1,
            "line2": this.getShippingValue.address2,
            "city": this.getShippingValue.city,
            "state": this.getShippingValue.state,
            "state_code": this.shippingCodes.state,
            "country": this.getShippingValue.country.name,
            "country_code": this.shippingCodes.country,
            "zip": this.getShippingValue.zip,
            "remove_default": false,
            "default": false,
            "organization_id": this.streamData?.organization_id || null,
          }
        }
      }
      this.toggleLoader('');
      data["timezone"] = this.timezoneVal;
      let code;
      if (this.selectedBillingAddress && this.selectedBillingAddress.line1) {
        let cc = this.selectedBillingAddress.country_code ? this.selectedBillingAddress.country_code : this.selectedBillingAddress.country;
        let country = COUNTRIES_LIST.filter(country => (country.alpha3code == cc || country.alpha2code == cc));
        code = country[0]?.alpha2code;
      }
      let billingAddress;
      billingAddress = {
        'line1': data['address'].street1,
        'line2': this.getBillingValue.address2,
        'city': this.getBillingValue.city,
        'state': this.getBillingValue.state,
        'country': this.getBillingValue.country.alpha2code ? this.getBillingValue.country.alpha2code : code ? code : "",
        'postal_code': this.getBillingValue.zip
      }
      let cardInfo = {
        'card': this.card,
        'billing_details': {
          'name': name || this.userInfo.user_first_name + ' ' + this.userInfo.user_last_name,
          'address': billingAddress
        }
      }
      data['card_id'] = this.selectedCard && this.selectedCard.id ? this.selectedCard.id : undefined;
      this.commonSubscribeService.sendPaymentStatus(true);
      data['guest_id'] = this.performerInfo.guest_id;
      data.discount_amount = this.discountVal || 0;
      data.discount_percentage = this.codeInfo.discount || 0;
      data.timezone_offset = new Date().getTimezoneOffset();
      data["timezone"] = this.timezoneVal;
      if (this.transactionInfo['mode'] == 'wallet' || this.transactionInfo["mode"] == 'crypto') {
        this.completeReg(data);
        return;
      }
      let url = API.GET_CLIENT_SECRET + '?NOLOADER';
      
      this.appPaymentService.postRequest(url, data).subscribe(result => {
        if (result['status'] == 0) {
          data.transaction_id = result['transaction_id'];
          // this.loader.start();
          this.transactionInfo.stripe.confirmCardPayment(result['client_secret'], {
            payment_method: Object.keys(this.selectedCard).length > 0 ? this.selectedCard.id : cardInfo,
            setup_future_usage: Object.keys(this.selectedCard).length > 0 ? undefined : 'off_session'
          }).then((result) => {
            // this.loader.stop();
            if (result.error) {
              this.showOverlay = false;
              this.commonSubscribeService.sendPaymentStatus(false);
              // Show error to your customer (e.g., insufficient funds)
              this.toastr.error(result.error.message);
            } else {
              // The payment has been processed!
              if (result.paymentIntent.status === 'succeeded') {
                try { fbq('track', 'StripePaymentSuccess'); } catch (e) { }
                data.response = result.paymentIntent;
                this.completeReg(data);
              }
            }
          });
        } else {
          this.showOverlay = false;
          this.commonSubscribeService.sendPaymentStatus(false);
          try { fbq('track', 'StripeInitFailed'); } catch (e) { }
          this.toastr.error(result.message)
          this.loader.stop();
        }
      }, error => {
        this.toastr.error(error?.error?.message || error?.message || 'Unable to process payment. Please try again.');
        this.showOverlay = false;
        this.commonSubscribeService.sendPaymentStatus(false);
      });
    } else if (!this.cardError) {
      this.cardError = "Please fill all the fields";
    }
  }

  completeReg(data) {
    data.response = this.transactionInfo['paymentIntent'] ? this.transactionInfo['paymentIntent'] : data.response;
    data["payment_gateway"] = this.nftTicketSelected ? 'nft' : this.transactionInfo['mode'] == 'wallet' ? "wallet" : this.transactionInfo['mode'] == 'crypto' ? 'crypto' : undefined;
    data["transaction_amount"] = this.transactionInfo['transaction_amount'];
    data["save_card"] = this.transactionInfo['save_card'];
    data["crypto_wallet_id"] = this.transactionInfo.crypto_wallet_id ? this.transactionInfo.crypto_wallet_id : undefined;
    data['token_id'] = this.transactionInfo.token_id

     //added different tickets count to the payload
     this.selectedTicketsData.forEach(ticket => {
      if (ticket.live === 0) {
        data['virtual_ticket_count'] = ticket.selectedOption;
      } else if (ticket.live === 1) {
        data['in_person_ticket_count'] = ticket.selectedOption;
      } else if (ticket.live === 2) {
        data['add_on_ticket_count'] = ticket.selectedOption;
      }
    });
    let url = API.PAYMENT_SUCCESSS + '?NOLOADER';
    this.appPaymentService.postRequest(url, data).subscribe(result => {
      if (result['message'] == 'Success') {
        this.commonSubscribeService.updateAvailBalSubject.next(true);
        this.showOverlay = false;
        this.commonSubscribeService.sendPaymentStatus(false);
        this.commonSubscribeService.sendTriggeredEvent({
          actionType: "purchase",
          clickAction: "PAYMENT_SUCCESS",
          metaData: {
            amount: data['transaction_amount'],
            eventId: this.streamInfo?.id || null,
            eventName: this.streamInfo?.stream_video_title || null,
            title: `Payment completed successfully`,
            timeStamp: new Date().toISOString()
          },
          organizationId: this.streamInfo?.organization_id || null,
          networkGroupId: this.streamInfo?.network_group_id || null,
        });
        this.storageService.deleteItem('eventInfo');
        this.storageService.deleteItem('isEvent');
        this.ticketKey = result.ticket_key;
        this.getMobileUrls(this.ticketKey, data.tickets);
        if (this.isBookingFrom == "mobile") {
          this.mobilePaymentSuccess();
        } else {
          this.openDialog(result.ticket_key, data.tickets);
          let deviceInfo=this.commonSubscribeService.getMobileOperatingSystem();
              if (deviceInfo==='android' || deviceInfo==='ios') {
              history.pushState(null, '');
              fromEvent(window, 'popstate')
                .pipe(takeUntil(this.unsubscriber))
                .subscribe((_) => {
                  history.pushState(null, '');
                  this.openDialog(result.ticket_key, data.tickets);
            });
      }
        }

        if (this.redirectUrl) {
          // this.router.navigateByUrl(this.redirectUrl);
          // this.redirectToHome();
          this.paymentSuccess = true;
        } else {
          this.isPaymentSuccess = true;
        }
      } else {
        try { fbq('track', 'StripePaymentFailed'); } catch (e) { }
        this.showOverlay = false;
        this.commonSubscribeService.sendPaymentStatus(false);
        this.toastr.error(result['message']);
      }
    });
  }

  completePayment(id, gateway) {
    this.toggleLoader('block');
    this.commonSubscribeService.sendPaymentStatus(true);
    // this.loader.start();
    // this.validateZip((valid) => {
    //   if (valid) {
    let ticketIds = [], ticketIdInv: any = [];
    this.selectedTicketsData.forEach(element => {
      let inv = { 'id': element.id, 'limited_tickets': element.limited_tickets }
      ticketIdInv.push(inv);
      if (element.sessions && element.sessions.length > 0) {
        element.sessions.forEach(e => {
          ticketIds.push(e);
        });
      } else if (!ticketIds.includes(element.event_id)) {
        ticketIds.push(element.event_id);
      }
    });
    var paymentInfo: any = {
      paymentType: this.paymentType,
      payment_type: this.paymentType,
      organization_id: this.streamData ? this.streamData.organization_id : '',
      currency: this.currency || "USD",
      gateway: gateway
      // subscription_id: this.subscriptionInfo.id ? this.subscriptionInfo.id : '',
    }
    paymentInfo.ticket_ids = ticketIds;
    paymentInfo['tickets'] = ticketIdInv;
    if (this.questionsInfo && this.questionsInfo.length > 0)
      paymentInfo['questions'] = this.generalQuesAns;
    if (this.route.snapshot.queryParams.ref && this.refCodeMatched)
      paymentInfo['ref_code'] = this.route.snapshot.queryParams.ref;
    if (this.discountInfo && this.discountInfo.code) {
      paymentInfo['discount_code'] = this.discountInfo.code;
    }
    paymentInfo.amount = this.streamData.amount;
    paymentInfo.stream_id = this.streamId;
    // paymentInfo.finalAmount = this.totalAmountAfterDiscount;
    paymentInfo.finalAmount = this.finalAmount;
    paymentInfo['fee_to_fan'] = this.settingsJSON.fee_to_fan;
    if (this.settingsJSON.fee_to_fan == 1) {
      paymentInfo['processing_fee_amount'] = this.processingFee;
      paymentInfo['processing_fee_percentage'] = environment.processing_fee;
      paymentInfo['processing_fee_fixed'] = environment.fee_percentage;
      paymentInfo['booking_fee'] = this.bookingFee;

    } else {
      paymentInfo['booking_fee'] = this.bookingFee;
    }
    paymentInfo['cardId'] = this.cardId;
    paymentInfo['country'] = this.getBillingValue.country.name;
    paymentInfo['country_code'] = this.currentLocation.country_code2;
    this.streamData.event_id = this.streamId;
    paymentInfo.streamInfo = this.streamData;
    paymentInfo.guest_id = this.performerInfo.guest_id;
    paymentInfo['invoice_id'] = this.invoice_id;
    paymentInfo.cardId = id;
    paymentInfo.tax_amount = this.taxAmount;
    paymentInfo.tax_rate = this.taxPercentage;
    paymentInfo.address = {
      street1: this.getBillingValue.address1,
      city: this.getBillingValue.city,
      state: this.getBillingValue.state,
      state_code: this.codes.state,
      zip: this.getBillingValue.zip,
      country: this.getBillingValue.country.name,
      country_code: this.codes.country,
      lat: this.billingFormLat,
      lng: this.billingFormLong
    };
    if (this.showShippingForm) {
      let phnNum = this.getShippingValue.phone_number;
      let num = (phnNum && phnNum.number) ? phnNum.number.replace(/\W+/g, '') : '';
      let dial_code = phnNum && phnNum.dialCode
      paymentInfo.shipping_address = {
        street1: this.getShippingValue.address1,
        city: this.getShippingValue.city,
        state: this.getShippingValue.state,
        state_code: this.codes.state,
        zip: this.getShippingValue.zip,
        country: this.getShippingValue.country.name,
        country_code: this.codes.country,
        lat: this.shippingFormLat,
        lng: this.shippingFormLong,
        phone_number: dial_code + num
      };
    }
    paymentInfo.ticket_type_name = this.selectedTicket.ticket_type_name;
    paymentInfo['creator_currency'] = this.streamInfo.currency_type.toLowerCase();
    paymentInfo['exchange_rate'] = this.exchange_rate;
    if (this.streamInfo.stream_payment_mode == 'paid') {
      let formData = this.contactInfoForm.getRawValue();
      let inputData = this.profileInfoForm.getRawValue();
      inputData.user_email = inputData.user_email.toLowerCase();
      let users: any = []; let usersData;
      let tickets = [];
      formData.contactTicketList.forEach(e1 => {
        e1.contactList.forEach(ele => {
          this.getNonRegTicketData.forEach(res => {
            if (ele.user_email == res.user.email) {
              if (res.ticketIDs && !res.ticketIDs.includes(e1.ticket_id))
                ele.self = 1;
              else
                ele.self = 1;
            } else {
              ele.self = 0;
            }
          });
          if (this.getNonRegTicketData.length == 0) {
            ele.self = 0;
          }
        });
        e1.contactList.forEach(contact => {
          let qArr = [];
          let questions = this.selectedQuestionsData.filter(a => a.email == inputData.user_email && contact.ticket_id == a.ticket_id);
          if (questions && questions.length > 0) {
            questions.forEach(element => {
              qArr = element.quesAns;
            });
          }
          tickets.push({
            'id': e1.ticket_detail.id,
            'for_self': e1.ticket_detail.live == 1 ? undefined : contact.self,
            'limited_tickets': e1.ticket_detail.limited_tickets,
            'name': e1.ticket_detail.title,
            'sessions': e1.ticket_detail.sessions,
            'networking': e1.ticket_detail.networking,
            'live': e1.ticket_detail.live,
            'live_qa': e1.ticket_detail.live_qa,
            'expo': e1.ticket_detail.expo,
            'questions': qArr && contact.user_email == inputData.user_email ? qArr : [],
            'add_ons': e1.ticket_detail.add_ons && e1.ticket_detail.add_ons.length > 0 ? e1.ticket_detail.add_ons : undefined,
            'price':e1.ticket_detail?.price || 0,
            'amounts':e1.ticket_detail?.amounts || 0,
            "discountTickets":this.discountTickets,
            "disccountinfo":this.discountInfo,
            user: {
              'id': contact.id,
              'first_name': contact.user_first_name,
              'last_name': contact.user_last_name,
              'email': contact.user_email
            }
          });
        })
      });
      paymentInfo.tickets = tickets;
    }

    paymentInfo.discount_amount = this.discountVal || 0;
    paymentInfo.discount_percentage = this.codeInfo.discount || 0;
    paymentInfo.timezone_offset = new Date().getTimezoneOffset();
    let url = API.MAKE_PAYMENT + "?NOLOADER";
    this.appPaymentService.postRequest(url, { paymentInfo: paymentInfo }).subscribe(result => {
      this.showOverlay = false;
      this.commonSubscribeService.sendPaymentStatus(false);
      if (result.status == 0) {
        this.ticketKey = result.ticket_key;
        this.getMobileUrls(this.ticketKey, paymentInfo.tickets);
        this.storageService.deleteItem('eventInfo');
        this.storageService.deleteItem('isEvent');
        this.storageService.deleteItem('streamInfo');
        try { fbq('track', 'PaymentSuccess'); } catch (e) { }
        if (this.isBookingFrom == "mobile") {
          this.mobilePaymentSuccess();
        } else {
          this.zone.run(() => {
            this.openDialog(result.ticket_key, paymentInfo.tickets);
            let deviceInfo=this.commonSubscribeService.getMobileOperatingSystem();
            if (deviceInfo==='android' || deviceInfo==='ios') {
            history.pushState(null, '');
            fromEvent(window, 'popstate')
              .pipe(takeUntil(this.unsubscriber))
              .subscribe((_) => {
                history.pushState(null, '');
                this.openDialog(result.ticket_key, paymentInfo.tickets);
            });
      }
          });
        }
      } else {
        try { fbq('track', 'PaymentFailed'); } catch (e) { }
        this.toastr.error(result.message);
      }
      this.toggleLoader('none');
    }, error => {
      setTimeout(() => {
        this.showOverlay = false;
      }, 500);
      this.commonSubscribeService.sendPaymentStatus(false);
      this.toggleLoader('none');
      this.toastr.error(error.error);
    });
  }

  showExpo: boolean = false;
  showNetworking: boolean = false;
  showSchedule: boolean = false;
  showStream: boolean = false;
  addOnCheck: boolean = false;
  getMobileUrls(ticket_key, tickets) {
    let id = this.subEvents.length > 0 ? this.subEvents[0].streamid : '';
    let addon = this.selectedTicketsData.filter(a => a.add_ons);
    let ticketsDataLength = tickets.length - addon.length;
    let schedule = tickets.filter(a => (((a.expo == 1 || a.networking.length > 0) && a.sessions.length > 0) || (a.expo == 1 || a.networking.length > 0 || a.sessions.length > 0)) && a.user.email == this.userInfo.email);
    if (schedule.length > 0)
      this.showSchedule = true;
    let stream = tickets.filter(a => a.sessions.length > 0 && a.sessions.includes(this.streamInfo.id) && a.expo == 0 && a.networking.length == 0 && a.user.email == this.userInfo.email);
    if (stream.length > 0 && stream.length == ticketsDataLength)
      this.showStream = true;
    let selectedTickets = tickets.filter(a => a.expo == 1 && a.sessions.length == 0 && a.user.email == this.userInfo.email);
    if ((selectedTickets.length > 0 && (selectedTickets.length == ticketsDataLength)) && (this.expoInfo && this.expoInfo.length > 0))
      this.showExpo = true;
    let checkNetworkTickets = [];
    checkNetworkTickets = tickets.filter(a => a.networking.length > 0 && a.sessions.length == 0 && a.user.email == this.userInfo.email);
    if ((checkNetworkTickets.length > 0 && (checkNetworkTickets.length == ticketsDataLength)) && (this.roomsList && this.roomsList.length > 0))
      this.showNetworking = true;
    let count = selectedTickets.length + checkNetworkTickets.length;
    if ((count == ticketsDataLength) && selectedTickets.length > 0 && checkNetworkTickets.length > 0) {
      this.showExpo = true;
      this.showNetworking = true;
    }
    if (addon.length == this.selectedTicketsData.length) {
      this.selectedTicketsData.forEach(element => {
        tickets.forEach(e => {
          if (e.id == element.id && element.add_ons) {
            this.addOnCheck = true;
            if (this.userSubscriptionInfo && this.userSubscriptionInfo.length > 0 && this.userSubscriptionInfo[0].ticketIDs.length > 0) {
              if (element.add_ons && this.userSubscriptionInfo[0].ticketIDs.includes(element.id))
                this.addOnCheck = true;
              else
                this.addOnCheck = false;
            }
          }
        });
      })
    }
    // let schedule = tickets.filter(a => (((a.expo == 1 || a.networking.length > 0) && a.sessions.length > 0) || (a.expo == 1 || a.networking.length > 0 || a.sessions.length > 0)) && a.user.email == this.userInfo.email);
    // if (schedule.length > 0)
    //   this.showSchedule = true;
    // let stream = tickets.filter(a => a.sessions.length > 0 && a.sessions.includes(this.streamInfo.id) && a.expo == 0 && a.networking.length == 0 && a.user.email == this.userInfo.email);
    // if (stream.length > 0 && stream.length == tickets.length)
    //   this.showStream = true;
    // tickets = tickets.filter(a => a.expo == 1 && a.sessions.length == 0 && a.user.email == this.userInfo.email);
    // if ((tickets.length > 0 && (tickets.length == tickets.length)) && (this.expoInfo && this.expoInfo.length > 0))
    //   this.showExpo = true;
    // let checkNetworkTickets = [];
    // checkNetworkTickets = tickets.filter(a => a.networking.length > 0 && a.sessions.length == 0 && a.user.email == this.userInfo.email);
    // if ((checkNetworkTickets.length > 0 && (checkNetworkTickets.length == tickets.length)) && (this.roomsList && this.roomsList.length > 0))
    //   this.showNetworking = true;
    // let count = tickets.length + checkNetworkTickets.length;
    // if ((count == tickets.length) && tickets.length > 0 && checkNetworkTickets.length > 0) {
    //   this.showExpo = true;
    //   this.showNetworking = true;
    // }
    const base = this.commonSubscribeService.getBasePathFromUrl(this.router.url).slice(1);
    this.scheduleUrl = environment.CONSUMER_PORTAL + `${base}/event/schedule/` + ticket_key;
    this.streamUrl = environment.CONSUMER_PORTAL + `${base}/stream/` + ticket_key + '/stage=' + id;
    this.expoUrl = environment.CONSUMER_PORTAL + `${base}/event/expo-list/` + ticket_key;
    this.networkUrl = environment.CONSUMER_PORTAL + `${base}/event/networking-list/` + ticket_key;
    // this.homeUrl = ticket_key ? environment.CONSUMER_PORTAL + 'event/home/' + this.streamInfo.slug + '/' + ticket_key : environment.CONSUMER_PORTAL + 'event/home/' + this.streamInfo.slug;
    const channel = this.router.url.split('/')[1] + '/event/';
    this.homeUrl = ticket_key
      ? `${environment.CONSUMER_PORTAL}${channel}home/${this.streamInfo.slug}/${ticket_key}`
      : `${environment.CONSUMER_PORTAL}${channel}home/${this.streamInfo.slug}`;

    // this.homeUrl = this.userInfo && (this.userInfo.signedIn || this.userInfo.id) && !this.userInfo.is_guest ? homeUrl : environment.CONSUMER_PORTAL + 'event/' + this.streamInfo.slug;
  }

  mobilePaymentSuccess() {
    this.isMobilePaymentSuccess = true;
    if (this.route.snapshot.queryParams.user_id == 0) {
      let queryParams = JSON.parse(JSON.stringify(this.route.snapshot.queryParams));
      queryParams.user_id = this.userInfo.id;
      this.router.navigate([], {
        relativeTo: this.route,
        queryParams: queryParams,
        queryParamsHandling: 'merge'
      });
    }
  }

  openDialog(ticket_key, tickets): void {
    let data = {
      userInfo: this.userInfo,
      streamInfo: this.streamInfo,
      ticket_key: ticket_key,
      subEvents: this.subEvents,
      expoInfo: this.expoInfo,
      roomsList: this.roomsList,
      ticketsData: tickets,
      selectedTicketsData: this.selectedTicketsData,
      userSubscriptionInfo: this.userSubscriptionInfo && this.userSubscriptionInfo[0] ? this.userSubscriptionInfo[0] : ''
    }
    const dialogRef = this.dialog.open(EventCheckoutDialog, {
      panelClass: 'event-checkout-dialog',
      disableClose: true,
      data: {
        ...data,               
        settingsData: this.settingsData   
      }
    });
    dialogRef.afterClosed().subscribe(result => {

    });
  }

  checkTC(event) {
    if (this.isAgrees) {
        this.checkForm();
    } else {
      this.commonSubscribeService.formsValidationSubject.next(false);
    }
  }

  openEventTermsConditions(isAgrees) {
    if (isAgrees) {
      const dialogRef = this.dialog.open(EventTermsConditionsComponent, {
        // maxWidth:"320px",
        panelClass: "app-event-terms",
        disableClose: true,
        data: this.streamInfo
      });
      dialogRef.afterClosed().subscribe(result => {
      });
    }
  }

  checkState(country) {
    if (country && country.stateless == "yes") {
      this.billingForm.get("state").setValidators([]);
      this.billingForm.get("state").updateValueAndValidity();
      this.shippingForm.get("state").setValidators([]);
      this.shippingForm.get("state").updateValueAndValidity();
    }
  }

  selectCountry(country, formType) {
    // if (country.value.alpha2code != this.currentLocation.country_code2 && formType == 'shippingForm') {
    //   this.toastr.error("Shipping is not available in your region");
    //   this.buildShippingForm();
    //   return;
    // }
    this.countryChanged = false
    this.billingCountry = country.value;
    this.shippingCountry = country.value;
    if (formType == 'shippingForm')
      this.selectedCountry = country.value.alpha2code;
    this.options = {
      types: [],
      componentRestrictions: { country: country.value.alpha2code }
    };
    if (formType == 'billingForm') {
      this.billingForm.patchValue({
        address1: "",
        address2: "",
        city: "",
        state: "",
        // country: "",
        zip: ""
      });
    } else {
      this.shippingForm.patchValue({
        address1: "",
        address2: "",
        city: "",
        state: "",
        // country: "",
        zip: "",
        phone_number: ""
      });
    }
    this.checkState(country.value);
    setTimeout(() => { this.countryChanged = true });
  }

  displayCountryName(option) {
    return option ? option.name : undefined;
  }

  filterCountry(form) {
    this.shippingCountriesList = this.shippingList;
    if (this[form].country) {
      let countriesList = form == "getShippingValue" ? JSON.parse(JSON.stringify(this.shippingCountriesList)) : JSON.parse(JSON.stringify(COUNTRIES_LIST));
      const filterValue = this[form].country.toLowerCase();
      if (form == "getShippingValue") {
        this.shippingCountriesList = countriesList.filter(option => option.name.toLowerCase().indexOf(filterValue) >= 0);
      } else {
        this.countriesList = countriesList.filter(option => option.name.toLowerCase().indexOf(filterValue) >= 0);
      }
    }
  }

  isSelectedTicket = false;
  selectedTicket: any = {};
  onChangeTicket(data) {
    this.currectDatesAmounts.forEach(e => {
      e.isSelectedTicketType = false;
    });
    setTimeout(() => {
      data.isSelectedTicketType = true;
      this.isSelectedTicket = true;
      this.amount = data.current.price;
      this.streamData.amount = data.current.price;
      this.streamData.currency = data.current.currency;
      this.currencyType = data.current.currency;
      this.selectedTicket = data;
      this.currency = data.current.currency;
      this.finalAmount = data.current.price;
      let amount = this.finalAmount ? JSON.parse(this.finalAmount) : 0;
      if (amount) {
        amount = amount.toFixed(2);
      }
    }, 100);
  }

  isCheckUser = false;
  skipQuestions = false;
  checkEmail = false;
  isRegUser = false;
  lastCheckedUserEmail = '';
  checkUser() {

    if (this.profileInfoForm.valid) {
      let inputData = this.profileInfoForm.getRawValue();
      inputData.user_email = inputData.user_email.toLowerCase();
      // A stray (blur) on this top buyer-info form (e.g. from focus shifting while filling in
      // the per-ticket-holder rows below) re-runs this with the SAME already-checked email.
      // continueInfoDetail() -> buildContactInfoForm() unconditionally wipes and rebuilds the
      // whole contactTicketList from scratch when re-triggered, discarding any ticket-holder
      // rows the user already filled in (and scrambling their order/delete-button state) even
      // though nothing about the buyer's info actually changed. Skip the no-op re-check.
      if (this.isCheckUser && inputData.user_email === this.lastCheckedUserEmail) {
        return;
      }
      this.isCheckUser = true;
      this.lastCheckedUserEmail = inputData.user_email;
      // if (this.isLiveTickets) {
      //   this.profileInfoForm.disable();
      //   this.continueInfoDetail();
      //   return;
      // }
      if (this.userInfo && this.userInfo.id && this.userInfo.email == inputData.user_email) {
        // this.profileInfoForm.disable();
        this.commonSubscribeService.userDetailSubject.next(inputData);
        this.continueInfoDetail();
      } else {
        let data = {
          "firstname": inputData.user_first_name,
          "lastname": inputData.user_last_name,
          "email": inputData.user_email.toLowerCase(),
          // "phone": inputData.user_phone_number
          "stream_id": this.streamId,
          "performer_id": this.streamInfo.performer_id,
          "organization_id": this.streamInfo.organization_id
        };
        this.appService.postRequest(API.GET_USER_BY_EMAIL, data).subscribe(result => {
          // if (this.deviceData != 'web')
          //   document.getElementById('app-tickets').scrollIntoView({ behavior: 'smooth' });
          if (result.status == 0) {
            this.commonSubscribeService.userDetailSubject.next(result.user);
            let isBooked = false;
            if (result.tickets && result.tickets.length > 0) {
              this.selectedTicketsData.forEach(e => {
                if (e.sessions) {
                  e.sessions.forEach(e1 => {
                    if (result.tickets.includes(e1)) {
                      isBooked = true;
                    }
                  });
                }
              });
            }

            // if (result.tickets && result.tickets.length > 0 && isBooked) {
            //   const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
            //     panelClass: 'app-signout-confirmation',
            //     disableClose: true,
            //     data: { title: inputData.user_email + " already registered for this stream. Do you want continue?" }
            //   });
            //   dialogRef.afterClosed().subscribe(result1 => {
            //     console.log(result1);
            //     if (result1 == 'yes') {
            //       this.continueInfoDetail(true);
            //       this.userInfo = result.user;
            //       this.commonSubscribeService.userInfo = this.userInfo;
            //     }
            //   });
            // } else {
            if (result.user.is_guest == 1) {
              this.userInfo = result.user;
              result.user.deviceInfo=this.deviceInfo
              // if (!this.isUserInfoForm)
              this.continueInfoDetail();
              this.commonSubscribeService.userInfo = this.userInfo;
              if (this.userInfo && this.userInfo.is_guest) {
                this.showBillingForm = true;
              }
              result.user.settingsData = this.settingsData;
              // alert(JSON.stringify(this.userInfo));
              // this.profileInfoForm.disable();
              const dialogRef = this.dialog.open(UserAccountDialog, {
                panelClass: 'app-signout-confirmation',
                disableClose: true,
                data: result.user,
              });
              dialogRef.afterClosed().subscribe(result => {
                if(result == "no"){
                   this.commonSubscribeService.sendGuestInfo(true);
                } else {
                  this.commonSubscribeService.sendGuestInfo(false);
                }
              });
            } else {
              this.userInfo = result.user;
              if (this.isRegUser) {
                this.userInfo = result.user;
                // if (!this.isUserInfoForm)
                this.continueInfoDetail();
                this.commonSubscribeService.userInfo = this.userInfo;
                this.storageService.deleteItem("signInEmail");
                this.storageService.deleteItem("skipRedirection");
              } else {
                this.isRegUser = true;
                this.storageService.setItem('signInEmail', result.user.email);
                this.storageService.setItem('skipRedirection', 'yes');
                const dialogRef = this.dialog.open(ConsumerSignInComponent, {
                  maxWidth: "400px",
                  panelClass: "app-consumer-sign-in",
                  disableClose: true,
                  data: {}
                });
                dialogRef.afterClosed().subscribe(result => {
                  this.checkEmail = true;
                  if (result == "success") {
                    this.userInfo = this.commonSubscribeService.userInfo;
                    // this.profileInfoForm.disable();
                    // if (!this.isUserInfoForm)
                    this.continueInfoDetail();
                  } else {
                    // this.userInfo = result.user;
                    this.continueInfoDetail();
                    this.commonSubscribeService.userInfo = this.userInfo;
                    // this.toastr.error('Sign in is mandatory or change email to continue');
                  }
                });
                this.toastr.error("Account already exists. Sign in to continue");
                setTimeout(() => {
                  this.storageService.deleteItem('signInEmail');
                }, 1000);
              }
            }
            // }
          }
        }, error => {
          console.log(error);
          this.isUserInfoForm = false;
          if (error.error && error.error.name) {
            // this.toastr.error(error.error.name);
            this.toastr.error("Email used in another environment. Please use a different email address.");
          } else {
            this.toastr.error(error.error.message,);
          }
        });
      }
    }
  }

  continueInfoDetail(isBooked?) {

    // if (this.streamInfo.stream_payment_mode == 'paid') {
    if (this.selectedTicketsData.length == 1) {
      try {
        fbq('track', 'Initiate Checkout', {
          value: this.amountWithBF,
          currency: this.currency
        });
      } catch (e) { }
      this.buildContactInfoForm(true,'',isBooked);
    }
    else
      this.buildContactInfoForm('','',isBooked);
    // } else {
    //   this.hasUserInfo = true;
    //   this.getQuestionsByEventId();
    // }

    // let mData = {"streamId" : this.streamId,"ticket_ids" : [],"user_id" : this.userInfo.id , token:this.userInfo.access_token };
    // this.selectedTicketsData.forEach(e => {
    //   mData.ticket_ids.push(e.id)
    // });
    // console.log("use from mobile url",  `${environment.CONSUMER_PORTAL}payment/pay_per_view?stream_id=${mData.streamId}&ticket_ids=${mData.ticket_ids.toString()}&user_id=${mData.user_id}&noofticket=${this.noOfTicket}&token=${mData.token}`);
  }

  get userList() {
    return this.contactInfoForm.getRawValue();;
  }

  checkTicketName(event, pIndex, cIndex) {
    let listData = this.contactInfoForm.getRawValue().contactTicketList;
    let isLimitExceeded = false;
    let contactArray = [], selectedOption, ticketId;
    listData.forEach(element => {
      if (element.ticket_id == event.value) {
        selectedOption = element.ticket_detail.selectedOption;
        ticketId = element.ticket_id;
      }
      element.contactList.forEach(contact => {
        contactArray.push(contact);
      });
    })
    let count = 0;
    if (contactArray && contactArray.length > 0) {
      contactArray.forEach(element => {
        if (element.ticket_id == ticketId) {
          count++;
          if (count > Number(selectedOption) && (ticketId == event.value))
            isLimitExceeded = true;
        }
      });
    }
    if (isLimitExceeded) {
      this.toastr.error(`You can select only ${selectedOption} ticket(s)`);
      this.contactList(pIndex)[cIndex].patchValue({
        ticket_id: ""
      });
    }
    this.validateUniqueEmails();
  }

  requireLogin() {
    this.storageService.setItem('skipRedirection', 'yes');
    const dialogRef = this.dialog.open(ConsumerSignInComponent, {
      maxWidth: "400px",
      panelClass: "app-consumer-sign-in",
      disableClose: true,
      data: {}
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result == "success") {
        this.userInfo = this.commonSubscribeService.userInfo;
      }
    });
  }
  isSubmitedUserInfo: boolean = false;
  userPanelOpenState = false;
  uniqueUserList: any;
  isUserInfoForm: boolean = false;
  saveOtherUserTicket(from?) {
    this.isUserInfoForm = true;
    this.validateUniqueEmails();
    if (this.contactInfoForm.valid) {
      this.billingForm.enable();
      if (this.showShippingForm)
        this.shippingForm.enable();
      let userList = [];
      let userBookedList = [];
      let resCount = 0;
      let listData = this.contactInfoForm.getRawValue().contactTicketList;
      let contactArray = [];
      listData.forEach((element, parentIdx) => {
        element.contactList.forEach(contact => {
          // Remembers which ticket-type group this row currently lives under, so a row whose
          // Ticket Name hasn't been picked yet (ticket_id still "") isn't dropped below when no
          // group's ticket_id matches it - it stays in its own slot instead of visually jumping
          // to whichever group happens to end up first once a *different* row picks a ticket.
          contactArray.push({ ...contact, __originalGroupIndex: parentIdx });
        });
      })
      let formData1 = this.contactInfoForm.getRawValue();
      formData1.contactTicketList.forEach((e1, groupIdx) => {
        e1.contactList = [];
        contactArray.forEach(ele => {
          const matchesTicketType = ele.ticket_id == e1.ticket_id;
          const notYetAssigned = !ele.ticket_id && ele.__originalGroupIndex === groupIdx;
          if (matchesTicketType || notYetAssigned) {
            const { __originalGroupIndex, ...contact } = ele;
            e1.contactList.push(contact);
          }
        });
      });
      this.buildContactInfoForm('', formData1);
      let formData = this.contactInfoForm.getRawValue();
      if (formData && formData.contactTicketList) {
        formData.contactTicketList.forEach((e1, parentIndex) => {
          e1.contactList.forEach((e2, childIndex) => {
            e2.parentIndex = parentIndex;
            e2.childIndex = childIndex;
            e2.ticket_id = e1.ticket_id;
            userList.push(e2);
          });
        });
      }
      this.uniqueUserList = [...new Map(userList.map(user =>
        [user['user_id'], user])).values()];
      userList.forEach((element, id) => {
        this.checkOtherUsers(element, id).then((data: any) => {
          if (data && data.result) {

            element.user_id = data.result.user.id;

            let ticketPrice = this.selectedTicketsData.filter(d => d.id == element.ticket_id);
            // if (ticketPrice && ticketPrice[0] && ticketPrice[0].amounts && ticketPrice[0].amounts.length > 0) {
            //   let isFountCurrency = false;
            //   ticketPrice[0].amounts.forEach(e => {
            //     if (this.currentLocation.currency.code == e.currency_type) {
            //       isFountCurrency = true;
            //       // e.subscriber = e.subscriber + ((e.subscriber *3)/100);
            //       // e.non_subscriber = e.non_subscriber + ((e.non_subscriber *3)/100);
            //       if (data.result.subscription_status) {
            //         element.price = e.subscriber;
            //       } else {
            //         element.price = e.non_subscriber;
            //       }
            //       // element.price_with_bf = element.price + ((element.price *3)/100);
            //     }
            //   });
            //   if (!isFountCurrency) {
            //     // ticketPrice[0].amounts[0].subscriber = ticketPrice[0].amounts[0].subscriber + ((ticketPrice[0].amounts[0].subscriber *3)/100);
            //     // ticketPrice[0].amounts[0].non_subscriber = ticketPrice[0].amounts[0].non_subscriber + ((ticketPrice[0].amounts[0].non_subscriber *3)/100);
            //     if (data.result.subscription_status) {
            //       element.price = ticketPrice[0].amounts[0].subscriber;
            //     } else {
            //       element.price = ticketPrice[0].amounts[0].non_subscriber;
            //     }

            //   }
            //   element.price_with_bf = ticketPrice[0].price_bf;
            // }
            if (data.result.subscription_status) {
              element.price = ticketPrice[0].subscriber_price;
            } else {
              element.price = ticketPrice[0].non_subscriber_price;
            }
            element.price_with_bf = ticketPrice[0].price_bf;
            let isBooked = false;
            if (data.result.tickets && data.result.tickets.length > 0) {
              this.selectedTicketsData.forEach(e => {
                if (e.sessions) {
                  e.sessions.forEach(e1 => {
                    if (data.result.tickets.includes(e1)) {
                      isBooked = true;
                    }
                  });
                }
              });
            }

            if (data.result.tickets && data.result.tickets.length > 0 && isBooked) {
              userBookedList.push(element.user_email);
            }
          }
          resCount++;
          // if (resCount == userList.length && userBookedList.length != 0) {
          //   const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
          //     panelClass: 'app-signout-confirmation',
          //     disableClose: true,
          //     data: { title: "Already booked stream ticket for these users " + userBookedList.toString() + "", isClose: true }
          //   });
          //   dialogRef.afterClosed().subscribe(result => {
          //     // this.hasUserInfo = false;
          //   });
          // }
          if (resCount == userList.length) {
            // this.hasUserInfo = true;
            this.updateUserIdInList(userList);

          }
        }).catch(error => {
        });
      });
      // if (this.deviceData != 'web')
      //   document.getElementById('app-tickets').scrollIntoView({ behavior: 'smooth' });
    }
    // else {
    //   this.commonSubscribeService.scrollToError();
    //   this.commonSubscribeService.markFormGroupTouched(this.contactInfoForm);
    //   // this.toastr.error("Please fill all users information.");
    // }
  }

  getRegUsersData: any = [];
  getNonRegTicketData: any = [];
  bookingFee = 0;
  updateUserIdInList(userList) {
    let checkRegUsers = [];
    if (this.userResponse && this.userResponse.length > 0) {
      let inputData = this.profileInfoForm.getRawValue();
      inputData.user_email = inputData.user_email.toLowerCase();
      this.userResponse.forEach(res => {
        if (inputData.user_email == res.user.email)
          checkRegUsers.push(res);
      })
    }
    // if (checkRegUsers && checkRegUsers.length == 0) {
    //   this.skipQuestions = true;
    //   this.initateCardDetails();
    //   console.log('uniq');
    // } else if (checkRegUsers && checkRegUsers.length > 0) {
    this.bookingFee = 0; this.finalAmount = 0, this.streamData.amount = 0, this.amount = 0, this.withoutAddOn = 0;
    checkRegUsers.forEach(result => {
      this.selectedTicketsData.forEach(e => {
        // result.ticketIDs = [579, 560];
        // if (e.sessions) {
        //   e.sessions.forEach(e1 => {
        if (result.ticketIDs && result.ticketIDs.includes(e.id)) {
          this.getRegUsersData.push(result);
        } else {
          // result.ticket_id = e.id;
          this.getNonRegTicketData.push(result);
        }
        //   });
        // }
      });
    })
    // }
    this.getRegUsersData = [...new Map(this.getRegUsersData.map(item =>
      [item['user']['id'], item])).values()];
    this.getNonRegTicketData = [...new Map(this.getNonRegTicketData.map(item =>
      [item['user']['id'], item])).values()];
    this.amount = 0;
    userList.forEach(e => {
      this.contactList(e.parentIndex)[e.childIndex].patchValue({
        id: e.user_id
      });
      e.price = e.price ? e.price : 0;
      e.price_with_bf = e.price_with_bf ? e.price_with_bf : 0;
      this.amount += e.price;
      this.streamData.amount = this.amount = Number(this.amount.toFixed(2));
    });
    let isFree = [];
    isFree = this.selectedTicketsData.filter(a => a.ticket_type == 'free');

    let amount = parseFloat(this.finalAmount);
    // this.finalAmount = amount += this.bookingFee;
    this.selectedTicketsData.forEach(e => {
      e.price = 0;
      userList.forEach(e1 => {
        if (e.id == e1.ticket_id) {
          e.price += e1.price;
          if (!e.add_ons) {
            this.withoutAddOn += e1.price;
            this.withoutAddOn = Number(this.withoutAddOn.toFixed(2));
          }
        }
      });
      // Each attendee is priced by their own subscription status, so this sum can differ from
      // selectedOption * org_price (the buyer's price). The order summary shows line_total so
      // its line items add up to the subtotal that is actually charged.
      e.line_total = e.price;
    });
    // this.totalAddOnAmount = this.amount - this.withoutAddOn;
    if (this.streamInfo.booking_fee != 0 && isFree.length != this.selectedTicketsData.length) {
      this.bookingFee = this.fee * this.withoutAddOn;
      // if(this.paidAddOnTickets.length > 0)
      //   this.bookingFee = this.bookingFee + (this.totalAddOnAmount * (2.9 / 100)) + 0.3;
      this.bookingFee = Number(this.bookingFee.toFixed(2));
    }
    this.amountWithBF = this.amount + this.bookingFee + this.shippingCost;
    let amt = this.amountWithBF + this.taxAmount;
    this.finalAmount = this.amountWithBF + this.taxAmount;
    if (this.settingsJSON && this.settingsJSON.fee_to_fan == 1) {
      this.addOnAmount = this.orgAmount - this.withoutAddOn;
      this.processingFee = (amt * (environment.processing_fee / 100)) + environment.fee_percentage;
      this.processingFee = Number(this.processingFee.toFixed(2));
    }
    // let fees = this.settingsJSON && this.settingsJSON.fee_to_fan == 1 ? this.processingFee : 0;
    let fees = this.settingsJSON && this.settingsJSON.fee_to_fan == 1 && this.selectedTransaction =='ott'? this.processingFee : 0;
    this.finalAmount = this.amountWithBF + fees + this.taxAmount;
    this.finalAmount = Number(this.finalAmount.toFixed(2));
    if ((this.getRegUsersData.length > 0 || (checkRegUsers && checkRegUsers.length == 0))) {
      this.skipQuestions = true;
      this.hasUserInfo = true;
      this.questionsData = false;
    }
    if (this.isDiscountApplied)
      this.finalAmounts(this.discountInfo, 'promocode')
    this.getQuestionsByEventId();
    this.isSubmitedUserInfo = true;
    this.hasUserInfo = true;
    // if (Object.keys(this.route.snapshot.queryParams).length > 0 && this.route.snapshot.queryParams.ref) {
    //   this.labelText = 'Enter referal code';
    //   this.promoCode = this.route.snapshot.queryParams.ref;
    //   this.verifyCode("referralcode");
    // } else {
    this.labelText = 'Enter promo code';
    // }

  }

  userResponse = [];
  index = 0;
  checkOtherUsers(userDetail, index) {
    // if(this.userResponse && this.userResponse)
    return new Promise((resolve, reject) => {
      // if(this.uniqueUserList && this.uniqueUserList.length >0 && this.userResponse && this.userResponse.length > 0){
      //   this.uniqueUserList.forEach(element => {
      //     if(element.user_email == userDetail.user_email){

      //     }
      //   });
      // }
      let data = {
        "firstname": userDetail.user_first_name,
        "lastname": userDetail.user_last_name,
        "email": userDetail.user_email.toLowerCase(),
        "stream_id": this.streamId,
        "performer_id": this.streamInfo.performer_id,
        "organization_id": this.streamInfo.organization_id
      };
      this.appService.postRequest(API.GET_USER_BY_EMAIL, data).subscribe(result => {
        if (result.status == 0) {
          this.userResponse.push(result);
          let res = {
            result: result,
            index: index
          }
          resolve(res);
        }
      }, error => {
        if (error.error && error.error.name) {
          // console.log(this.contactInfoForm.value);
          // this.toastr.error(error.error.name);
          this.toastr.error("Email used in another environment. Please use a different email address.");
        } else {
          this.toastr.error("Server error");
        }
        reject(error)
      });
    });
  }

  validateUniqueEmails() {
    let rowsByTicket = new Map<string, any[]>();
    this.contactTicketList.controls.forEach((_, i) => {
      (this.contactList(i) as any).forEach((row: any) => {
        let ticketId = row.get('ticket_id').value;
        if (!ticketId) return;
        if (!rowsByTicket.has(ticketId)) rowsByTicket.set(ticketId, []);
        rowsByTicket.get(ticketId).push(row);
      });
    });
    let duplicateFound = false;
    rowsByTicket.forEach(rows => {
      rows.forEach(row => {
        let emailCtrl = row.get('user_email');
        let email = emailCtrl.value;
        let isDuplicate = !!email && rows.filter(r => r.get('user_email').value == email).length > 1;
        if (isDuplicate) duplicateFound = true;
        let errors = { ...(emailCtrl.errors || {}) };
        delete errors.duplicateEmail;
        if (isDuplicate) errors.duplicateEmail = true;
        emailCtrl.setErrors(Object.keys(errors).length ? errors : null);
      });
    });
    if (duplicateFound) {
      this.toastr.error("Please give unique email");
    }
  }

  hasDuplicateEmailError(): boolean {
    return this.contactTicketList.controls.some((_, i) =>
      (this.contactList(i) as any).some((row: any) => row.get('user_email').hasError('duplicateEmail'))
    );
  }


  getExpoList() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_EXPO_LIST + '/' + this.streamInfo.id;
    this.loader.start();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        this.loader.stop();
        this.expoInfo = response.data.Data;

      }
    }).catch(error => {
      this.loader.stop();
    });
  }

  roomsList: any = [];
  getNetworkRoomsList() {
    let data = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: {}
    }
    let url = CONST_AWS_API.GET_ROOMS_LIST + '/' + this.streamInfo.id;
    this.loader.start();
    AWS_API.get(environment.AWS_Cognito.apiName, url, data).then(response => {
      if (response.data.statusCode === '200') {
        this.loader.stop();
        if (response.data.Data) {
          this.roomsList = response.data.Data;
        }
      }
    }).catch(error => {
      this.loader.stop();
    });

  }

  redirectTo() {
    let device = this.commonSubscribeService.getMobileOperatingSystem();
    this.commonSubscribeService.sendDeviceType(device);
    const channelName = this.router.url.split('/')[1];
    const segment2 = this.router.url.split('/')[2];
    const groupSlug = segment2 && !['event', 'channel', 'stream', 'watch', 'album', 'subscription-list'].includes(segment2) ? segment2 : '';
    const base = groupSlug ? `/${channelName}/${groupSlug}` : `/${channelName}`;
    if ((this.subEvents && this.subEvents.length > 1) || (this.expoInfo && this.expoInfo.length > 0) || (this.roomsList && this.roomsList.length > 0))
      this.router.navigateByUrl(`${base}/event/schedule/${this.ticketKey}`);
    else
      this.router.navigate([`${base}/stream/` + this.ticketKey], { queryParams: { stage: this.subEvents[0].streamid } });
  }

  newCard() {
    this.addNewCard = true;
    this.selectedCard = {};
    if (this.addressList.billingAddress.length == 0)
      this.showBillingForm = true;
    this.commonSubscribeService.selectedCardSubject.next(false);
  }

  addStyle(){
    //mat-select-dropdown
    document.documentElement.style.setProperty('--select-panel-bg', this.settingsData?.event_button_bg_primary_color);
    document.documentElement.style.setProperty('--select-panel-text', this.settingsData?.event_button_font_primary_color);
    document.documentElement.style.setProperty('--select-panel-text-color', this.settingsData?.event_button_font_primary_color);
    document.documentElement.style.setProperty('--select-panel-text-hover', this.settingsData?.event_button_font_primary_color);
    //dropdown selected value
    document.documentElement.style.setProperty('--select-value-text', this.settingsData?.event_font_primary_color);
  }

  preventInvalidSpaces(event: KeyboardEvent) {
    if (event.key === ' ') {
      event.preventDefault();
    }
  }
  
  onCouponInput(value: string) {
    this.promoCode = value.replace(/\s+/g, '').toUpperCase();
  }
  
  onCouponPaste(event: ClipboardEvent) {
    event.preventDefault();
    const pasted = event.clipboardData?.getData('text') ?? '';
    this.promoCode = pasted
      .replace(/\s+/g, '')
      .toUpperCase();
  }

  ngOnDestroy() {
    this.card = '';
    if (this.userInfoSubscription)
      this.userInfoSubscription.unsubscribe();
    if (this.currencyInfoSubscription)
      this.currencyInfoSubscription.unsubscribe();
    this.storageService.deleteItem('vodUrl');
    if (this.selectedCardInfoSubscr) {
      this.selectedCardInfoSubscr.unsubscribe();
    }
    if (this.addressListInfoSubscr) {
      this.addressListInfoSubscr.unsubscribe();
    }
    if (this.savedCardsListSubscr) {
      this.savedCardsListSubscr.unsubscribe();
    }
    if (this.transactionInfoSubscr) {
      this.transactionInfoSubscr.unsubscribe();
    }
    if(this.totalAmount){
      this.totalAmount.unsubscribe();
    }
    if (this.settingsDataSubscription)
      this.settingsDataSubscription.unsubscribe();
    this.performerInfoSubscription?.unsubscribe();
  }

}

@Component({
  selector: 'app-event-checkout-dialog',
  templateUrl: './event-checkout-dialog.html',
  styleUrls: ['./event-tickets.component.scss']
})
export class EventCheckoutDialog implements OnInit {
  userInfo: any;
  streamInfo: any;
  eventType: any;
  ticket_key: any;
  deviceInfo: any;
  content: string = 'live';
  subEvents: any;
  expoInfo: any;
  isLiveTickets: any;
  roomsList: any;
  selectedTickets: any = [];
  showExpo: boolean = false;
  showNetworking: boolean = false;
  showSchedule: boolean = false;
  showStream: boolean = false;
  selectedTicketsData = [];
  addOnCheck: boolean = false;
  userSubscriptionInfo: any;
  vodUrl: any;
  assets_url = environment.assets_url;
  clientDetails: any;
  cryptoToken: any;
  cryptoSymbol: any;
  settingsData: any;

  ngOnInit(): void {
    this.clientDetails = environment.clientDetails;
    this.cryptoToken = this.clientDetails.crypto_token;
    this.cryptoSymbol = this.clientDetails.crypto_symbol;
  }

  constructor(private router: Router,
    private route: ActivatedRoute,
    public dialogRef: MatDialogRef<EventCheckoutDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private storageService: StorageService,
    private toastr: ToastrService,
    private userService: UserService,
    private commonSubscribeService: CommanSubscribeService) {
    
    let device = this.commonSubscribeService.getMobileOperatingSystem();
    this.deviceInfo = device;
    if(this.data.streamInfo===undefined ){
      this.userInfo = data.userInfo;
    }else{
    this.userInfo = data.userInfo;
    this.streamInfo = data.streamInfo;
    this.ticket_key = data.ticket_key;
    this.subEvents = data.subEvents;
    this.expoInfo = data.expoInfo;
    this.isLiveTickets = data.liveTickets;
    this.roomsList = data.roomsList;
    this.selectedTicketsData = data.selectedTicketsData;
    this.userSubscriptionInfo = data.userSubscriptionInfo;
    this.vodUrl = this.storageService.getItem('vodUrl');
    this.settingsData = data.settingsData;
    // this.selectedTickets = data.ticketsData;
    let addon = this.selectedTicketsData.filter(a => a.add_ons);
    let ticketsDataLength = data.ticketsData.length - addon.length;
    let schedule = data.ticketsData.filter(a => (((a.expo == 1 || a.networking.length > 0) && a.sessions.length > 0) || (a.expo == 1 || a.networking.length > 0 || a.sessions.length > 0)) && a.user.email == this.userInfo.email);
    if (schedule.length > 0)
      this.showSchedule = true;
    let stream = data.ticketsData.filter(a => a.sessions.length > 0 && a.sessions.includes(this.streamInfo.id) && a.expo == 0 && a.networking.length == 0 && a.user.email == this.userInfo.email);
    if (stream.length > 0 && stream.length == ticketsDataLength)
      this.showStream = true;
    this.selectedTickets = data.ticketsData.filter(a => a.expo == 1 && a.sessions.length == 0 && a.user.email == this.userInfo.email);
    if ((this.selectedTickets.length > 0 && (this.selectedTickets.length == ticketsDataLength)) && (this.expoInfo && this.expoInfo.length > 0))
      this.showExpo = true;
    let checkNetworkTickets = [];
    checkNetworkTickets = data.ticketsData.filter(a => a.networking.length > 0 && a.sessions.length == 0 && a.user.email == this.userInfo.email);
    if ((checkNetworkTickets.length > 0 && (checkNetworkTickets.length == ticketsDataLength)) && (this.roomsList && this.roomsList.length > 0))
      this.showNetworking = true;
    let count = this.selectedTickets.length + checkNetworkTickets.length;
    if ((count == ticketsDataLength) && this.selectedTickets.length > 0 && checkNetworkTickets.length > 0) {
      this.showExpo = true;
      this.showNetworking = true;
    }


    if (addon.length == this.selectedTicketsData.length) {
      this.selectedTicketsData.forEach(element => {
        data.ticketsData.forEach(e => {
          if (e.id == element.id && element.add_ons) {
            this.addOnCheck = true;
            if (this.userSubscriptionInfo.length > 0 && this.userSubscriptionInfo.ticketIDs.length > 0) {
              if (element.add_ons && this.userSubscriptionInfo.ticketIDs.includes(element.id))
                this.addOnCheck = true;
              else
                this.addOnCheck = false;
            }
          }
        });
      })
    }
    // if(this.showSchedule  || this.showStream || this.showExpo || this.showNetworking )
    //   this.addOnCheck = false;
    // else
    //   this.addOnCheck = true;
    // this.eventType = this.storageService.getItem('isEvent');
    // if (this.eventType == 'vod' || this.streamInfo.stream_status == 'completed')
    //   this.content = 'video';
    // else
    //   this.content = 'live';
    this.storageService.setItem('ticket_key', this.ticket_key);
    this.userService.setTicketStatus(true);
    try { fbq('track', 'Purchase'); } catch (e) { }
  }
  }
  goToHome(): void {
    // if (this.userInfo && (this.userInfo.signedIn || this.userInfo.id) && !this.userInfo.is_guest) {
    //   this.router.navigateByUrl('/userhome');
    // } else {
    //   this.router.navigateByUrl('');
    // }
    // let homeUrl = this.ticket_key ? 'event/home/' + this.streamInfo.slug + '/' + this.ticket_key : 'event/' + this.streamInfo.slug;
    const channelName = this.router.url.split('/')[1];
    const basePath = this.commonSubscribeService.getChannelBasePath(channelName);
    const prefix = basePath + '/event/';
    let homeUrl = this.ticket_key ? `${prefix}home/${this.streamInfo.slug}/${this.ticket_key}` : `${prefix}${this.streamInfo.slug}`;
    console.log("prefix",prefix,"homeURL",homeUrl)
    if (Object.keys(this.route.snapshot.queryParams).length > 0) {
      this.router.navigate([homeUrl], { queryParams: { ref: this.route.snapshot.queryParams.ref } }).then(() => {
        window.location.reload();
      });
    } else {
      this.router.navigate([homeUrl]).then(() => {
        window.location.reload();
      });
    }
    this.dialogRef.close();
  }

  goToExpo() {
    this.router.navigateByUrl(`${this.streamInfo?.channel_name}/event/expo-list/${this.ticket_key}`);
    this.dialogRef.close();
  }

  goToNetworking() {
    this.router.navigateByUrl(`${this.streamInfo?.channel_name}/event/networking-list/${this.ticket_key}`);
    this.dialogRef.close();
  }

  goToStream() {
    // if (this.streamInfo && this.streamInfo.number_of_creators == 1)
    this.router.navigateByUrl(`stream/${this.ticket_key}`);
    // else
    //   this.router.navigateByUrl(`group-stream/${this.streamInfo.id}`);
    this.dialogRef.close();
  }
  goToSchedule() {
    // let id = this.streamInfo.id + '-'+this.userInfo.id + '-' + this.ticket_key;
    if ((this.subEvents && this.subEvents.length > 1) || !this.showStream) {
      this.router.navigateByUrl(`${this.streamInfo?.channel_name}/event/schedule/${this.ticket_key}`);
    } else {
      if (this.subEvents && (this.subEvents[0].stream_status == 'completed' && this.subEvents[0].conversion_status == 'completed'))
        this.router.navigate([`${this.streamInfo?.channel_name}/watch/` + this.ticket_key], { queryParams: { stage: this.subEvents[0].streamid } });
      else
        this.router.navigate([`${this.streamInfo?.channel_name}/stream/` + this.ticket_key], { queryParams: { stage: this.subEvents[0].streamid } });
    }
    this.dialogRef.close();
  }

  goToVOD() {
    this.streamInfo['allow_vod'] = (this.streamInfo['allow_vod'] && this.streamInfo['allow_vod'] == 1) ? true : true;
    if (this.streamInfo['allow_vod'])
      this.router.navigateByUrl(`${this.streamInfo?.channel_name}/watch/${this.ticket_key}`);
    else if (!this.streamInfo['allow_vod'])
      this.toastr.error('Video recording is not available');
    this.dialogRef.close();
  }

  goToChannelVod() {
    this.router.navigateByUrl(`${this.vodUrl}`);
    this.dialogRef.close();
  }

  ngOnDestroy() {
    this.storageService.deleteItem('streamInfo');
    this.storageService.deleteItem('isEvent');
    this.storageService.deleteItem('vodUrl');
  }

}


@Component({
  selector: 'app-user-account-dialog',
  templateUrl: './user-account.html',
  styleUrls: ['./user-account-dialog.scss']
})
export class UserAccountDialog {
  userInfo: any;
  streamInfo: any;
  eventType: any;
  message: any;
  messageStatus:boolean=false;
  settingsData: any = {};
  constructor(public dialogRef: MatDialogRef<UserAccountDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private dialog: MatDialog,
    private commonSubscribeService: CommanSubscribeService) {
    this.userInfo = this.commonSubscribeService.userInfo;
    this.settingsData = data.settingsData;
    if(data.deviceInfo=='android' || data.deviceInfo=='ios'){
      this.continue('yes')
      this.messageStatus=true
    }
  }

  continue(status) {
    if (status == 'yes') {
      this.appService.postRequest(API.SEND_PASSWORD, { user_id: this.userInfo.id, organization_id: this.commonSubscribeService.streamInfo?.organization_id }).subscribe((result: any) => {
        this.message = result.message;
      }, error => {
        console.log(error);
      });
    } else {
      this.dialogRef.close(status);
    }
  }
  close() {
    this.dialogRef.close();
    if (this.message) {
      const dialogRef = this.dialog.open(ConsumerSignInComponent, {
        maxWidth: "400px",
        panelClass: "app-consumer-sign-in",
        disableClose: true,
        // A fan who chose "create an account" already has a password emailed to them — closing
        // this dialog and continuing as a guest would silently skip signing into the account
        // that was just created for them, so the dialog's own close (X) button is suppressed too.
        data: { forceSignIn: true }
      });
      dialogRef.afterClosed().subscribe(result => {
        this.userInfo.close_modal = true;
        this.commonSubscribeService.sendGuestInfo(false);
        this.commonSubscribeService.userDetailSubject.next(this.userInfo);
      });
    }
  }
}
